const moment = require('moment-timezone');
import axios from 'axios';
import { createI18n } from '@/i18n';
import Vue from 'vue';

const i18n = createI18n();

export default {
    install(Vue, store) {

        const rosterhelper = new RosterHelper(store);
        Vue.rosterhelper = rosterhelper;
        Vue.prototype.$rosterhelper = rosterhelper;
    }
}

class RosterHelper {
    constructor(store) {
        this.store = store;
    }

    isBlank(str) {
        if (typeof str === 'boolean' || this.isInt(str)) {
            return false;
        } else {
            return (!str || /^\s*$/.test(str))
        }
    }

    isInt(value) {
        var x;
        if (isNaN(value)) {
            return false;
        }
        x = parseFloat(value);
        return (x | 0) === x;
    }

    getMoment() {
        return moment().locale('de');
    }

    getMomentUTC() {
        return moment.utc().locale('de');
    }

    getMomentTZ() {
        if (this.store.state.storeSettings.timeZone) {
            //console.log("timezone");
            return moment.tz(this.store.state.storeSettings.timeZone).locale('de');
        }
        return this.getMoment();
    }

    getMomentFromString(str, format = 'YYYY-MM-DDTHH:mmZ') {
        return moment(str, format).locale('de');
    }

    getMomentFromStringUTC(str, format = 'YYYY-MM-DDTHH:mmZ') {
        return moment.utc(str, format).locale('de');
    }

    getMomentFromStringTZ(str, format = 'YYYY-MM-DDTHH:mmZ') {
        if (this.store.state.storeSettings.timeZone) {
            return moment.tz(str, format, this.store.state.storeSettings.timeZone).locale('de');
        }
        return this.getMomentFromString(str, format);
    }

    GetFromToCheckObject(from, to, lower, upper) {
        let resultFrom = from < lower ? lower : (from > upper ? upper : from);
        let resultTo = to > upper ? upper : (to < lower ? lower : to);
        let result = {
            isNonZeroDiff: (Math.max(0, resultTo.diff(resultFrom))) > 0,
            from: resultFrom,
            to: resultTo
        };

        return result;
    }

    getFromToMomentMap(map) {
        let momentMap = {};

        Object.values(map).forEach(entry => {
            let momentEntry = momentMap[entry.id] ? momentMap[entry.id] : {};
            momentEntry.data = entry;

            if (momentEntry.from != entry.from) {
                momentEntry.from = entry.from;
                momentEntry.fromDate = entry.from ? this.getMomentFromStringTZ(entry.from) : null;
            }
            if (momentEntry.to != entry.to) {
                momentEntry.to = entry.to;
                momentEntry.toDate = entry.to ? this.getMomentFromStringTZ(entry.to) : null;
            }
            momentMap[entry.id] = momentEntry;
        });
        return momentMap;
    }

    calculateMomentMapEntry(momentMap, entry){
        let momentEntry = momentMap[entry.id] ? momentMap[entry.id] : {};
        momentEntry.data = entry;

        if (momentEntry.from != entry.from) {
            momentEntry.from = entry.from;
            momentEntry.fromDate = entry.from ? this.getMomentFromStringTZ(entry.from) : null;
        }
        if (momentEntry.to != entry.to) {
            momentEntry.to = entry.to;
            momentEntry.toDate = entry.to ? this.getMomentFromStringTZ(entry.to) : null;
        }
        momentMap[entry.id] = momentEntry;
    }



    getEmployeeEmployeeSkillMap(employeeSkillMap) {
        let employeeEmployeeSkillMap = {};
        Object.values(employeeSkillMap).forEach(eSkill => {
            if (!employeeEmployeeSkillMap[eSkill.employeeId]) {
                employeeEmployeeSkillMap[eSkill.employeeId] = [];
            }
            employeeEmployeeSkillMap[eSkill.employeeId].push(eSkill);
        });
        return employeeEmployeeSkillMap;
    }

    getEmployeeIdContractMap(employeeContractMap) {
        let employeeIdContractMap = {};

        Object.values(employeeContractMap).forEach(c => {

            if (c.employeeId) {
                if (!employeeIdContractMap[c.employeeId]) employeeIdContractMap[c.employeeId] = [];
                employeeIdContractMap[c.employeeId].push(c);
            }
        });
        return employeeIdContractMap;
    }




    getCustomSpotMapWithoutPriority(spotMap, businessUnitMap) {
        let data = Object.values(spotMap);

        let i;
        let tspots = {}
        for (i = 0; i < data.length; i++) {
            let priority = 0; // priority not checked here, is always 0

            tspots[data[i].id] = data[i];
            //Each spot has a required business unit, since we drop spots to employeeGroups, we add the businessUnit now to the spot
            for (let j in businessUnitMap) {
                if (data[i].unitId == businessUnitMap[j].id) {
                    tspots[data[i].id].bunit = businessUnitMap[j];
                }
            }
            tspots[data[i].id].toggled = false;
            tspots[data[i].id].userPriority = priority;
            data[i].label = data[i].name
        }
        return tspots;
    }

    getEmployeePreferenceAvailabilityMap(employeeMap, employeePreferenceMap, employeePreferenceMomentMap, employeeAvailabilityMap, rosterFromTo) {
        let map = {};
        let unapproved = {};

        let rosterFrom = this.getMomentFromStringTZ(rosterFromTo.from);
        let rosterTo = this.getMomentFromStringTZ(rosterFromTo.to);


        let today = rosterFrom.clone();
        let dayMap = {};
        while (today <= rosterTo) {
            dayMap[today.format('YYYY-MM-DD')] = today;
            today.add(1, 'days');
        }

        Object.values(employeeMap).forEach(e => {
            map[e.id] = {
                preferences: [],
                preferencesDate: {},
                availabilities: {}
            };
            unapproved[e.id] = {
                preferences: [],
                preferencesDate: {},
                availabilities: {}
            };
        });
        Object.values(employeePreferenceMap).filter(pref => employeeMap[pref.employeeId] != null).forEach(pref => {
            let employee = employeeMap[pref.employeeId];
            let fromDate = employeePreferenceMomentMap[pref.id] ? employeePreferenceMomentMap[pref.id].fromDate : this.getMomentFromStringTZ(pref.from);
            let toDate = employeePreferenceMomentMap[pref.id] ? employeePreferenceMomentMap[pref.id].toDate : this.getMomentFromStringTZ(pref.to);

            if (employee) {
                var targetMap = map;
                if(!pref.approved){
                    targetMap = unapproved;
                }
                if (!targetMap[employee.id]) {
                    targetMap[employee.id] = {
                        preferences: [],
                        preferencesDate: {}
                    };
                }

                targetMap[employee.id].preferences.push(pref);


                let tempDate = fromDate.clone();
                while (toDate > tempDate) {
                    let key = tempDate.format('YYYY-MM-DD');
                    if (!targetMap[employee.id].preferencesDate[key]) targetMap[employee.id].preferencesDate[key] = [];
                    let item = {
                        preference: pref,
                        date: tempDate.clone().hours(0).minutes(0)
                    };
                    targetMap[employee.id].preferencesDate[key].push(item);
                    tempDate.add(1, 'days');
                }

            }
        });


        Object.values(employeeAvailabilityMap).filter(availability => employeeMap[availability.employeeId] != null).forEach(availability => {
            let employee = employeeMap[availability.employeeId];
            if (employee) {
                if (!map[employee.id]) {
                    map[employee.id] = {
                        preferences: [],
                        preferencesDate: {}
                    };
                }
                let entry = map[employee.id];

                if (!entry.availabilities) {
                    entry.availabilities = {}
                }
                if (!entry.availabilities[availability.state]) {
                    entry.availabilities[availability.state] = [];
                }

                entry.availabilities[availability.state].push(availability);

                if (!unapproved[employee.id]) {
                    unapproved[employee.id] = {
                        preferences: [],
                        preferencesDate: {}
                    };
                }
                let entry2 = unapproved[employee.id];

                if (!entry2.availabilities) {
                    entry2.availabilities = {}
                }
                if (!entry2.availabilities[availability.state]) {
                    entry2.availabilities[availability.state] = [];
                }

                entry2.availabilities[availability.state].push(availability);

            }
        });

        return {
            'approved': map,
            'unapproved': unapproved
        };
    }

    getCalculatedPreferenceMaps(employeeMap, employeePreferenceMap, employeeAvailabilityMap, rosterFromTo) {
        let employeePreferenceMomentMap = this.getFromToMomentMap(employeePreferenceMap);
        let employeePreferenceAvailabilityMaps = this.getEmployeePreferenceAvailabilityMap(employeeMap, employeePreferenceMap, employeePreferenceMomentMap, employeeAvailabilityMap, rosterFromTo);

        let employeePreferenceAvailabilityMap = employeePreferenceAvailabilityMaps['approved'];
        let employeeUnapprovedPreferenceAvailabilityMap = employeePreferenceAvailabilityMaps['unapproved'];
        let result = {
            employeePreferenceMomentMap: employeePreferenceMomentMap,
            employeePreferenceAvailabilityMap: employeePreferenceAvailabilityMap,
            employeeUnapprovedPreferenceAvailabilityMap: employeeUnapprovedPreferenceAvailabilityMap
        }
        return result;
    }

    getCalculatedShiftMaps(planShiftMap, actualShiftMap, actualBreakMap, employeeMap, employeeContractMap, spotMap, businessUnitMap, rosterFromTo, customSpotMap = null) {
        console.log('Starting maps calculation');
        //let t0 = performance.now();

        let planShiftMomentMap = {};
        let actualShiftMomentMap = {};
        let unassignedShiftsDateMap = {};


        if (customSpotMap == null) customSpotMap = this.getCustomSpotMapWithoutPriority(spotMap, businessUnitMap);

        let newUnpublishedShiftsWeeklyMap = {
            total: 0,
            weekEntries: {},
            dayEntries: {}
        };
        let newUnassignShiftsWeeklyMap = {
            total: 0,
            weekEntries: {},
            dayEntries: {}
        };
        let newPublishedShiftsWeeklyMap = {
            total: 0,
            weekEntries: {},
            dayEntries: {}
        };
        let newShiftsWeeklyMap = {
            total: 0,
            weekEntries: {},
            dayEntries: {}
        };
        let now = this.getMomentTZ().startOf('week');


        let rosterFrom = this.getMomentFromStringTZ(rosterFromTo.from).add(-1, 'days');
        let rosterTo = this.getMomentFromStringTZ(rosterFromTo.to).add(1, 'days');

        let actualRosterFrom = this.getMomentFromStringTZ(rosterFromTo.from);
        let actualRosterTo = this.getMomentFromStringTZ(rosterFromTo.to);

        let currentDate = rosterFrom.clone();
        let rosterDateKeys = [];
        let rosterDateKeyBoundaries = {};
        while (currentDate < rosterTo) {
            let dateKey = currentDate.format("YYYY-MM-DD");
            rosterDateKeys.push(dateKey);
            rosterDateKeyBoundaries[dateKey] = {
                dayStart: currentDate.clone().startOf('day'),
                dayEnd: currentDate.clone().endOf('day'),
                inRange: currentDate.month() == rosterFromTo.month
            };
            currentDate.add(1, 'days');
        }

        console.log('Preparing empty shiftDateMaps');
        let planShiftDateMap = {};
        let actualShiftDateMap = {};

        rosterDateKeys.forEach(k => planShiftDateMap[k] = []);
        rosterDateKeys.forEach(k => actualShiftDateMap[k] = []);
        let employeeDatePlannedShiftMap = {};
        let employeeDateActualShiftMap = {};
        let employeeDateActualShiftMarkedMap = {}; //marks on which days the actual shifts were planned in order to hide planshifts on those days
        let employeeDateCombinedShiftMap = {};
        let employeeContractStatusMap = {};

        console.log('Preparing empty employeeContractStatusMap');
        rosterDateKeys.forEach(dateKey => employeeContractStatusMap[dateKey] = {});

        console.log('Get employeeContractMomentMap');
        let employeeContractMomentMap = this.getFromToMomentMap(employeeContractMap);
        console.log('Get employeeIdContractMap');
        let employeeIdContractMap = this.getEmployeeIdContractMap(employeeContractMap);



        console.log('Looping employees to prepare date shift maps');
        Object.values(employeeMap).forEach(e => {
            employeeDatePlannedShiftMap[e.id] = {};
            rosterDateKeys.forEach(k => employeeDatePlannedShiftMap[e.id][k] = []);
            employeeDatePlannedShiftMap[e.id].shifts = [];

            employeeDateActualShiftMap[e.id] = {};
            rosterDateKeys.forEach(k => employeeDateActualShiftMap[e.id][k] = []);
            employeeDateActualShiftMap[e.id].shifts = [];

            employeeDateActualShiftMarkedMap[e.id] = {};
            rosterDateKeys.forEach(k => employeeDateActualShiftMarkedMap[e.id][k] = false)

            employeeDateCombinedShiftMap[e.id] = {};
            rosterDateKeys.forEach(k => employeeDateCombinedShiftMap[e.id][k] = []);
            employeeDateCombinedShiftMap[e.id].shifts = [];

            if (!employeeIdContractMap[e.id]) employeeIdContractMap[e.id] = [];
            rosterDateKeys.forEach(dateKey => {
                employeeContractStatusMap[dateKey][e.id] = !employeeIdContractMap[e.id] || (employeeIdContractMap[e.id] && employeeIdContractMap[e.id].length == 0) ||
                    (employeeIdContractMap[e.id] && employeeIdContractMap[e.id].length > 0
                        &&
                        !employeeIdContractMap[e.id].find(contract => {
                            return ((
                                    employeeContractMomentMap[contract.id].toDate == null ||
                                    rosterDateKeyBoundaries[dateKey].dayStart._d.getTime() < employeeContractMomentMap[contract.id].toDate._d.getTime()) &&
                                rosterDateKeyBoundaries[dateKey].dayEnd._d.getTime() > employeeContractMomentMap[contract.id].fromDate._d.getTime())
                        }))
            });
        });

        //let t1 = performance.now();
        //console.log("Preparation of maps took " + (t1-t0) / 1000.0 + " seconds.");

        let overviewA = [];
        let tplanShiftMap = {};
        console.log('Calculating planshift maps')
        Object.values(planShiftMap).forEach(entry => {
            this.calculateMomentMapEntry(planShiftMomentMap, entry);


            let momentEntry = planShiftMomentMap[entry.id];

            let weekStart = momentEntry.fromDate.clone().startOf('week');
            let dateKey = momentEntry.fromDate.format('YYYY-MM-DD');
            let dateLabel = momentEntry.fromDate.format("DD.MM.YYYY");
            let weekLabel = weekStart.format("DD.MM.YYYY") + ' - ' + weekStart.clone().add(1, 'week').format("DD.MM.YYYY");

            let planShiftItem = {
                id: entry.id,
                from: entry.from,
                to: entry.to,
                published: entry.published,
                publishDate: entry.publishDate,
            }
            planShiftItem.fromDate = planShiftItem.date = entry.fromDate = momentEntry.fromDate;
            planShiftItem.toDate = entry.toDate = momentEntry.toDate;

            if (!entry.employeeId && weekStart >= actualRosterFrom && weekStart < actualRosterTo) {
                if (!unassignedShiftsDateMap[dateKey]) unassignedShiftsDateMap[dateKey] = [];
                unassignedShiftsDateMap[dateKey].push(entry);
            }


            if (entry.employeeId) {
                planShiftItem.employeeId = entry.employeeId;
                let firstName = (employeeMap[entry.employeeId] != undefined) ? employeeMap[entry.employeeId].firstName : "";
                let lastName = (employeeMap[entry.employeeId] != undefined) ? employeeMap[entry.employeeId].lastName : "";
                planShiftItem.employee = firstName + " " + lastName;

                if (!employeeDatePlannedShiftMap[entry.employeeId]) {
                    employeeDatePlannedShiftMap[entry.employeeId] = {
                        shifts: []
                    };
                    rosterDateKeys.forEach(k => employeeDatePlannedShiftMap[entry.employeeId][k] = []);
                }
                employeeDatePlannedShiftMap[entry.employeeId].shifts.push(entry);
                if (!employeeDatePlannedShiftMap[entry.employeeId][dateKey]) employeeDatePlannedShiftMap[entry.employeeId][dateKey] = [];
                employeeDatePlannedShiftMap[entry.employeeId][dateKey].push(entry);
            }

            if (!this.isBlank(entry.spotId) && customSpotMap[entry.spotId]) {
                planShiftItem.spot = customSpotMap[entry.spotId].name;
            } else {
                planShiftItem.spot = "";
            }
            let employee = employeeMap[entry.employeeId];
            if (employee) {
                if (!employee.shifts) employee.shifts = [];
                if (!employee.shiftsDate) employee.shiftsDate = {};
                employee.shifts.push(entry);
                if (!employee.shiftsDate[dateKey]) employee.shiftsDate[dateKey] = [];
                employee.shiftsDate[dateKey].push(entry);
            }
            tplanShiftMap[entry.id] = entry;
            overviewA.push(planShiftItem);

            if (!planShiftDateMap[dateKey]) planShiftDateMap[dateKey] = [];
            planShiftDateMap[dateKey].push(entry);
            //add to unpublished shift date map
            if (!entry.published && entry.employeeId != null && weekStart >= actualRosterFrom && weekStart < actualRosterTo && employee != null && !employee.dummy) {
                if (!newUnpublishedShiftsWeeklyMap.dayEntries[dateLabel]) {
                    newUnpublishedShiftsWeeklyMap.dayEntries[dateLabel] = [];
                }
                if (!newUnpublishedShiftsWeeklyMap.weekEntries[weekLabel]) {
                    newUnpublishedShiftsWeeklyMap.weekEntries[weekLabel] = [];
                }
                newUnpublishedShiftsWeeklyMap.dayEntries[dateLabel].push(entry);
                newUnpublishedShiftsWeeklyMap.weekEntries[weekLabel].push(entry);
                newUnpublishedShiftsWeeklyMap.total += 1;
            }
            //add to unassign shift date map
            if (!entry.published && entry.employeeId != null && weekStart >= actualRosterFrom && weekStart < actualRosterTo && employee != null) {
                if (!newUnassignShiftsWeeklyMap.dayEntries[dateLabel]) {
                    newUnassignShiftsWeeklyMap.dayEntries[dateLabel] = [];
                }
                if (!newUnassignShiftsWeeklyMap.weekEntries[weekLabel]) {
                    newUnassignShiftsWeeklyMap.weekEntries[weekLabel] = [];
                }
                newUnassignShiftsWeeklyMap.dayEntries[dateLabel].push(entry);
                newUnassignShiftsWeeklyMap.weekEntries[weekLabel].push(entry);
                newUnassignShiftsWeeklyMap.total += 1;
            }
            //add to published shift date map
            if (entry.published && weekStart >= now && weekStart >= actualRosterFrom && weekStart < actualRosterTo) {
                if (!newPublishedShiftsWeeklyMap.dayEntries[dateLabel]) {
                    newPublishedShiftsWeeklyMap.dayEntries[dateLabel] = [];
                }
                if (!newPublishedShiftsWeeklyMap.weekEntries[weekLabel]) {
                    newPublishedShiftsWeeklyMap.weekEntries[weekLabel] = [];
                }
                newPublishedShiftsWeeklyMap.dayEntries[dateLabel].push(entry);
                newPublishedShiftsWeeklyMap.weekEntries[weekLabel].push(entry);
                newPublishedShiftsWeeklyMap.total += 1;
            }
            //add to shift date map
            if (weekStart >= rosterFrom) {
                if (!newShiftsWeeklyMap.dayEntries[dateLabel]) {
                    newShiftsWeeklyMap.dayEntries[dateLabel] = [];
                }
                if (!newShiftsWeeklyMap.weekEntries[weekLabel]) {
                    newShiftsWeeklyMap.weekEntries[weekLabel] = [];
                }
                newShiftsWeeklyMap.dayEntries[dateLabel].push(entry);
                newShiftsWeeklyMap.weekEntries[weekLabel].push(entry);
                newShiftsWeeklyMap.total += 1;
            }

        });
        let planshifts = overviewA;
        let customPlanShiftMap = tplanShiftMap;

        //let t2 = performance.now();
        //console.log("Plan Shift maps took " + (t2-t1) / 1000.0 + " seconds.");

        console.log('Calculating actual shift maps');
        Object.values(actualShiftMap).forEach(entry => {
            this.calculateMomentMapEntry(actualShiftMomentMap, entry);

            let momentEntry = actualShiftMomentMap[entry.id];

            let dateKey = momentEntry.fromDate.format('YYYY-MM-DD');

            //mark actual shift days
            if(!entry.endMissing){
                if (entry.planFrom != null) {
                    if (!employeeDateActualShiftMarkedMap[entry.employeeId]) {
                        employeeDateActualShiftMarkedMap[entry.employeeId] = {};
                    }
                    let markedKey = this.getMomentFromStringTZ(entry.planFrom).format('YYYY-MM-DD');
                    employeeDateActualShiftMarkedMap[entry.employeeId][markedKey] = true;
                } else {
                    if (!employeeDateActualShiftMarkedMap[entry.employeeId]) {
                        employeeDateActualShiftMarkedMap[entry.employeeId] = {};
                    }

                    employeeDateActualShiftMarkedMap[entry.employeeId][dateKey] = true;
                }
            }



            if (entry.employeeId) {
                if (!employeeDateActualShiftMap[entry.employeeId]) {
                    employeeDateActualShiftMap[entry.employeeId] = {
                        shifts: []
                    };
                    rosterDateKeys.forEach(k => employeeDateActualShiftMap[entry.employeeId][k] = []);
                }
                employeeDateActualShiftMap[entry.employeeId].shifts.push(entry);
                if (!employeeDateActualShiftMap[entry.employeeId][dateKey]) employeeDateActualShiftMap[entry.employeeId][dateKey] = [];
                employeeDateActualShiftMap[entry.employeeId][dateKey].push(entry);
            }

            if (!actualShiftDateMap[dateKey]) actualShiftDateMap[dateKey] = [];
            actualShiftDateMap[dateKey].push(entry);
        });

        //let t3 = performance.now();
        //console.log("Actual Shift maps took " + (t3-t2) / 1000.0 + " seconds.");

        Object.values(employeeMap).forEach(e => {
            rosterDateKeys.forEach(k => {
                if (employeeDateActualShiftMap[e.id][k]) {
                    if (employeeDateActualShiftMap[e.id][k].length > 0) {
                        for (let y in employeeDateActualShiftMap[e.id][k]) {
                            employeeDateCombinedShiftMap[e.id].shifts.push(employeeDateActualShiftMap[e.id][k][y]);
                            employeeDateCombinedShiftMap[e.id][k].push(employeeDateActualShiftMap[e.id][k][y]);
                        }
                    } else {
                        let invalidPlanDay = employeeDateActualShiftMarkedMap[e.id] && employeeDateActualShiftMarkedMap[e.id][k];
                        if (employeeDatePlannedShiftMap[e.id][k] && !invalidPlanDay) {
                            if (employeeDatePlannedShiftMap[e.id][k].length > 0) {
                                for (let y in employeeDatePlannedShiftMap[e.id][k]) {
                                    employeeDateCombinedShiftMap[e.id].shifts.push(employeeDatePlannedShiftMap[e.id][k][y]);
                                    employeeDateCombinedShiftMap[e.id][k].push(employeeDatePlannedShiftMap[e.id][k][y]);
                                }
                            }
                        }
                    }
                }
            });
        });

        //let t4 = performance.now();
        //console.log("Combined Shift maps took " + (t4-t3) / 1000.0 + " seconds.");


        let actualBreakShiftIdMap = {};
        let actualBreakMomentMap = {};
        Object.values(actualBreakMap).forEach(entry => {
            let momentEntry = actualBreakMomentMap[entry.id] ? actualBreakMomentMap[entry.id] : {};
            momentEntry.shift = entry;

            if (momentEntry.from != entry.from) {
                momentEntry.from = entry.from;
                momentEntry.fromDate = this.getMomentFromStringTZ(entry.from);
            }
            if (momentEntry.to != entry.to) {
                momentEntry.to = entry.to;
                momentEntry.toDate = this.getMomentFromStringTZ(entry.to);
            }
            actualBreakMomentMap[entry.id] = momentEntry;

            if (!actualBreakShiftIdMap[entry.shiftId]) actualBreakShiftIdMap[entry.shiftId] = [];
            actualBreakShiftIdMap[entry.shiftId].push(entry);
        });

        let unpublishedShiftsWeeklyMap = newUnpublishedShiftsWeeklyMap;
        let unassignShiftsWeeklyMap = newUnassignShiftsWeeklyMap;
        let publishedShiftsWeeklyMap = newPublishedShiftsWeeklyMap;
        let shiftsWeeklyMap = newShiftsWeeklyMap;

        //let t5 = performance.now();
        //console.log("Break maps took " + (t5-t4) / 1000.0 + " seconds.");


        Object.values(employeeDateCombinedShiftMap).forEach(eid => {
            let shifts = eid.shifts;
            shifts.sort((a, b) => {
                let aDate = planShiftMomentMap[a.id] ? planShiftMomentMap[a.id].fromDate.unix() : actualShiftMomentMap[a.id] ? actualShiftMomentMap[a.id].fromDate.unix() : 0;
                let bDate = planShiftMomentMap[b.id] ? planShiftMomentMap[b.id].fromDate.unix() : actualShiftMomentMap[b.id] ? actualShiftMomentMap[b.id].fromDate.unix() : 0;
                return aDate - bDate;
            })
        })


        //let t6 = performance.now();
        //console.log("Sorting maps took " + (t6-t5) / 1000.0 + " seconds.");


        let result = {
            planShiftMomentMap: planShiftMomentMap,
            actualShiftMomentMap: actualShiftMomentMap,
            unassignedShiftsDateMap: unassignedShiftsDateMap,
            customSpotMap: customSpotMap,
            planShiftDateMap: planShiftDateMap,
            actualShiftDateMap: actualShiftDateMap,
            employeeDatePlannedShiftMap: employeeDatePlannedShiftMap,
            employeeDateActualShiftMap: employeeDateActualShiftMap,
            employeeDateActualShiftMarkedMap: employeeDateActualShiftMarkedMap,
            employeeDateCombinedShiftMap: employeeDateCombinedShiftMap,
            employeeContractStatusMap: employeeContractStatusMap,
            employeeContractMomentMap: employeeContractMomentMap,
            employeeIdContractMap: employeeIdContractMap,
            planshifts: planshifts,
            customPlanShiftMap: customPlanShiftMap,
            actualBreakShiftIdMap: actualBreakShiftIdMap,
            actualBreakMomentMap: actualBreakMomentMap,
            unpublishedShiftsWeeklyMap: unpublishedShiftsWeeklyMap,
            unassignShiftsWeeklyMap: unassignShiftsWeeklyMap,
            publishedShiftsWeeklyMap: publishedShiftsWeeklyMap,
            shiftsWeeklyMap: shiftsWeeklyMap,
        };


        return result;
    }

    getUnpublishedShiftsWeeklyMap(planShiftMap, employeeMap, rosterFrom) {
        let planShiftMomentMap = this.getFromToMomentMap(planShiftMap);
        let unpublishedShiftsWeeklyMap =  {total: 0, weekEntries: {}, dayEntries: {}};
        Object.values(planShiftMap).forEach(entry => {
            let momentEntry = planShiftMomentMap[entry.id] ? planShiftMomentMap[entry.id] : {};
            momentEntry.shift = entry;

            if (momentEntry.from != entry.from) {
                momentEntry.from = entry.from;
                momentEntry.fromDate = this.getMomentFromStringTZ(entry.from);
            }
            if (momentEntry.to != entry.to) {
                momentEntry.to = entry.to;
                momentEntry.toDate = this.getMomentFromStringTZ(entry.to);
            }

            let weekStart = momentEntry.fromDate.clone().startOf('week');
            let dateLabel = momentEntry.fromDate.format("DD.MM.YYYY");
            let weekLabel = weekStart.format("DD.MM.YYYY") + ' - ' + weekStart.clone().add(1, 'week').format("DD.MM.YYYY");

            let employee = employeeMap[entry.employeeId];

            //add to unpublished shift date map
            if (!entry.published && entry.employeeId != null && weekStart >= rosterFrom && employee != null && !employee.dummy) {
                if (!unpublishedShiftsWeeklyMap.dayEntries[dateLabel]) {
                    unpublishedShiftsWeeklyMap.dayEntries[dateLabel] = [];
                }
                if (!unpublishedShiftsWeeklyMap.weekEntries[weekLabel]) {
                    unpublishedShiftsWeeklyMap.weekEntries[weekLabel] = [];
                }
                unpublishedShiftsWeeklyMap.dayEntries[dateLabel].push(entry);
                unpublishedShiftsWeeklyMap.weekEntries[weekLabel].push(entry);
                unpublishedShiftsWeeklyMap.total += 1;
            }


        });
        return unpublishedShiftsWeeklyMap;
    }

    getPublishedShiftsWeeklyMap(planShiftMap, rosterFrom) {
        let planShiftMomentMap = this.getFromToMomentMap(planShiftMap);
        let publishedShiftsWeeklyMap =  {total: 0, weekEntries: {}, dayEntries: {}};
        let now = this.getMomentTZ().add(30, 'minutes');
        Object.values(planShiftMap).forEach(entry => {
            let momentEntry = planShiftMomentMap[entry.id] ? planShiftMomentMap[entry.id] : {};
            momentEntry.shift = entry;

            if (momentEntry.from != entry.from) {
                momentEntry.from = entry.from;
                momentEntry.fromDate = this.getMomentFromStringTZ(entry.from);
            }
            if (momentEntry.to != entry.to) {
                momentEntry.to = entry.to;
                momentEntry.toDate = this.getMomentFromStringTZ(entry.to);
            }

            let weekStart = momentEntry.fromDate.clone().startOf('week');
            let dateLabel = momentEntry.fromDate.format("DD.MM.YYYY");
            let weekLabel = weekStart.format("DD.MM.YYYY") + ' - ' + weekStart.clone().add(1, 'week').format("DD.MM.YYYY");


            //add to published shift date map
            if (entry.published && momentEntry.fromDate > now && weekStart >= rosterFrom) {
                if (!publishedShiftsWeeklyMap.dayEntries[dateLabel]) {
                    publishedShiftsWeeklyMap.dayEntries[dateLabel] = [];
                }
                if (!publishedShiftsWeeklyMap.weekEntries[weekLabel]) {
                    publishedShiftsWeeklyMap.weekEntries[weekLabel] = [];
                }
                publishedShiftsWeeklyMap.dayEntries[dateLabel].push(entry);
                publishedShiftsWeeklyMap.weekEntries[weekLabel].push(entry);
                publishedShiftsWeeklyMap.total += 1;
            }


        });

        return publishedShiftsWeeklyMap;

    }

    getShiftsWeeklyMap(planShiftMap, rosterFrom) {
        let planShiftMomentMap = this.getFromToMomentMap(planShiftMap);
        let shiftsWeeklyMap =  {total: 0, weekEntries: {}, dayEntries: {}};

        Object.values(planShiftMap).forEach(entry => {
            let momentEntry = planShiftMomentMap[entry.id] ? planShiftMomentMap[entry.id] : {};
            momentEntry.shift = entry;

            if (momentEntry.from != entry.from) {
                momentEntry.from = entry.from;
                momentEntry.fromDate = this.getMomentFromStringTZ(entry.from);
            }
            if (momentEntry.to != entry.to) {
                momentEntry.to = entry.to;
                momentEntry.toDate = this.getMomentFromStringTZ(entry.to);
            }

            let weekStart = momentEntry.fromDate.clone().startOf('week');
            let dateLabel = momentEntry.fromDate.format("DD.MM.YYYY");
            let weekLabel = weekStart.format("DD.MM.YYYY") + ' - ' + weekStart.clone().add(1, 'week').format("DD.MM.YYYY");



            //add to shift date map
            if (weekStart >= rosterFrom) {
                if (!shiftsWeeklyMap.dayEntries[dateLabel]) {
                    shiftsWeeklyMap.dayEntries[dateLabel] = [];
                }
                if (!shiftsWeeklyMap.weekEntries[weekLabel]) {
                    shiftsWeeklyMap.weekEntries[weekLabel] = [];
                }
                shiftsWeeklyMap.dayEntries[dateLabel].push(entry);
                shiftsWeeklyMap.weekEntries[weekLabel].push(entry);
                shiftsWeeklyMap.total += 1;
            }

        });
        return shiftsWeeklyMap;

    }

    getActualBreakShiftIdMap(actualBreakMap){
        let actualBreakShiftIdMap = {};

        Object.values(actualBreakMap).forEach(entry => {
            if (!actualBreakShiftIdMap[entry.shiftId]) actualBreakShiftIdMap[entry.shiftId] = [];
            actualBreakShiftIdMap[entry.shiftId].push(entry);
        });
        return actualBreakShiftIdMap;
    }

    calculateShiftTimeByDayMap(rosterFrom, rosterTo,
                                planShiftMap, planShiftMomentMap,
                                actualShiftMap, actualShiftMomentMap,
                                actualBreakMap, actualBreakMomentMap,
                                actualBreakShiftIdMap,
                                employeeMap, spotMap, helpers) {


        let map = {};
        let currentDate = rosterFrom.clone();
        let endDate = rosterTo.clone().add(1, 'days');

        while (currentDate < endDate) {
          let dateKey = currentDate.format("YYYY-MM-DD");

          map[dateKey] = {totalPlanned: 0,
                          totalPlannedPreviousDay: 0,
                          totalAssigned: 0,
                          totalAssignedPreviousDay: 0,
                          totalActual: 0,
                          totalActualPreviousDay: 0,
                          totalAssignedCrewOnly: 0,
                          totalAssignedPreviousDayCrewOnly: 0,
                          totalActualCrewOnly: 0,
                          totalActualPreviousDayCrewOnly: 0,
                          productiveAssigned: 0,
                          productiveAssignedPreviousDay: 0,
                          productiveActual: 0,
                          productiveActualPreviousDay: 0,
                          productiveAssignedCrewOnly: 0,
                          productiveAssignedPreviousDayCrewOnly: 0,
                          productiveActualCrewOnly: 0,
                          productiveActualPreviousDayCrewOnly: 0,
                          endOfDay: currentDate.clone().endOf('day')
                        };
          currentDate.add(1, 'days');
        }

        Object.values(actualShiftMap).filter(s => employeeMap[s.employeeId] || s.employeeId == null).forEach(s => {
            let shiftMoment = actualShiftMomentMap[s.id];
            let from = shiftMoment.fromDate;
            let to = shiftMoment.toDate;
            let dateKey = from.format("YYYY-MM-DD");
            let nextDay = from.clone().add(1, 'days').format("YYYY-MM-DD");
            if(map[dateKey]){
                let result = this.calculateShiftTimeDayActual(s, from, to, map[dateKey].endOfDay, planShiftMap, actualBreakMomentMap, actualBreakShiftIdMap, employeeMap, spotMap, helpers);
                map[dateKey].totalActual += result.totalActual;
                map[dateKey].productiveActual += result.productiveActual;
                map[dateKey].totalActualCrewOnly += result.totalActualCrewOnly;
                map[dateKey].productiveActualCrewOnly += result.productiveActualCrewOnly;

                if(map[nextDay]){
                    map[nextDay].totalActualPreviousDay += result.totalActualNextDay;
                    map[nextDay].productiveActualPreviousDay += result.productiveActualNextDay;
                    map[nextDay].totalActualPreviousDayCrewOnly += result.totalActualNextDayCrewOnly;
                    map[nextDay].productiveActualPreviousDayCrewOnly += result.productiveActualNextDayCrewOnly;
                }
            }




        });

        Object.values(planShiftMap).filter(s => employeeMap[s.employeeId] || s.employeeId == null).forEach(s => {
            let shiftMoment = planShiftMomentMap[s.id];
            let from = shiftMoment.fromDate;
            let to = shiftMoment.toDate;
            let dateKey = from.format("YYYY-MM-DD");
            let nextDay = from.clone().add(1, 'days').format("YYYY-MM-DD");
            if(map[dateKey]){
                let result = this.calculateShiftTimeDayPlanned(s, from, to, map[dateKey].endOfDay, employeeMap, spotMap, helpers);

                map[dateKey].totalAssigned += result.totalAssigned;
                map[dateKey].productiveAssigned += result.productiveAssigned;
                map[dateKey].totalAssignedCrewOnly += result.totalAssignedCrewOnly;
                map[dateKey].productiveAssignedCrewOnly += result.productiveAssignedCrewOnly;
                map[dateKey].totalPlanned += result.totalPlanned;


                if(map[nextDay]){
                    map[nextDay].totalAssignedPreviousDay += result.totalAssignedNextDay;
                    map[nextDay].productiveAssignedPreviousDay += result.productiveAssignedNextDay;
                    map[nextDay].totalAssignedPreviousDayCrewOnly += result.totalAssignedNextDayCrewOnly;
                    map[nextDay].productiveAssignedPreviousDayCrewOnly += result.productiveAssignedNextDayCrewOnly;
                    map[nextDay].totalPlannedPreviousDay += result.totalPlannedNextDay;

                    

                }
            }


        });

        this.store.commit('setShiftTimeByDayMap', {shiftTimeByDayMap: map});

        return map;


    }

    calculateShiftTimeByDayMapDelta(map, oldDateKeys, newDateKeys,
        planShiftDateMap, actualShiftDateMap,
        planShiftMap, planShiftMomentMap,
        actualShiftMap, actualShiftMomentMap,
        actualBreakMap, actualBreakMomentMap,
        actualBreakShiftIdMap,
        employeeMap, spotMap, helpers) {

        let usedKeys = new Set();
        if(oldDateKeys != null){

            oldDateKeys.forEach(dk => {
                if(!usedKeys.has(dk)){
                    this.calculateShiftTimeByDayMapDeltaEntry(map, dk,
                                                            planShiftDateMap, actualShiftDateMap,
                                                             planShiftMap, planShiftMomentMap,
                                                             actualShiftMap, actualShiftMomentMap,
                                                             actualBreakMap, actualBreakMomentMap,
                                                             actualBreakShiftIdMap,
                                                             employeeMap,
                                                             spotMap, helpers);
                    usedKeys.add(dk);
                }

            })

        }
        if(newDateKeys != null){
            newDateKeys.forEach(dk => {
                if(!usedKeys.has(dk)){
                    this.calculateShiftTimeByDayMapDeltaEntry(map, dk,
                                                            planShiftDateMap, actualShiftDateMap,
                                                            planShiftMap, planShiftMomentMap,
                                                            actualShiftMap, actualShiftMomentMap,
                                                            actualBreakMap, actualBreakMomentMap,
                                                            actualBreakShiftIdMap,
                                                            employeeMap,
                                                            spotMap, helpers);
                    usedKeys.add(dk);
                }

            })
        }
        this.store.commit('setShiftTimeByDayMap', {shiftTimeByDayMap: map});

    }

    calculateShiftTimeByDayMapDeltaEntry(map, dateKey,
        planShiftDateMap, actualShiftDateMap,
        planShiftMap, planShiftMomentMap,
        actualShiftMap, actualShiftMomentMap,
        actualBreakMap, actualBreakMomentMap,
        actualBreakShiftIdMap,
        employeeMap, spotMap, helpers) {

        let nextDay = this.getMomentFromStringTZ(dateKey, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
        let entry =  map[dateKey];
        let nextEntry = map[nextDay];

        if(entry){
            entry.totalPlanned =  0,
            entry.totalAssigned = 0,
            entry.totalActual = 0,
            entry.totalAssignedCrewOnly = 0,
            entry.totalActualCrewOnly = 0,
            entry.productiveAssigned = 0,
            entry.productiveActual = 0,
            entry.productiveAssignedCrewOnly = 0,
            entry.productiveActualCrewOnly = 0;
        }
        if(nextEntry){
            nextEntry.totalPlannedPreviousDay = 0,
            nextEntry.totalAssignedPreviousDay = 0,
            nextEntry.totalActualPreviousDay = 0,
            nextEntry.totalAssignedPreviousDayCrewOnly = 0,
            nextEntry.totalActualPreviousDayCrewOnly = 0,
            nextEntry.productiveAssignedPreviousDay = 0,
            nextEntry.productiveActualPreviousDay = 0,
            nextEntry.productiveAssignedPreviousDayCrewOnly = 0,
            nextEntry.productiveActualPreviousDayCrewOnly = 0;
        }




        if (actualShiftDateMap[dateKey]){
            actualShiftDateMap[dateKey].filter(s => employeeMap[s.employeeId] || s.employeeId == null).forEach(s => {
                let shiftMoment = actualShiftMomentMap[s.id];
                let from = shiftMoment.fromDate;
                let to = shiftMoment.toDate;

                if(entry){
                    let result = this.calculateShiftTimeDayActual(s, from, to, entry.endOfDay, planShiftMap, actualBreakMomentMap, actualBreakShiftIdMap, employeeMap, spotMap, helpers);
                    entry.totalActual += result.totalActual;
                    entry.productiveActual += result.productiveActual;
                    entry.totalActualCrewOnly += result.totalActualCrewOnly;
                    entry.productiveActualCrewOnly += result.productiveActualCrewOnly;

                    if(nextEntry){
                        nextEntry.totalActualPreviousDay += result.totalActualNextDay;
                        nextEntry.productiveActualPreviousDay += result.productiveActualNextDay;
                        nextEntry.totalActualPreviousDayCrewOnly += result.totalActualNextDayCrewOnly;
                        nextEntry.productiveActualPreviousDayCrewOnly += result.productiveActualNextDayCrewOnly;
                    }
                }
            });
        }

        if (planShiftDateMap[dateKey]){
            planShiftDateMap[dateKey].filter(s => employeeMap[s.employeeId] || s.employeeId == null).forEach(s => {
                let shiftMoment = planShiftMomentMap[s.id];
                let from = shiftMoment.fromDate;
                let to = shiftMoment.toDate;

                if(entry){
                    let result = this.calculateShiftTimeDayPlanned(s, from, to, entry.endOfDay, employeeMap, spotMap, helpers);
                    entry.totalAssigned += result.totalAssigned;
                    entry.productiveAssigned += result.productiveAssigned;
                    entry.totalAssignedCrewOnly += result.totalAssignedCrewOnly;
                    entry.productiveAssignedCrewOnly += result.productiveAssignedCrewOnly;
                    entry.totalPlanned += result.totalPlanned;


                    if(nextEntry){
                        nextEntry.totalAssignedPreviousDay += result.totalAssignedNextDay;
                        nextEntry.productiveAssignedPreviousDay += result.productiveAssignedNextDay;
                        nextEntry.totalAssignedPreviousDayCrewOnly += result.totalAssignedNextDayCrewOnly;
                        nextEntry.productiveAssignedPreviousDayCrewOnly += result.productiveAssignedNextDayCrewOnly;
                        nextEntry.totalPlannedPreviousDay += result.totalPlannedNextDay;

                    }
                }

            });
        }







        return map;


    }

    calculateShiftTimeDayActual(s, from, to, endOfDay, planShiftMap, actualBreakMomentMap, actualBreakShiftIdMap, employeeMap, spotMap, helpers) {

        let ps = planShiftMap[s.planshiftId] ? planShiftMap[s.planshiftId] : null;
        let shiftSpot = ps != null ? (spotMap[ps.spotId] ? spotMap[ps.spotId] : null) : null;
        let employeeMainSpot = employeeMap[s.employeeId] ? (spotMap[employeeMap[s.employeeId].spotId] ? spotMap[employeeMap[s.employeeId].spotId] : null): null;

        let productive = shiftSpot != null ? shiftSpot.productive : (employeeMainSpot != null ? employeeMainSpot.productive : true);


        let timeAggregation = helpers.GetMillisecondTotalObjectFromMoments(from, to, endOfDay); //this adds 2ms

        let result = {
            totalPlanned: 0,
            totalPlannedNextDay: 0,
            totalAssigned: 0,
            totalAssignedNextDay: 0,
            totalActual: 0,
            totalActualNextDay: 0,
            totalAssignedCrewOnly: 0,
            totalAssignedNextDayCrewOnly: 0,
            totalActualCrewOnly: 0,
            totalActualNextDayCrewOnly: 0,
            productiveAssigned: 0,
            productiveAssignedNextDay: 0,
            productiveActual: 0,
            productiveActualNextDay: 0,
            productiveAssignedCrewOnly: 0,
            productiveAssignedNextDayCrewOnly: 0,
            productiveActualCrewOnly: 0,
            productiveActualNextDayCrewOnly: 0,
        }
        if (actualBreakShiftIdMap[s.id] && actualBreakShiftIdMap[s.id].length > 0){
            let breaks = actualBreakShiftIdMap[s.id];
            breaks.forEach(b => {
                let breakMoment = actualBreakMomentMap[b.id];
                let breakFrom = breakMoment.fromDate;
                let breakTo = breakMoment.toDate;
                let check = helpers.GetFromToCheckObject(breakFrom, breakTo, from, to);
                if(check.isNonZeroDiff){
                    let breakTimeAggregation = helpers.GetMillisecondTotalObjectFromMoments(breakFrom, breakTo, endOfDay);
                    timeAggregation.total -= Math.max(0, breakTimeAggregation.total);
                    timeAggregation.totalOutOfRange -= Math.max(0, breakTimeAggregation.totalOutOfRange);

                }

            });


        }
        result.totalActual = timeAggregation.total;
        if(productive){
           result.productiveActual = timeAggregation.total;
        }
        if (timeAggregation.totalOutOfRange){
            result.totalActualNextDay = timeAggregation.totalOutOfRange;
            if(productive){
                result.productiveActualNextDay = timeAggregation.totalOutOfRange;
            }
        }

        if(employeeMainSpot == null || employeeMainSpot == undefined || employeeMainSpot.employeeLevel == 1){ // include all spots with level "Crew" and scenarios where spot is null (can this happen?)
            result.totalActualCrewOnly = timeAggregation.total;
            if(productive){
                result.productiveActualCrewOnly = timeAggregation.total;
            }
            if (timeAggregation.totalOutOfRange){
                result.totalActualNextDayCrewOnly = timeAggregation.totalOutOfRange;
                if(productive){
                    result.productiveActualNextDayCrewOnly = timeAggregation.totalOutOfRange;
                }
            }
        }

        return result


    }

    calculateShiftTimeDayPlanned(s, from, to, endOfDay, employeeMap, spotMap, helpers) {


        let shiftSpot = spotMap[s.spotId] ? spotMap[s.spotId] : null;

        let result = {
            totalPlanned: 0,
            totalPlannedNextDay: 0,
            totalAssigned: 0,
            totalAssignedNextDay: 0,
            totalActual: 0,
            totalActualNextDay: 0,
            totalAssignedCrewOnly: 0,
            totalAssignedNextDayCrewOnly: 0,
            totalActualCrewOnly: 0,
            totalActualNextDayCrewOnly: 0,
            productiveAssigned: 0,
            productiveAssignedNextDay: 0,
            productiveActual: 0,
            productiveActualNextDay: 0,
            productiveAssignedCrewOnly: 0,
            productiveAssignedNextDayCrewOnly: 0,
            productiveActualCrewOnly: 0,
            productiveActualNextDayCrewOnly: 0,
        }

        let timeAggregation = helpers.GetMillisecondTotalObjectFromMoments(from, to, endOfDay); //this adds 2ms
        if(s.employeeId){
            let employeeMainSpot = employeeMap[s.employeeId] ? (spotMap[employeeMap[s.employeeId].spotId] ? spotMap[employeeMap[s.employeeId].spotId] : null): null;
            let productive = shiftSpot != null ? shiftSpot.productive : (employeeMainSpot != null ? employeeMainSpot.productive : true);

            if (s.breakValue && s.breakValue > 0){
                let breakFrom = null;
                if(s.breakFrom != null){
                    breakFrom = helpers.getMomentFromStringTZ(s.breakFrom);
                    let breakTo = breakFrom.clone().add(s.breakValue, 'minutes');
                    let check = helpers.GetFromToCheckObject(breakFrom, breakTo, from, to);
                    if(check.isNonZeroDiff){
                        let breakTimeAggregation = helpers.GetMillisecondTotalObjectFromMoments(breakFrom, breakTo, endOfDay);
                        timeAggregation.total -= Math.max(0, breakTimeAggregation.total);
                        timeAggregation.totalOutOfRange -= Math.max(0, breakTimeAggregation.totalOutOfRange);

                    }
                } else {
                    let tor = timeAggregation.totalOutOfRange > 0 ? timeAggregation.totalOutOfRange : 0
                    let wv = to.diff(from, 'milliseconds') - (s.breakValue *60*1000);
                    let total = wv * (timeAggregation.total/(timeAggregation.total + tor));
                    let totalOutOfRange = wv * (tor/(timeAggregation.total + tor));
                    timeAggregation.total = total;
                    timeAggregation.totalOutOfRange = totalOutOfRange;
                }


            }

            result.totalAssigned = timeAggregation.total;
            if(productive){
                result.productiveAssigned = timeAggregation.total;
            }


            if (timeAggregation.totalOutOfRange){
                result.totalAssignedNextDay = timeAggregation.totalOutOfRange;
                if(productive){
                    result.productiveAssignedNextDay = timeAggregation.totalOutOfRange;
                }
            }

            if(employeeMainSpot == null || employeeMainSpot == undefined || employeeMainSpot.employeeLevel == 1){ // include all spots with level "Crew" and scenarios where spot is null (can this happen?)
                result.totalAssignedCrewOnly = timeAggregation.total;
                if(productive){
                    result.productiveAssignedCrewOnly = timeAggregation.total;
                }

                if (timeAggregation.totalOutOfRange){

                    result.totalAssignedNextDayCrewOnly = timeAggregation.totalOutOfRange;
                    if(productive){
                        result.productiveAssignedNextDayCrewOnly = timeAggregation.totalOutOfRange;
                    }

                }
            }
        }  else {
            if (s.breakValue && s.breakValue > 0){
                let breakFrom = null;
                if(s.breakFrom != null){
                    breakFrom = helpers.getMomentFromStringTZ(s.breakFrom);
                    let breakTo = breakFrom.clone().add(s.breakValue, 'minutes');
                    let check = helpers.GetFromToCheckObject(breakFrom, breakTo, from, to);
                    if(check.isNonZeroDiff){
                        let breakTimeAggregation = helpers.GetMillisecondTotalObjectFromMoments(breakFrom, breakTo, endOfDay);
                        timeAggregation.total -= Math.max(0, breakTimeAggregation.total);
                        timeAggregation.totalOutOfRange -= Math.max(0, breakTimeAggregation.totalOutOfRange);

                    }
                } else {
                    let tor = timeAggregation.totalOutOfRange > 0 ? timeAggregation.totalOutOfRange : 0
                    let wv = to.diff(from, 'milliseconds') - (s.breakValue *60*1000);
                    let total = wv * (timeAggregation.total/(timeAggregation.total + tor));
                    let totalOutOfRange = wv * (tor/(timeAggregation.total + tor));
                    timeAggregation.total = total;
                    timeAggregation.totalOutOfRange = totalOutOfRange;
                }


            }
            result.totalPlanned = timeAggregation.total;


            if (timeAggregation.totalOutOfRange){
                result.totalPlannedNextDay = timeAggregation.totalOutOfRange;
            }
        }

        return result;
    }

    calculateShiftTimeByHourMap(rosterFrom, rosterTo,
                                planShiftMap, planShiftMomentMap,
                                actualShiftMap, actualShiftMomentMap,
                                actualBreakMap, actualBreakMomentMap,
                                actualBreakShiftIdMap,
                                employeeMap, spotMap, helpers) {


        let map = {};
        let currentDate = rosterFrom.clone();
        let endDate = rosterTo.clone().add(1, 'days');

        while (currentDate < endDate) {
            let hourKey = currentDate.format("YYYY-MM-DD HH");

            map[hourKey] = {
                            totalPlanned: 0,
                            totalPlannedFull: 0,
                            totalAssigned: 0,
                            totalAssignedFull: 0,
                            totalActual: 0,
                            totalActualFull: 0,
                            totalAssignedCrewOnly: 0,
                            totalAssignedCrewOnlyFull: 0,
                            totalActualCrewOnly: 0,
                            totalActualCrewOnlyFull: 0,
                            productiveAssigned: 0,
                            productiveAssignedFull: 0,
                            productiveActual: 0,
                            productiveActualFull: 0,
                            productiveAssignedCrewOnly: 0,
                            productiveAssignedCrewOnlyFull: 0,
                            productiveActualCrewOnly: 0,
                            productiveActualCrewOnlyFull: 0,
                            spots: {}
                        };
            currentDate.add(1, 'hours');
        }

        Object.values(actualShiftMap).filter(s => employeeMap[s.employeeId] || s.employeeId == null).forEach(s => {
            let shiftMoment = actualShiftMomentMap[s.id];
            let from = shiftMoment.fromDate;
            let to = shiftMoment.toDate;

            let hourIter = from.clone();
            while(hourIter < to){
                let nextHour = hourIter.clone().add(1, 'hours').startOf('hour');
                if(nextHour > to){
                    nextHour = to;
                }
                let hourKey = hourIter.format("YYYY-MM-DD HH");
                if(map[hourKey]){
                    let result = this.calculateShiftTimeHourActual(s, hourIter, nextHour, planShiftMap, actualBreakMomentMap, actualBreakShiftIdMap, employeeMap, spotMap, helpers);
                    map[hourKey].totalActual += result.totalActual;
                    map[hourKey].totalActualFull += result.totalActualFull;
                    map[hourKey].productiveActual += result.productiveActual;
                    map[hourKey].productiveActualFull += result.productiveActualFull;
                    map[hourKey].totalActualCrewOnly += result.totalActualCrewOnly;
                    map[hourKey].totalActualCrewOnlyFull += result.totalActualCrewOnlyFull;
                    map[hourKey].productiveActualCrewOnly += result.productiveActualCrewOnly;
                    map[hourKey].productiveActualCrewOnlyFull += result.productiveActualCrewOnlyFull;
                    Object.entries(result.spots).forEach(spot => {
                        if(!map[hourKey].spots[spot[0]]){
                            map[hourKey].spots[spot[0]] = {
                                totalPlanned: 0,
                                totalPlannedFull: 0,
                                totalAssigned: 0,
                                totalAssignedFull: 0,
                                totalActual: 0,
                                totalActualFull: 0,
                                totalAssignedCrewOnly: 0,
                                totalAssignedCrewOnlyFull: 0,
                                totalActualCrewOnly: 0,
                                totalActualCrewOnlyFull: 0,
                                productiveAssigned: 0,
                                productiveAssignedFull: 0,
                                productiveActual: 0,
                                productiveActualFull: 0,
                                productiveAssignedCrewOnly: 0,
                                productiveAssignedCrewOnlyFull: 0,
                                productiveActualCrewOnly: 0,
                                productiveActualCrewOnlyFull: 0,
                              };
                        }
                        map[hourKey].spots[spot[0]].totalActual += spot[1].totalActual;
                        map[hourKey].spots[spot[0]].totalActualFull += spot[1].totalActualFull;
                        map[hourKey].spots[spot[0]].productiveActual += spot[1].productiveActual;
                        map[hourKey].spots[spot[0]].productiveActualFull += spot[1].productiveActualFull;
                        map[hourKey].spots[spot[0]].totalActualCrewOnly += spot[1].totalActualCrewOnly;
                        map[hourKey].spots[spot[0]].totalActualCrewOnlyFull += spot[1].totalActualCrewOnlyFull;
                        map[hourKey].spots[spot[0]].productiveActualCrewOnly += spot[1].productiveActualCrewOnly;
                        map[hourKey].spots[spot[0]].productiveActualCrewOnlyFull += spot[1].productiveActualCrewOnlyFull;
                    });
                }
                hourIter = nextHour;
            }

        });

        Object.values(planShiftMap).filter(s => employeeMap[s.employeeId] || s.employeeId == null).forEach(s => {
            let shiftMoment = planShiftMomentMap[s.id];
            let from = shiftMoment.fromDate;
            let to = shiftMoment.toDate;

            let hourIter = from.clone();
            while(hourIter < to){
                let nextHour = hourIter.clone().add(1, 'hours').startOf('hour');
                if(nextHour > to){
                    nextHour = to;
                }
                let hourKey = hourIter.format("YYYY-MM-DD HH");
                if(map[hourKey]){
                    let result = this.calculateShiftTimeHourPlanned(s, hourIter, nextHour, from, to, employeeMap, spotMap, helpers);
                    map[hourKey].totalAssigned += result.totalAssigned;
                    map[hourKey].totalAssignedFull += result.totalAssignedFull;
                    map[hourKey].productiveAssigned += result.productiveAssigned;
                    map[hourKey].productiveAssignedFull += result.productiveAssignedFull;
                    map[hourKey].totalAssignedCrewOnly += result.totalAssignedCrewOnly;
                    map[hourKey].totalAssignedCrewOnlyFull += result.totalAssignedCrewOnlyFull;
                    map[hourKey].productiveAssignedCrewOnly += result.productiveAssignedCrewOnly;
                    map[hourKey].productiveAssignedCrewOnlyFull += result.productiveAssignedCrewOnlyFull;
                    map[hourKey].totalPlanned += result.totalPlanned;
                    map[hourKey].totalPlannedFull += result.totalPlannedFull;
                    Object.entries(result.spots).forEach(spot => {
                        if(!map[hourKey].spots[spot[0]]){
                            map[hourKey].spots[spot[0]] = {
                                totalPlanned: 0,
                                totalPlannedFull: 0,
                                totalAssigned: 0,
                                totalAssignedFull: 0,
                                totalActual: 0,
                                totalActualFull: 0,
                                totalAssignedCrewOnly: 0,
                                totalAssignedCrewOnlyFull: 0,
                                totalActualCrewOnly: 0,
                                totalActualCrewOnlyFull: 0,
                                productiveAssigned: 0,
                                productiveAssignedFull: 0,
                                productiveActual: 0,
                                productiveActualFull: 0,
                                productiveAssignedCrewOnly: 0,
                                productiveAssignedCrewOnlyFull: 0,
                                productiveActualCrewOnly: 0,
                                productiveActualCrewOnlyFull: 0,
                              };
                        }
                        map[hourKey].spots[spot[0]].totalAssigned += spot[1].totalAssigned;
                        map[hourKey].spots[spot[0]].totalAssignedFull += spot[1].totalAssignedFull;
                        map[hourKey].spots[spot[0]].productiveAssigned += spot[1].productiveAssigned;
                        map[hourKey].spots[spot[0]].productiveAssignedFull += spot[1].productiveAssignedFull;
                        map[hourKey].spots[spot[0]].totalAssignedCrewOnly += spot[1].totalAssignedCrewOnly;
                        map[hourKey].spots[spot[0]].totalAssignedCrewOnlyFull += spot[1].totalAssignedCrewOnlyFull;
                        map[hourKey].spots[spot[0]].productiveAssignedCrewOnly += spot[1].productiveAssignedCrewOnly;
                        map[hourKey].spots[spot[0]].productiveAssignedCrewOnlyFull += spot[1].productiveAssignedCrewOnlyFull;
                        map[hourKey].spots[spot[0]].totalPlanned += spot[1].totalPlanned;
                        map[hourKey].spots[spot[0]].totalPlannedFull += spot[1].totalPlannedFull;
                    });
                    
                }
                hourIter = nextHour;
            }



        });

        this.store.commit('setShiftTimeByHourMap', {shiftTimeByHourMap: map});

        return map;


    }

    calculateShiftTimeByHourMapDelta(map, oldDateKeys, newDateKeys,
        planShiftDateMap, actualShiftDateMap,
        planShiftMap, planShiftMomentMap,
        actualShiftMap, actualShiftMomentMap,
        actualBreakMap, actualBreakMomentMap,
        actualBreakShiftIdMap,
        employeeMap, spotMap, helpers) {

        let usedKeys = new Set();
        if(oldDateKeys != null){

            oldDateKeys.forEach(dk => {
                if(!usedKeys.has(dk)){
                    this.calculateShiftTimeByHourMapDeltaEntry(map, dk,
                                                            planShiftDateMap, actualShiftDateMap,
                                                             planShiftMap, planShiftMomentMap,
                                                             actualShiftMap, actualShiftMomentMap,
                                                             actualBreakMap, actualBreakMomentMap,
                                                             actualBreakShiftIdMap,
                                                             employeeMap,
                                                             spotMap, helpers);
                    usedKeys.add(dk);
                }

            })

        }
        if(newDateKeys != null){
            newDateKeys.forEach(dk => {
                if(!usedKeys.has(dk)){
                    this.calculateShiftTimeByHourMapDeltaEntry(map, dk,
                                                            planShiftDateMap, actualShiftDateMap,
                                                            planShiftMap, planShiftMomentMap,
                                                            actualShiftMap, actualShiftMomentMap,
                                                            actualBreakMap, actualBreakMomentMap,
                                                            actualBreakShiftIdMap,
                                                            employeeMap,
                                                            spotMap, helpers);
                    usedKeys.add(dk);
                }

            })
        }
        this.store.commit('setShiftTimeByHourMap', {shiftTimeByHourMap: map});

    }

    calculateShiftTimeByHourMapDeltaEntry(map, dateKey,
        planShiftDateMap, actualShiftDateMap,
        planShiftMap, planShiftMomentMap,
        actualShiftMap, actualShiftMomentMap,
        actualBreakMap, actualBreakMomentMap,
        actualBreakShiftIdMap,
        employeeMap, spotMap, helpers) {

        //first reset the hour entries of the next 48h, 48h because the shift can go beyond midnight
        let startDate = this.getMomentFromStringTZ(dateKey, "YYYY-MM-DD").clone();
        let dayIter = startDate.clone();
        let endDate = startDate.clone().add(2, 'days');

        while (dayIter < endDate) {
            let hourKey = dayIter.format("YYYY-MM-DD HH");

            map[hourKey] = {
                          totalPlanned: 0,
                          totalPlannedFull: 0,
                          totalAssigned: 0,
                          totalAssignedFull: 0,
                          totalActual: 0,
                          totalActualFull: 0,
                          totalAssignedCrewOnly: 0,
                          totalAssignedCrewOnlyFull: 0,
                          totalActualCrewOnly: 0,
                          totalActualCrewOnlyFull: 0,
                          productiveAssigned: 0,
                          productiveAssignedFull: 0,
                          productiveActual: 0,
                          productiveActualFull: 0,
                          productiveAssignedCrewOnly: 0,
                          productiveAssignedCrewOnlyFull: 0,
                          productiveActualCrewOnly: 0,
                          productiveActualCrewOnlyFull: 0,
                          spots: {},
                        };
            dayIter = dayIter.add(1, 'hours');
        }


        let prevDayKey = this.getMomentFromStringTZ(dateKey, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
        let nextDayKey = this.getMomentFromStringTZ(dateKey, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");



        if (actualShiftDateMap[prevDayKey]){
            //first do the shifts of previous day hat go over midnight
            actualShiftDateMap[prevDayKey].forEach(s => {
                let shiftMoment = actualShiftMomentMap[s.id];
                let from = shiftMoment.fromDate;
                let to = shiftMoment.toDate;

                if((employeeMap[s.employeeId] || s.employeeId == null) && from < endDate && to > startDate){
                    from = from < startDate ? startDate : from;
                    to = to > endDate ? endDate : to;

                    let hourIter = from.clone();
                    while(hourIter < to){
                        let nextHour = hourIter.clone().add(1, 'hours').startOf('hour');
                        if(nextHour > to){
                            nextHour = to;
                        }
                        let hourKey = hourIter.format("YYYY-MM-DD HH");
                        if(map[hourKey]){
                            let result = this.calculateShiftTimeHourActual(s, hourIter, nextHour, planShiftMap, actualBreakMomentMap, actualBreakShiftIdMap, employeeMap, spotMap, helpers);
                            map[hourKey].totalActual += result.totalActual;
                            map[hourKey].totalActualFull += result.totalActualFull;
                            map[hourKey].productiveActual += result.productiveActual;
                            map[hourKey].productiveActualFull += result.productiveActualFull;
                            map[hourKey].totalActualCrewOnly += result.totalActualCrewOnly;
                            map[hourKey].totalActualCrewOnlyFull += result.totalActualCrewOnlyFull;
                            map[hourKey].productiveActualCrewOnly += result.productiveActualCrewOnly;
                            map[hourKey].productiveActualCrewOnlyFull += result.productiveActualCrewOnlyFull;
                            Object.entries(result.spots).forEach(spot => {
                                if(!map[hourKey].spots[spot[0]]){
                                    map[hourKey].spots[spot[0]] = {
                                        totalPlanned: 0,
                                        totalPlannedFull: 0,
                                        totalAssigned: 0,
                                        totalAssignedFull: 0,
                                        totalActual: 0,
                                        totalActualFull: 0,
                                        totalAssignedCrewOnly: 0,
                                        totalAssignedCrewOnlyFull: 0,
                                        totalActualCrewOnly: 0,
                                        totalActualCrewOnlyFull: 0,
                                        productiveAssigned: 0,
                                        productiveAssignedFull: 0,
                                        productiveActual: 0,
                                        productiveActualFull: 0,
                                        productiveAssignedCrewOnly: 0,
                                        productiveAssignedCrewOnlyFull: 0,
                                        productiveActualCrewOnly: 0,
                                        productiveActualCrewOnlyFull: 0,
                                      };
                                }
                                map[hourKey].spots[spot[0]].totalActual += spot[1].totalActual;
                                map[hourKey].spots[spot[0]].totalActualFull += spot[1].totalActualFull;
                                map[hourKey].spots[spot[0]].productiveActual += spot[1].productiveActual;
                                map[hourKey].spots[spot[0]].productiveActualFull += spot[1].productiveActualFull;
                                map[hourKey].spots[spot[0]].totalActualCrewOnly += spot[1].totalActualCrewOnly;
                                map[hourKey].spots[spot[0]].totalActualCrewOnlyFull += spot[1].totalActualCrewOnlyFull;
                                map[hourKey].spots[spot[0]].productiveActualCrewOnly += spot[1].productiveActualCrewOnly;
                                map[hourKey].spots[spot[0]].productiveActualCrewOnlyFull += spot[1].productiveActualCrewOnlyFull;
                            });
                        }
                        hourIter = nextHour;
                    }
                }
            });
        }
        if (actualShiftDateMap[dateKey]){
            //then do the shifts of same day
            actualShiftDateMap[dateKey].forEach(s => {
                let shiftMoment = actualShiftMomentMap[s.id];
                let from = shiftMoment.fromDate;
                let to = shiftMoment.toDate;

                if((employeeMap[s.employeeId] || s.employeeId == null) && from < endDate && to > startDate){
                    from = from < startDate ? startDate : from;
                    to = to > endDate ? endDate : to;

                    let hourIter = from.clone();
                    while(hourIter < to){
                        let nextHour = hourIter.clone().add(1, 'hours').startOf('hour');
                        if(nextHour > to){
                            nextHour = to;
                        }
                        let hourKey = hourIter.format("YYYY-MM-DD HH");
                        if(map[hourKey]){
                            let result = this.calculateShiftTimeHourActual(s, hourIter, nextHour, planShiftMap, actualBreakMomentMap, actualBreakShiftIdMap, employeeMap, spotMap, helpers);
                            map[hourKey].totalActual += result.totalActual;
                            map[hourKey].totalActualFull += result.totalActualFull;
                            map[hourKey].productiveActual += result.productiveActual;
                            map[hourKey].productiveActualFull += result.productiveActualFull;
                            map[hourKey].totalActualCrewOnly += result.totalActualCrewOnly;
                            map[hourKey].totalActualCrewOnlyFull += result.totalActualCrewOnlyFull;
                            map[hourKey].productiveActualCrewOnly += result.productiveActualCrewOnly;
                            map[hourKey].productiveActualCrewOnlyFull += result.productiveActualCrewOnlyFull;
                            Object.entries(result.spots).forEach(spot => {
                                if(!map[hourKey].spots[spot[0]]){
                                    map[hourKey].spots[spot[0]] = {
                                        totalPlanned: 0,
                                        totalPlannedFull: 0,
                                        totalAssigned: 0,
                                        totalAssignedFull: 0,
                                        totalActual: 0,
                                        totalActualFull: 0,
                                        totalAssignedCrewOnly: 0,
                                        totalAssignedCrewOnlyFull: 0,
                                        totalActualCrewOnly: 0,
                                        totalActualCrewOnlyFull: 0,
                                        productiveAssigned: 0,
                                        productiveAssignedFull: 0,
                                        productiveActual: 0,
                                        productiveActualFull: 0,
                                        productiveAssignedCrewOnly: 0,
                                        productiveAssignedCrewOnlyFull: 0,
                                        productiveActualCrewOnly: 0,
                                        productiveActualCrewOnlyFull: 0,
                                      };
                                }
                                map[hourKey].spots[spot[0]].totalActual += spot[1].totalActual;
                                map[hourKey].spots[spot[0]].totalActualFull += spot[1].totalActualFull;
                                map[hourKey].spots[spot[0]].productiveActual += spot[1].productiveActual;
                                map[hourKey].spots[spot[0]].productiveActualFull += spot[1].productiveActualFull;
                                map[hourKey].spots[spot[0]].totalActualCrewOnly += spot[1].totalActualCrewOnly;
                                map[hourKey].spots[spot[0]].totalActualCrewOnlyFull += spot[1].totalActualCrewOnlyFull;
                                map[hourKey].spots[spot[0]].productiveActualCrewOnly += spot[1].productiveActualCrewOnly;
                                map[hourKey].spots[spot[0]].productiveActualCrewOnlyFull += spot[1].productiveActualCrewOnlyFull;
                            });
                        }
                        hourIter = nextHour;
                    }
                }
            });
        }
        if (actualShiftDateMap[nextDayKey]){
            //then do the shifts of next day
            actualShiftDateMap[nextDayKey].forEach(s => {
                let shiftMoment = actualShiftMomentMap[s.id];
                let from = shiftMoment.fromDate;
                let to = shiftMoment.toDate;

                if((employeeMap[s.employeeId] || s.employeeId == null) && from < endDate && to > startDate){
                    from = from < startDate ? startDate : from;
                    to = to > endDate ? endDate : to;

                    let hourIter = from.clone();
                    while(hourIter < to){
                        let nextHour = hourIter.clone().add(1, 'hours').startOf('hour');
                        if(nextHour > to){
                            nextHour = to;
                        }
                        let hourKey = hourIter.format("YYYY-MM-DD HH");
                        if(map[hourKey]){
                            let result = this.calculateShiftTimeHourActual(s, hourIter, nextHour, planShiftMap, actualBreakMomentMap, actualBreakShiftIdMap, employeeMap, spotMap, helpers);
                            map[hourKey].totalActual += result.totalActual;
                            map[hourKey].totalActualFull += result.totalActualFull;
                            map[hourKey].productiveActual += result.productiveActual;
                            map[hourKey].productiveActualFull += result.productiveActualFull;
                            map[hourKey].totalActualCrewOnly += result.totalActualCrewOnly;
                            map[hourKey].totalActualCrewOnlyFull += result.totalActualCrewOnlyFull;
                            map[hourKey].productiveActualCrewOnly += result.productiveActualCrewOnly;
                            map[hourKey].productiveActualCrewOnlyFull += result.productiveActualCrewOnlyFull;
                            Object.entries(result.spots).forEach(spot => {
                                if(!map[hourKey].spots[spot[0]]){
                                    map[hourKey].spots[spot[0]] = {
                                        totalPlanned: 0,
                                        totalPlannedFull: 0,
                                        totalAssigned: 0,
                                        totalAssignedFull: 0,
                                        totalActual: 0,
                                        totalActualFull: 0,
                                        totalAssignedCrewOnly: 0,
                                        totalAssignedCrewOnlyFull: 0,
                                        totalActualCrewOnly: 0,
                                        totalActualCrewOnlyFull: 0,
                                        productiveAssigned: 0,
                                        productiveAssignedFull: 0,
                                        productiveActual: 0,
                                        productiveActualFull: 0,
                                        productiveAssignedCrewOnly: 0,
                                        productiveAssignedCrewOnlyFull: 0,
                                        productiveActualCrewOnly: 0,
                                        productiveActualCrewOnlyFull: 0,
                                      };
                                }
                                map[hourKey].spots[spot[0]].totalActual += spot[1].totalActual;
                                map[hourKey].spots[spot[0]].totalActualFull += spot[1].totalActualFull;
                                map[hourKey].spots[spot[0]].productiveActual += spot[1].productiveActual;
                                map[hourKey].spots[spot[0]].productiveActualFull += spot[1].productiveActualFull;
                                map[hourKey].spots[spot[0]].totalActualCrewOnly += spot[1].totalActualCrewOnly;
                                map[hourKey].spots[spot[0]].totalActualCrewOnlyFull += spot[1].totalActualCrewOnlyFull;
                                map[hourKey].spots[spot[0]].productiveActualCrewOnly += spot[1].productiveActualCrewOnly;
                                map[hourKey].spots[spot[0]].productiveActualCrewOnlyFull += spot[1].productiveActualCrewOnlyFull;
                            });
                        }
                        hourIter = nextHour;
                    }
                }
            });
        }
        //now planshifts too
        if (planShiftDateMap[prevDayKey]){
            //first do the shifts of previous day hat go over midnight
            planShiftDateMap[prevDayKey].forEach(s => {
                let shiftMoment = planShiftMomentMap[s.id];
                let from = shiftMoment.fromDate;
                let to = shiftMoment.toDate;

                if((employeeMap[s.employeeId] || s.employeeId == null) && from < endDate && to > startDate){
                    from = from < startDate ? startDate : from;
                    to = to > endDate ? endDate : to;

                    let hourIter = from.clone();
                    while(hourIter < to){
                        let nextHour = hourIter.clone().add(1, 'hours').startOf('hour');
                        if(nextHour > to){
                            nextHour = to;
                        }
                        let hourKey = hourIter.format("YYYY-MM-DD HH");
                        if(map[hourKey]){
                            let result = this.calculateShiftTimeHourPlanned(s, hourIter, nextHour, shiftMoment.fromDate, shiftMoment.toDate, employeeMap, spotMap, helpers);
                            map[hourKey].totalAssigned += result.totalAssigned;
                            map[hourKey].totalAssignedFull += result.totalAssignedFull;
                            map[hourKey].productiveAssigned += result.productiveAssigned;
                            map[hourKey].productiveAssignedFull += result.productiveAssignedFull;
                            map[hourKey].totalAssignedCrewOnly += result.totalAssignedCrewOnly;
                            map[hourKey].totalAssignedCrewOnlyFull += result.totalAssignedCrewOnlyFull;
                            map[hourKey].productiveAssignedCrewOnly += result.productiveAssignedCrewOnly;
                            map[hourKey].productiveAssignedCrewOnlyFull += result.productiveAssignedCrewOnlyFull;
                            map[hourKey].totalPlanned += result.totalPlanned;
                            map[hourKey].totalPlannedFull += result.totalPlannedFull;
                            Object.entries(result.spots).forEach(spot => {
                                if(!map[hourKey].spots[spot[0]]){
                                    map[hourKey].spots[spot[0]] = {
                                        totalPlanned: 0,
                                        totalPlannedFull: 0,
                                        totalAssigned: 0,
                                        totalAssignedFull: 0,
                                        totalActual: 0,
                                        totalActualFull: 0,
                                        totalAssignedCrewOnly: 0,
                                        totalAssignedCrewOnlyFull: 0,
                                        totalActualCrewOnly: 0,
                                        totalActualCrewOnlyFull: 0,
                                        productiveAssigned: 0,
                                        productiveAssignedFull: 0,
                                        productiveActual: 0,
                                        productiveActualFull: 0,
                                        productiveAssignedCrewOnly: 0,
                                        productiveAssignedCrewOnlyFull: 0,
                                        productiveActualCrewOnly: 0,
                                        productiveActualCrewOnlyFull: 0,
                                      };
                                }
                                map[hourKey].spots[spot[0]].totalAssigned += spot[1].totalAssigned;
                                map[hourKey].spots[spot[0]].totalAssignedFull += spot[1].totalAssignedFull;
                                map[hourKey].spots[spot[0]].productiveAssigned += spot[1].productiveAssigned;
                                map[hourKey].spots[spot[0]].productiveAssignedFull += spot[1].productiveAssignedFull;
                                map[hourKey].spots[spot[0]].totalAssignedCrewOnly += spot[1].totalAssignedCrewOnly;
                                map[hourKey].spots[spot[0]].totalAssignedCrewOnlyFull += spot[1].totalAssignedCrewOnlyFull;
                                map[hourKey].spots[spot[0]].productiveAssignedCrewOnly += spot[1].productiveAssignedCrewOnly;
                                map[hourKey].spots[spot[0]].productiveAssignedCrewOnlyFull += spot[1].productiveAssignedCrewOnlyFull;
                                map[hourKey].spots[spot[0]].totalPlanned += spot[1].totalPlanned;
                                map[hourKey].spots[spot[0]].totalPlannedFull += spot[1].totalPlannedFull;
                            });
                        }
                        hourIter = nextHour;
                    }
                }
            });
        }
        if (planShiftDateMap[dateKey]){
            //then do the shifts of same day
            planShiftDateMap[dateKey].forEach(s => {
                let shiftMoment = planShiftMomentMap[s.id];
                let from = shiftMoment.fromDate;
                let to = shiftMoment.toDate;

                if((employeeMap[s.employeeId] || s.employeeId == null) && from < endDate && to > startDate){
                    from = from < startDate ? startDate : from;
                    to = to > endDate ? endDate : to;

                    let hourIter = from.clone();
                    while(hourIter < to){
                        let nextHour = hourIter.clone().add(1, 'hours').startOf('hour');
                        if(nextHour > to){
                            nextHour = to;
                        }
                        let hourKey = hourIter.format("YYYY-MM-DD HH");
                        if(map[hourKey]){
                            let result = this.calculateShiftTimeHourPlanned(s, hourIter, nextHour, shiftMoment.fromDate, shiftMoment.toDate, employeeMap, spotMap, helpers);
                            map[hourKey].totalAssigned += result.totalAssigned;
                            map[hourKey].totalAssignedFull += result.totalAssignedFull;
                            map[hourKey].productiveAssigned += result.productiveAssigned;
                            map[hourKey].productiveAssignedFull += result.productiveAssignedFull;
                            map[hourKey].totalAssignedCrewOnly += result.totalAssignedCrewOnly;
                            map[hourKey].totalAssignedCrewOnlyFull += result.totalAssignedCrewOnlyFull;
                            map[hourKey].productiveAssignedCrewOnly += result.productiveAssignedCrewOnly;
                            map[hourKey].productiveAssignedCrewOnlyFull += result.productiveAssignedCrewOnlyFull;
                            map[hourKey].totalPlanned += result.totalPlanned;
                            map[hourKey].totalPlannedFull += result.totalPlannedFull;
                            Object.entries(result.spots).forEach(spot => {
                                if(!map[hourKey].spots[spot[0]]){
                                    map[hourKey].spots[spot[0]] = {
                                        totalPlanned: 0,
                                        totalPlannedFull: 0,
                                        totalAssigned: 0,
                                        totalAssignedFull: 0,
                                        totalActual: 0,
                                        totalActualFull: 0,
                                        totalAssignedCrewOnly: 0,
                                        totalAssignedCrewOnlyFull: 0,
                                        totalActualCrewOnly: 0,
                                        totalActualCrewOnlyFull: 0,
                                        productiveAssigned: 0,
                                        productiveAssignedFull: 0,
                                        productiveActual: 0,
                                        productiveActualFull: 0,
                                        productiveAssignedCrewOnly: 0,
                                        productiveAssignedCrewOnlyFull: 0,
                                        productiveActualCrewOnly: 0,
                                        productiveActualCrewOnlyFull: 0,
                                      };
                                }
                                map[hourKey].spots[spot[0]].totalAssigned += spot[1].totalAssigned;
                                map[hourKey].spots[spot[0]].totalAssignedFull += spot[1].totalAssignedFull;
                                map[hourKey].spots[spot[0]].productiveAssigned += spot[1].productiveAssigned;
                                map[hourKey].spots[spot[0]].productiveAssignedFull += spot[1].productiveAssignedFull;
                                map[hourKey].spots[spot[0]].totalAssignedCrewOnly += spot[1].totalAssignedCrewOnly;
                                map[hourKey].spots[spot[0]].totalAssignedCrewOnlyFull += spot[1].totalAssignedCrewOnlyFull;
                                map[hourKey].spots[spot[0]].productiveAssignedCrewOnly += spot[1].productiveAssignedCrewOnly;
                                map[hourKey].spots[spot[0]].productiveAssignedCrewOnlyFull += spot[1].productiveAssignedCrewOnlyFull;
                                map[hourKey].spots[spot[0]].totalPlanned += spot[1].totalPlanned;
                                map[hourKey].spots[spot[0]].totalPlannedFull += spot[1].totalPlannedFull;
                            });
                        }
                        hourIter = nextHour;
                    }
                }
            });
        }
        if (planShiftDateMap[nextDayKey]){
            //then do the shifts of next day
            planShiftDateMap[nextDayKey].forEach(s => {
                let shiftMoment = planShiftMomentMap[s.id];
                let from = shiftMoment.fromDate;
                let to = shiftMoment.toDate;

                if((employeeMap[s.employeeId] || s.employeeId == null) && from < endDate && to > startDate){
                    from = from < startDate ? startDate : from;
                    to = to > endDate ? endDate : to;

                    let hourIter = from.clone();
                    while(hourIter < to){
                        let nextHour = hourIter.clone().add(1, 'hours').startOf('hour');
                        if(nextHour > to){
                            nextHour = to;
                        }
                        let hourKey = hourIter.format("YYYY-MM-DD HH");
                        if(map[hourKey]){
                            let result = this.calculateShiftTimeHourPlanned(s, hourIter, nextHour, shiftMoment.fromDate, shiftMoment.toDate, employeeMap, spotMap, helpers);
                            map[hourKey].totalAssigned += result.totalAssigned;
                            map[hourKey].totalAssignedFull += result.totalAssignedFull;
                            map[hourKey].productiveAssigned += result.productiveAssigned;
                            map[hourKey].productiveAssignedFull += result.productiveAssignedFull;
                            map[hourKey].totalAssignedCrewOnly += result.totalAssignedCrewOnly;
                            map[hourKey].totalAssignedCrewOnlyFull += result.totalAssignedCrewOnlyFull;
                            map[hourKey].productiveAssignedCrewOnly += result.productiveAssignedCrewOnly;
                            map[hourKey].productiveAssignedCrewOnlyFull += result.productiveAssignedCrewOnlyFull;
                            map[hourKey].totalPlanned += result.totalPlanned;
                            map[hourKey].totalPlannedFull += result.totalPlannedFull;
                            Object.entries(result.spots).forEach(spot => {
                                if(!map[hourKey].spots[spot[0]]){
                                    map[hourKey].spots[spot[0]] = {
                                        totalPlanned: 0,
                                        totalPlannedFull: 0,
                                        totalAssigned: 0,
                                        totalAssignedFull: 0,
                                        totalActual: 0,
                                        totalActualFull: 0,
                                        totalAssignedCrewOnly: 0,
                                        totalAssignedCrewOnlyFull: 0,
                                        totalActualCrewOnly: 0,
                                        totalActualCrewOnlyFull: 0,
                                        productiveAssigned: 0,
                                        productiveAssignedFull: 0,
                                        productiveActual: 0,
                                        productiveActualFull: 0,
                                        productiveAssignedCrewOnly: 0,
                                        productiveAssignedCrewOnlyFull: 0,
                                        productiveActualCrewOnly: 0,
                                        productiveActualCrewOnlyFull: 0,
                                      };
                                }
                                map[hourKey].spots[spot[0]].totalAssigned += spot[1].totalAssigned;
                                map[hourKey].spots[spot[0]].totalAssignedFull += spot[1].totalAssignedFull;
                                map[hourKey].spots[spot[0]].productiveAssigned += spot[1].productiveAssigned;
                                map[hourKey].spots[spot[0]].productiveAssignedFull += spot[1].productiveAssignedFull;
                                map[hourKey].spots[spot[0]].totalAssignedCrewOnly += spot[1].totalAssignedCrewOnly;
                                map[hourKey].spots[spot[0]].totalAssignedCrewOnlyFull += spot[1].totalAssignedCrewOnlyFull;
                                map[hourKey].spots[spot[0]].productiveAssignedCrewOnly += spot[1].productiveAssignedCrewOnly;
                                map[hourKey].spots[spot[0]].productiveAssignedCrewOnlyFull += spot[1].productiveAssignedCrewOnlyFull;
                                map[hourKey].spots[spot[0]].totalPlanned += spot[1].totalPlanned;
                                map[hourKey].spots[spot[0]].totalPlannedFull += spot[1].totalPlannedFull;
                            });
                        }
                        hourIter = nextHour;
                    }
                }
            });
        }

        return map;


    }

    calculateShiftTimeHourActual(s, from, to, planShiftMap, actualBreakMomentMap, actualBreakShiftIdMap, employeeMap, spotMap, helpers) {
        let ps = planShiftMap[s.planshiftId] ? planShiftMap[s.planshiftId] : null;
        let shiftSpot = ps != null ? (spotMap[ps.spotId] ? spotMap[ps.spotId] : null) : null;
        let employeeMainSpot = employeeMap[s.employeeId] ? (spotMap[employeeMap[s.employeeId].spotId] ? spotMap[employeeMap[s.employeeId].spotId] : null): null;

        let productive = shiftSpot != null ? shiftSpot.productive : (employeeMainSpot != null ? employeeMainSpot.productive : true);

        if (shiftSpot == null) {
            // if shift has no spot, assume the employee's main spot is the shift spot
            shiftSpot = employeeMainSpot ? employeeMainSpot : {id: "0"};
        }

        let timeAggregation = helpers.GetMillisecondTotalObjectFromMoments(from, to); //this adds 2ms
        let fullShift = timeAggregation.total;

        let result = {
            totalPlanned: 0,
            totalPlannedFull: 0,
            totalAssigned: 0,
            totalAssignedFull: 0,
            totalActual: 0,
            totalActualFull: 0,
            totalAssignedCrewOnly: 0,
            totalAssignedCrewOnlyFull: 0,
            totalActualCrewOnly: 0,
            totalActualCrewOnlyFull: 0,
            productiveAssigned: 0,
            productiveAssignedFull: 0,
            productiveActual: 0,
            productiveActualFull: 0,
            productiveAssignedCrewOnly: 0,
            productiveAssignedCrewOnlyFull: 0,
            productiveActualCrewOnly: 0,
            productiveActualCrewOnlyFull: 0,
            spots: {},
        }
        if (shiftSpot) {
            result.spots[shiftSpot.id] = {
                totalPlanned: 0,
                totalPlannedFull: 0,
                totalAssigned: 0,
                totalAssignedFull: 0,
                totalActual: 0,
                totalActualFull: 0,
                totalAssignedCrewOnly: 0,
                totalAssignedCrewOnlyFull: 0,
                totalActualCrewOnly: 0,
                totalActualCrewOnlyFull: 0,
                productiveAssigned: 0,
                productiveAssignedFull: 0,
                productiveActual: 0,
                productiveActualFull: 0,
                productiveAssignedCrewOnly: 0,
                productiveAssignedCrewOnlyFull: 0,
                productiveActualCrewOnly: 0,
                productiveActualCrewOnlyFull: 0,
            }
        }
        if (actualBreakShiftIdMap[s.id] && actualBreakShiftIdMap[s.id].length > 0){
            let breaks = actualBreakShiftIdMap[s.id];

            breaks.forEach(b => {
                let breakMoment = actualBreakMomentMap[b.id];
                let breakFrom = breakMoment.fromDate;
                let breakTo = breakMoment.toDate;
                if(breakFrom < to && breakTo > from){
                    let f = breakFrom > from ? breakFrom : from;
                    let t = breakTo < to ? breakTo : to;
                    timeAggregation.total -= Math.max(0, helpers.GetMillisecondTotalObjectFromMoments(f, t).total);
                }


            });


        }
        result.totalActual = timeAggregation.total;
        result.totalActualFull = fullShift;
        if(productive){
           result.productiveActual = timeAggregation.total;
           result.productiveActualFull = fullShift;
        }
        if (shiftSpot) {
            result.spots[shiftSpot.id].totalActual = timeAggregation.total;
            result.spots[shiftSpot.id].totalActualFull = fullShift;
            if(productive){
                result.spots[shiftSpot.id].productiveActual = timeAggregation.total;
                result.spots[shiftSpot.id].productiveActualFull = fullShift;
            }
        }


        if(employeeMainSpot == null || employeeMainSpot == undefined || employeeMainSpot.employeeLevel == 1){ // include all spots with level "Crew" and scenarios where spot is null (can this happen?)
            result.totalActualCrewOnly = timeAggregation.total;
            result.totalActualCrewOnlyFull = fullShift;
            if(productive){
                result.productiveActualCrewOnly = timeAggregation.total;
                result.productiveActualCrewOnlyFull = fullShift;
            }
            if (shiftSpot) {
                result.spots[shiftSpot.id].totalActualCrewOnly = timeAggregation.total;
                result.spots[shiftSpot.id].totalActualCrewOnlyFull = fullShift;
                if(productive){
                    result.spots[shiftSpot.id].productiveActualCrewOnly = timeAggregation.total;
                    result.spots[shiftSpot.id].productiveActualCrewOnlyFull = fullShift;
                }
            }
        }

        return result;


    }

    calculateShiftTimeHourPlanned(s, from, to, startOfShift, endOfShift, employeeMap, spotMap, helpers) {


        let shiftSpot = spotMap[s.spotId] ? spotMap[s.spotId] : null;

        let result = {
            totalPlanned: 0,
            totalPlannedFull: 0,
            totalAssigned: 0,
            totalAssignedFull: 0,
            totalActual: 0,
            totalActualFull: 0,
            totalAssignedCrewOnly: 0,
            totalAssignedCrewOnlyFull: 0,
            totalActualCrewOnly: 0,
            totalActualCrewOnlyFull: 0,
            productiveAssigned: 0,
            productiveAssignedFull: 0,
            productiveActual: 0,
            productiveActualFull: 0,
            productiveAssignedCrewOnly: 0,
            productiveAssignedCrewOnlyFull: 0,
            productiveActualCrewOnly: 0,
            productiveActualCrewOnlyFull: 0,
            spots: {},
        }
        result.spots[shiftSpot.id] = {
            totalPlanned: 0,
            totalPlannedFull: 0,
            totalAssigned: 0,
            totalAssignedFull: 0,
            totalActual: 0,
            totalActualFull: 0,
            totalAssignedCrewOnly: 0,
            totalAssignedCrewOnlyFull: 0,
            totalActualCrewOnly: 0,
            totalActualCrewOnlyFull: 0,
            productiveAssigned: 0,
            productiveAssignedFull: 0,
            productiveActual: 0,
            productiveActualFull: 0,
            productiveAssignedCrewOnly: 0,
            productiveAssignedCrewOnlyFull: 0,
            productiveActualCrewOnly: 0,
            productiveActualCrewOnlyFull: 0,
        }

        let timeAggregation = helpers.GetMillisecondTotalObjectFromMoments(from, to); //this adds 2ms
        let fullShift = timeAggregation.total;

        if (s.breakValue && s.breakValue > 0){
            let breakFrom = null;
            if(s.breakFrom != null){
                breakFrom = helpers.getMomentFromStringTZ(s.breakFrom);
                let breakTo = breakFrom.clone().add(s.breakValue, 'minutes');
                if(breakFrom < to && breakTo > from){
                    let f = breakFrom > from ? breakFrom : from;
                    let t = breakTo < to ? breakTo : to;
                    timeAggregation.total -= Math.max(0, helpers.GetMillisecondTotalObjectFromMoments(f, t).total);
                }
            } else {
                let totalShiftLength = Math.max(0, endOfShift._d.getTime() - startOfShift._d.getTime());
                let breakValuePortion = Math.max(0, s.breakValue * 60 * 1000 * (timeAggregation.total/ totalShiftLength));

                timeAggregation.total = timeAggregation.total - breakValuePortion;
                
                

            }


        }
        if(s.employeeId){
            let employeeMainSpot = employeeMap[s.employeeId] ? (spotMap[employeeMap[s.employeeId].spotId] ? spotMap[employeeMap[s.employeeId].spotId] : null): null;
            let productive = shiftSpot != null ? shiftSpot.productive : (employeeMainSpot != null ? employeeMainSpot.productive : true);

            result.totalAssigned = timeAggregation.total;
            result.totalAssignedFull = fullShift;
            if(productive){
                result.productiveAssigned = timeAggregation.total;
                result.productiveAssignedFull = fullShift;
            }
            result.spots[shiftSpot.id].totalAssigned = timeAggregation.total;
            result.spots[shiftSpot.id].totalAssignedFull = fullShift;
            if(productive){
                result.spots[shiftSpot.id].productiveAssigned = timeAggregation.total;
                result.spots[shiftSpot.id].productiveAssignedFull = fullShift;
            }

            if(employeeMainSpot == null || employeeMainSpot == undefined || employeeMainSpot.employeeLevel == 1){ // include all spots with level "Crew" and scenarios where spot is null (can this happen?)
                result.totalAssignedCrewOnly = timeAggregation.total;
                result.totalAssignedCrewOnlyFull = fullShift;
                if(productive){
                    result.productiveAssignedCrewOnly = timeAggregation.total;
                    result.productiveAssignedCrewOnlyFull = fullShift;
                }
                result.spots[shiftSpot.id].totalAssignedCrewOnly = timeAggregation.total;
                result.spots[shiftSpot.id].totalAssignedCrewOnlyFull = fullShift;
                if(productive){
                    result.spots[shiftSpot.id].productiveAssignedCrewOnly = timeAggregation.total;
                    result.spots[shiftSpot.id].productiveAssignedCrewOnlyFull = fullShift;
                }

            }
        }  else {

            result.totalPlanned = timeAggregation.total;
            result.totalPlannedFull = fullShift;
            result.spots[shiftSpot.id].totalPlanned = timeAggregation.total;
            result.spots[shiftSpot.id].totalPlannedFull = fullShift;

        }

        return result;
    }

    calculatePlanTypeLimits(employee, employeeTypeMap) {
        let limits = {
            planTypeFound: false,
            planType_dayTimeMax: 43200,
            planType_restTime: 39600,
            planType_shiftBetweenTimeMin: 39600,
            planType_shiftBetweenTimeMax: -1,
            planType_weekSpareDaysMin: 1,
            planType_weekSpareTimeMin: 129600,
            planType_weekTimeMax: 216000,
            planType_allowPartialShifts: false,
            planType_daysConsecutiveMax: null
        }

        if (employee.typeId != undefined && employee.typeId != null && employeeTypeMap[employee.typeId] != undefined && employeeTypeMap[employee.typeId] != null) {
            limits.planTypeFound = true;
            let plantype = employeeTypeMap[employee.typeId];
            limits.planType_dayTimeMax = plantype.dayTimeMax * 60; // checked
            limits.planType_restTime = plantype.restTime * 60; // checked
            limits.planType_weekSpareDaysMin = plantype.weekSpareDaysMin;
            limits.planType_weekSpareTimeMin = plantype.weekSpareTimeMin * 60;
            limits.planType_weekTimeMax = plantype.weekTimeMax * 60; // checked
            if (plantype.shiftBetweenTimeMin > -1) {
                limits.planType_allowPartialShifts = true;
                limits.planType_shiftBetweenTimeMin = plantype.shiftBetweenTimeMin * 60;
                limits.planType_shiftBetweenTimeMax = plantype.shiftBetweenTimeMax * 60
            }
            limits.planType_daysConsecutiveMax = plantype.daysConsecutiveMax;
        }

        return limits;
    }

    calculateOvertimeCutoffs(contract, storeSettings){
        let dailyOverTimeCutoff = contract.overtimeCutoff;
        
        if(!storeSettings.allowShiftOvertime && storeSettings.shiftOvertimeOverride > 0){
            dailyOverTimeCutoff = storeSettings.shiftOvertimeOverride;
        }
        let weeklyOvertimeCutoff = contract.weeklyOvertimeCutoff
        
       
        if(!storeSettings.allowWeeklyOvertime && storeSettings.weekOvertimeOverride > 0){
            weeklyOvertimeCutoff = storeSettings.weekOvertimeOverride;
        }
        return {overtimeCutoff: dailyOverTimeCutoff, weeklyOvertimeCutoff: weeklyOvertimeCutoff}
    }
    calculateContractLimits(employee, employeeIdContractMap, allowedContractMap, collectiveContractMap, storeSettings, monthFrom, monthTo) {
        let limits = {
            collectiveContractFound: false,
            contract_dayTimeMax: 43200,
            contract_restTime: storeSettings.country == 1 ? 39600 : 43200,
            contract_weekSpareDaysMin: 1,
            contract_weekSpareTimeMin: 129600,
            contract_weekTimeMax: 216000,
            contract_weeklyOvertimeCutoff: 144000,
            contract_overtimeCutoff: 28800,
            allowPartialShifts: false,
            contract_daysConsecutiveMax: null,
            employeeContractMomentMap: {},
        }
        if(storeSettings.country == 8){
            limits.contract_daysConsecutiveMax = 6;
        }

        let prevContractFrom = null;
        let prevInMonth = true;
        employeeIdContractMap[employee.id].forEach(employeeContract => {

            let contractFrom = this.getMomentFromStringTZ(employeeContract.from);
            let contractTo = employeeContract.to ? this.getMomentFromStringTZ(employeeContract.to) : null;
            let inMonth = (contractFrom < monthTo && (contractTo == null || contractTo > monthFrom));
            limits.employeeContractMomentMap[employeeContract.id] = {
                from: contractFrom,
                to: contractTo
            };
            if(prevContractFrom  == null || inMonth){


                if (prevContractFrom == null || contractFrom > prevContractFrom || !prevInMonth) {

                    let otc = this.calculateOvertimeCutoffs(employeeContract, storeSettings);

                    limits.contract_weeklyOvertimeCutoff = otc.weeklyOvertimeCutoff * 60;
                    limits.contract_overtimeCutoff = otc.overtimeCutoff * 60;
                    if (employeeContract.collectiveContractId != undefined && employeeContract.collectiveContractId != null) {

                        limits.collectiveContractFound = true;

                        let allowedContract = allowedContractMap[employeeContract.collectiveContractId];
                        let contract = collectiveContractMap[allowedContract.collectiveContractId];

                        limits.contract_dayTimeMax = contract.dayTimeMax * 60;
                        limits.contract_restTime = contract.restTime * 60;
                        limits.contract_weekSpareDaysMin = contract.weekSpareDaysMin;
                        limits.contract_weekSpareTimeMin = contract.weekSpareTimeMin * 60;
                        limits.contract_weekTimeMax = contract.weekTimeMax * 60;
                    }
                    if (employeeContract.allowPartialShifts) {
                        limits.allowPartialShifts = true;
                    }
                    prevContractFrom = contractFrom;
                    prevInMonth = inMonth;
                }
            }

        });

        return limits;
    }

    calculateRequiredBreakCounts(shift, shiftStart, shiftEnd, actualBreakShiftIdMap, actualBreakMomentMap, storeSettings) {
        /* Block to calculate how many required rest times are done */
        let counts = {
            shiftStart: shiftStart,
            actualShiftDuration: 0,
            countFifteenMinutePauses: 0,
            countThirtyMinutePauses: 0,
            countFortyFiveMinutePauses: 0,
            countSixtyMinutePauses: 0,
            mainPauseBegunWithinSixHours: false,
            mainPauseBegunWithinFourPointFiveHours: false,
            mainPauseBegunWithinFourHours: false,
        }

        counts.actualShiftDuration = shiftEnd - shiftStart;
        for (let j in actualBreakShiftIdMap[shift.id]) {
            let actualBreak = actualBreakShiftIdMap[shift.id][j];
            let breakTime = actualBreakMomentMap[actualBreak.id].toDate - actualBreakMomentMap[actualBreak.id].fromDate;


            if (breakTime >= 900000) { // 15 Minutes => 15 * 60 * 1000 -> subtract from shift duration
                counts.actualShiftDuration = Math.max(0, counts.actualShiftDuration - breakTime);
            }
            if (breakTime >= 3600000) { // 45 Minutes => 45 * 60 * 1000
                let diffToStart = actualBreakMomentMap[actualBreak.id].fromDate - shiftStart;
                counts.countSixtyMinutePauses++;
                if (diffToStart <= 14400000) {
                    counts.mainPauseBegunWithinFourHours = true;
                    counts.mainPauseBegunWithinFourPointFiveHours = true;
                    counts.mainPauseBegunWithinSixHours = true;
                } else if (diffToStart <= 16200000) {
                    counts.mainPauseBegunWithinFourPointFiveHours = true;
                    counts.mainPauseBegunWithinSixHours = true;
                } else if (diffToStart <= 21600000) {
                    counts.mainPauseBegunWithinSixHours = true;
                }
            } else if (breakTime >= 2700000) { // 45 Minutes => 45 * 60 * 1000
                let diffToStart = actualBreakMomentMap[actualBreak.id].fromDate - shiftStart;
                counts.countFortyFiveMinutePauses++;
                if (diffToStart <= 14400000) {
                    counts.mainPauseBegunWithinFourHours = true;
                    counts.mainPauseBegunWithinFourPointFiveHours = true;
                    counts.mainPauseBegunWithinSixHours = true;
                } else if (diffToStart <= 16200000) {
                    counts.mainPauseBegunWithinFourPointFiveHours = true;
                    counts.mainPauseBegunWithinSixHours = true;
                } else if (diffToStart <= 21600000) {
                    counts.mainPauseBegunWithinSixHours = true;
                }
            } else if (breakTime >= 1800000) { // 30 Minutes => 30 * 60 * 1000
                let diffToStart = actualBreakMomentMap[actualBreak.id].fromDate - shiftStart;
                counts.countThirtyMinutePauses++;
                if (diffToStart <= 14400000) {
                    counts.mainPauseBegunWithinFourHours = true;
                    counts.mainPauseBegunWithinFourPointFiveHours = true;
                    counts.mainPauseBegunWithinSixHours = true;
                } else if (diffToStart <= 16200000) {
                    counts.mainPauseBegunWithinFourPointFiveHours = true;
                    counts.mainPauseBegunWithinSixHours = true;
                } else if (diffToStart <= 21600000) {
                    counts.mainPauseBegunWithinSixHours = true;
                }
            } else if (breakTime >= 900000) { // 15 Minutes => 15 * 60 * 1000
                if(storeSettings.country == 2 || storeSettings.country == 8){
                    let diffToStart = actualBreakMomentMap[actualBreak.id].fromDate - shiftStart;
                    if (diffToStart <= 14400000) {
                        counts.mainPauseBegunWithinFourHours = true;
                        counts.mainPauseBegunWithinFourPointFiveHours = true;
                        counts.mainPauseBegunWithinSixHours = true;
                    } else if (diffToStart <= 16200000) {
                        counts.mainPauseBegunWithinFourPointFiveHours = true;
                        counts.mainPauseBegunWithinSixHours = true;
                    } else if (diffToStart <= 21600000) {
                        counts.mainPauseBegunWithinSixHours = true;
                    }
                }
                counts.countFifteenMinutePauses++;
            }
        }
        return counts;
    }

    calculateUnderageStats(today, birthday, youthWorkRules) {
        let stats = {
            underage: false,
            below15: false,
            over16: true,
            rule : null
        }

        if (birthday) {
            let age = today.diff(birthday, 'years');

            if (age < 18) {
                stats.underage = true;
                stats.over16 = false;
            }
            if (age < 15) {
                stats.below15 = true;
            }
            if (age > 15) {
                stats.over16 = true;
            }

            if(youthWorkRules){
                let rule = null;
                youthWorkRules.forEach(r => {

                    if(age < r.maxAge && (rule == null || r.maxAge < rule.maxAge)){
                        rule = r;
                    }
                })
                stats.rule = rule;
            }

        }
        return stats;
    }

    calculateWorkValueData(shift, shiftStart, shiftEnd, isPlanShift, actualBreakShiftIdMap, actualBreakMomentMap, planShiftMomentMap, workDayCalcMode = 2, storeSettings, helpers) {
        let workValueData = {
            workValue: 0,
            dayWorkValues: {},
            weekWorkValues: {},
            weekOvertimeWorkValues: {}
        }
        let workValue = 0;
        let midnight = shiftStart.clone().add(1, 'days').startOf('day');
        if(shiftEnd > midnight){
            let ds = shiftStart.clone();
            while(ds < shiftEnd){
                let dayKey = ds.format("YYYY-MM-DD");
                let weekKey = ds.isoWeek();
                midnight = ds.clone().add(1, 'days').startOf('day');
                if(midnight > shiftEnd){
                    midnight = shiftEnd;
                }
                let dayWorkValue = midnight.diff(ds, 'minutes');

                if(isPlanShift){
                    if (shift.workValue == -1) {

                        if(shift.breakValue > 0){
                            let breakFrom = null;
                            let breakTo = null;
                            if(shift.breakFrom != null){
                                breakFrom = this.getMomentFromStringTZ(shift.breakFrom);
                            } else {
                                breakFrom = shiftStart.clone().add(shiftEnd.diff(shiftStart, 'minutes')/2, 'minutes');
                            }
                            breakTo = breakFrom.clone().add(shift.breakValue, 'minutes');

                            if(breakTo > ds && breakFrom < midnight){
                                breakFrom = breakFrom > ds ? breakFrom : ds;
                                breakTo = breakTo < midnight ? breakTo : midnight;
                                dayWorkValue -= breakTo.diff(breakFrom, 'minutes')
                            }
                        }

                    } else {
                        let length = shiftEnd.diff(shiftStart, 'minutes');
                        dayWorkValue = shift.workValue * dayWorkValue/length;

                    }

                } else {

                    if(actualBreakShiftIdMap[shift.id]){
                        actualBreakShiftIdMap[shift.id].forEach(b => {
                            let breakFrom = actualBreakMomentMap[b.id].fromDate;
                            let breakTo = actualBreakMomentMap[b.id].toDate;
                            if(breakTo > ds && breakFrom < midnight){
                                breakFrom = breakFrom > ds ? breakFrom : ds;
                                breakTo = breakTo < midnight ? breakTo : midnight;
                                dayWorkValue -= breakTo.diff(breakFrom, 'minutes')
                            }
                        })
                    } else if(shift.endMissing == true){
                        //assume that employee will go on break until end of shift
                        let breakValue = helpers.CalculateAutoBreakValueForPlanShift(false, shiftStart, shiftEnd, storeSettings);
                        if(breakValue > 0){
                            let breakFrom = shiftStart.clone();
                            let breakTo = shiftStart.clone().add(breakValue, 'minutes');
                            if(breakTo > ds && breakFrom < midnight){
                                breakFrom = breakFrom > ds ? breakFrom : ds;
                                breakTo = breakTo < midnight ? breakTo : midnight;
                                dayWorkValue -= breakTo.diff(breakFrom, 'minutes')
                            }
                        }
                        
                    }
                }
                dayWorkValue = dayWorkValue *60;
                workValue += dayWorkValue;
                if(workDayCalcMode == 1){
                    if(!workValueData.dayWorkValues[dayKey]){
                        workValueData.dayWorkValues[dayKey] = 0;
                    }
                    workValueData.dayWorkValues[dayKey] += dayWorkValue;
                }

                if(!workValueData.weekWorkValues[weekKey]){
                    workValueData.weekWorkValues[weekKey] = 0;
                }
                workValueData.weekWorkValues[weekKey] += dayWorkValue;

                ds = ds.add(1, 'days').startOf('day');
            }
            if(workDayCalcMode == 2){
                let dayKey = shiftStart.format("YYYY-MM-DD");
                if(!workValueData.dayWorkValues[dayKey]){
                    workValueData.dayWorkValues[dayKey] = 0;
                }
                workValueData.dayWorkValues[dayKey] += workValue;
            }
            workValueData.workValue = workValue;

            workValueData.weekOvertimeWorkValues[shiftStart.isoWeek()] = workValue;



        } else {
            let dayKey = shiftStart.format("YYYY-MM-DD");
            workValue = shiftEnd.diff(shiftStart, 'minutes');

            if(isPlanShift){
                if (shift.workValue == -1) {
                    workValue = Math.max(0, workValue - shift.breakValue);
                } else {
                    workValue = shift.workValue;
                }

            } else {
                if(shift.planshiftId != null && planShiftMomentMap[shift.planshiftId]){
                    dayKey = planShiftMomentMap[shift.planshiftId].fromDate.format("YYYY-MM-DD")
                }
                if(actualBreakShiftIdMap[shift.id]){
                    actualBreakShiftIdMap[shift.id].forEach(b => {
                        let bFrom = actualBreakMomentMap[b.id].fromDate;
                        let bTo = actualBreakMomentMap[b.id].toDate;
                        let breakValue = bTo.diff(bFrom, 'minutes');
                        workValue -= breakValue;
                    })
                } else if(shift.endMissing == true){
                    //assume that employee will go on break until end of shift
                    let breakValue = helpers.CalculateAutoBreakValueForPlanShift(false, shiftStart, shiftEnd, storeSettings)
                    workValue -= breakValue;
                }
            }

            workValue = Math.max(0, workValue) * 60;
            workValueData.workValue = workValue;
            workValueData.dayWorkValues[dayKey] = workValue;
            workValueData.weekWorkValues[shiftStart.isoWeek()] = workValue;
            workValueData.weekOvertimeWorkValues[shiftStart.isoWeek()] = workValue;

        }


        return workValueData;
    }

    calculateWorkValueDataForPreference(employee, pref, prefFrom, prefTo, employeeIdContractMap, employeeContractMomentMap, storeSettings, employeeAvgWorktimeMap, workDayCalcMode = 2) {
        let workValueData = {
            workValue: 0,
            dayWorkValues: {},
            weekWorkValues: {},
            weekOvertimeWorkValues: {}
        }

        if (pref.state == 1 && pref.approved) {
            let baseWorkValue = pref.workValue;

            let prefStart = prefFrom.clone();

            let alwaysWork = pref.alwaysWork;

            while (prefStart < prefTo) {
                //step through day, and check interval
                let dayKey = prefStart.format("YYYY-MM-DD");
                let workValue = 0;
                let endOfDay = prefStart.clone().add(1, 'days').startOf('day');
                let checkEnd = endOfDay < prefTo ? endOfDay : prefTo;
                //time between prefstart is less than 24h => put workvalue to start of day
                if(prefTo.diff(prefStart, 'minutes') < 24*60 && workDayCalcMode == 2){
                    checkEnd = prefTo;
                }


                let currentContract = employeeIdContractMap[employee.id] ? employeeIdContractMap[employee.id].find(contract => {
                    if(prefStart >= employeeContractMomentMap[contract.id].fromDate && (employeeContractMomentMap[contract.id].toDate == null || prefStart < employeeContractMomentMap[contract.id].toDate)){
                        return true;
                    } else {
                        return false;
                    }
                }) : null;
                let workDays = currentContract ? currentContract.workDays : storeSettings.workDays;

                let dayTimeRegular = currentContract != null ? Math.round((currentContract.weekTimeRegular / currentContract.weekWorkDaysRegular)) : 9 * 60;
                if (employee.remoteId && employeeAvgWorktimeMap[employee.remoteId] && storeSettings.useAvgWorkTimeForPrefs) {
                    dayTimeRegular = employeeAvgWorktimeMap[employee.remoteId].averageMinutes;
                }
                let prefTime = checkEnd.diff(prefStart, 'minutes');

                if (prefTime > 0) {
                    let isWeekend = !workDays.includes(prefStart.isoWeekday());

                    let tWorkValue = 0;
                    if (baseWorkValue > -1) {
                        //use preference.workValue instead of preference duration to determine workValue
                        //first determine the ratio that the current day interval has compared to entire preference length
                        let workValueRatio = checkEnd.diff(prefStart) / prefTo.diff(prefFrom);
                        tWorkValue = Math.round(baseWorkValue * workValueRatio);
                    } else {
                        if (prefTime > dayTimeRegular) {
                            tWorkValue += dayTimeRegular;
                        } else {
                            tWorkValue += prefTime;
                        }
                    }

                    if (pref.type == 1 || pref.type == 2 || pref.type == 3 || pref.type == 6 || pref.type == 7 || pref.type == 8) {
                        if (!isWeekend || alwaysWork) {
                            workValue += tWorkValue;
                        }
                    } else if (pref.type == 4 && alwaysWork) {
                            workValue += tWorkValue;
                    }

                }
                workValueData.workValue += (workValue *60);
                if(!workValueData.dayWorkValues[dayKey]){
                    workValueData.dayWorkValues[dayKey] = 0;
                }
                workValueData.dayWorkValues[dayKey] += (workValue *60);
                let weekKey = prefStart.isoWeek();
                if(!workValueData.weekWorkValues[weekKey]){
                    workValueData.weekWorkValues[weekKey] = 0;
                }
                workValueData.weekWorkValues[weekKey] += (workValue *60);
                if(!workValueData.weekOvertimeWorkValues[weekKey]){
                    workValueData.weekOvertimeWorkValues[weekKey] = 0;
                }
                workValueData.weekOvertimeWorkValues[weekKey] += (workValue *60);
                //time between prefstart is less than 24h => put workvalue to start of day, might be over midnight, so skip 1 more day
                if(prefTo.diff(prefStart, 'minutes') < 24*60 && workDayCalcMode == 2){
                    prefStart = prefStart.add(1, 'days').startOf('day');
                }
                prefStart = prefStart.add(1, 'days').startOf('day');

            }

        }

        return workValueData;
    }

    calculateWorkTimeForShift(shift, shiftFrom, shiftTo, timeFrom, timeTo, isPlanShift, actualBreakShiftIdMap, actualBreakMomentMap) {

        let workTime = 0;

        let shiftStart = shiftFrom < timeFrom ? timeFrom : shiftFrom;
        let shiftEnd = timeTo < shiftTo ? timeTo : shiftTo;



        workTime = Math.max(0, shiftEnd.diff(shiftStart, 'minutes'));


        if(isPlanShift){
            if (shift.workValue == -1) {
                let breakFrom = null;
                if (!shift.breakFrom) {

                    breakFrom = shiftFrom.clone().add(Math.round(shiftTo.diff(shiftFrom, 'minutes') / 2), 'minutes');
                } else {
                    breakFrom = this.getMomentFromStringTZ(shift.breakFrom);
                }
                let breakTo = breakFrom.clone().add(shift.breakValue, 'minutes');

                let ratioFrom = breakFrom < timeFrom ? timeFrom : (breakFrom > timeTo ? timeTo : breakFrom);
                let ratioTo = breakTo > timeTo ? timeTo : (breakTo < timeFrom ? timeFrom : breakTo);

                let breakTime = Math.max(0, ratioTo.diff(ratioFrom, 'minutes'));
                workTime = Math.max(0, workTime - breakTime);
            } else {
                let ratioFrom = shiftFrom < timeFrom ? timeFrom : (shiftFrom > timeTo ? timeTo : shiftFrom);
                let ratioTo = shiftTo > timeTo ? timeTo : (shiftTo < timeFrom ? timeFrom : shiftTo);

                let ratio = ratioTo.diff(ratioFrom) / shiftTo.diff(shiftFrom);

                workTime = Math.round(shift.workValue * ratio);
            }

        } else {
            if(actualBreakShiftIdMap[shift.id]){
                actualBreakShiftIdMap[shift.id].forEach(b => {
                    let bFrom = actualBreakMomentMap[b.id].fromDate;
                    let bTo = actualBreakMomentMap[b.id].toDate;
                    if(bFrom < timeFrom){
                        bFrom = timeFrom;
                    }
                    if(timeTo < bTo){
                        bTo = timeTo;
                    }
                    let breakValue = Math.max(0, bTo.diff(bFrom, 'minutes'));
                    workTime -= breakValue;
                })
            }
        }



        return Math.max(0, workTime);
    }

    calculateWorkTimeForPreference(employee, pref, prefFrom, prefTo, rangeFrom, rangeTo, employeeIdContractMap, employeeContractMomentMap, storeSettings) {
       let workTime = 0;

        if (pref.state == 1 && pref.approved && (prefFrom < rangeTo && prefTo > rangeFrom)) {
            let baseWorkValue = pref.workValue;

            let prefStart = prefFrom.clone();

            let prefEnd = prefTo;


            let alwaysWork = pref.alwaysWork;

            while (prefStart < prefEnd) {
                //step through day, and check interval

                let workValue = 0;
                let endOfDay = prefStart.clone().add(1, 'days').startOf('day');
                let checkEnd = endOfDay < prefEnd ? endOfDay : prefEnd;


                let currentContract = employeeIdContractMap[employee.id] ? employeeIdContractMap[employee.id].find(contract => {
                    if(prefStart >= employeeContractMomentMap[contract.id].fromDate && (employeeContractMomentMap[contract.id].toDate == null || prefStart < employeeContractMomentMap[contract.id].toDate)){
                        return true;
                    } else {
                        return false;
                    }
                }) : null;
                let workDays = currentContract ? currentContract.workDays : storeSettings.workDays;

                let dayTimeRegular = currentContract != null ? Math.round((currentContract.weekTimeRegular / currentContract.weekWorkDaysRegular)) : 9 * 60;
                let prefTime = checkEnd.diff(prefStart, 'minutes');

                if (prefTime > 0) {
                    let isWeekend = !workDays.includes(prefStart.isoWeekday());

                    let tWorkValue = 0;
                    if (baseWorkValue > -1) {
                        //use preference.workValue instead of preference duration to determine workValue
                        //first determine the ratio that the current day interval has compared to entire preference length
                        let workValueRatio = checkEnd.diff(prefStart) / prefTo.diff(prefFrom);
                        tWorkValue = Math.round(baseWorkValue * workValueRatio);
                    } else {
                        if (prefTime > dayTimeRegular) {
                            tWorkValue += dayTimeRegular;
                        } else {
                            tWorkValue += prefTime;
                        }
                    }

                    if (pref.type == 1 || pref.type == 2 || pref.type == 3 || pref.type == 6 || pref.type == 7 || pref.type == 8) {
                        if (!isWeekend || alwaysWork) {
                            workValue += tWorkValue;
                        }
                    } else if (pref.type == 4 && alwaysWork) {
                            workValue += tWorkValue;
                    }

                }
                workTime += (workValue);


                prefStart = prefStart.add(1, 'days').startOf('day');
            }

            let ratioFrom = prefFrom < rangeFrom ? rangeFrom : (prefFrom > rangeTo ? rangeTo : prefFrom);
            let ratioTo = prefTo > rangeTo ? rangeTo : (prefTo < rangeFrom ? rangeFrom : prefTo);
            let ratio = ratioTo.diff(ratioFrom) / prefTo.diff(prefFrom);

            workTime = Math.round(workTime * ratio);

        }
        return workTime;
    }

    doRequiredSkillCheck(shift, employee, mapKey, spotMap, employeeMap, employeeEmployeeSkillMap, dayMap) {
        if (shift.spotId && spotMap[shift.spotId]) {
            let requiredSkill = spotMap[shift.spotId].requiredSkill;

            if (!(employeeMap[employee.id] && employeeEmployeeSkillMap[employee.id] && employeeEmployeeSkillMap[employee.id].find(s => s.skillId === requiredSkill))) {
                dayMap[mapKey].plan_skillError = true;
            }
        }
    }

    doRequiredBreaksCheck(requiredBreakCounts, underageStats, dayMap, mapKey, storeSettings) {
        let shiftDuration = requiredBreakCounts.actualShiftDuration / (1000 * 60.0) // shift Duration in Minutes
        let totalBreakTime = (requiredBreakCounts.countSixtyMinutePauses * 60 +
                            requiredBreakCounts.countFortyFiveMinutePauses * 45 +
                            requiredBreakCounts.countThirtyMinutePauses * 30 +
                            requiredBreakCounts.countFifteenMinutePauses * 15)
        if(storeSettings.country == 2){ //German Rules
            if (underageStats.underage) {
                //germany allows splitting breaks into 15min intervals for underage too, no need to recalculate totalBreakTime
                //check if break is within 4.5h
                if(!requiredBreakCounts.mainPauseBegunWithinFourPointFiveHours && shiftDuration > 4.5 * 60){
                    dayMap[mapKey].legalRestingError = true;
                } else {
                    //check break duration violations
                    if(shiftDuration > 6 * 60 && totalBreakTime < 60){ //min 60min Pause, can be split into 15min intervals
                        dayMap[mapKey].legalRestingError = true;
                    } else if (shiftDuration > 4.5 * 60 && totalBreakTime < 30){
                        dayMap[mapKey].legalRestingError = true;
                    }
                }

            } else {
                //check if break is within 6h
                if(!requiredBreakCounts.mainPauseBegunWithinSixHours && shiftDuration > 6 * 60){
                    dayMap[mapKey].legalRestingError = true;
                } else {
                    //check break duration violations
                    if(shiftDuration > 9 * 60 && totalBreakTime < 45){ //min 45min Pause, can be split into 15min intervals
                        dayMap[mapKey].legalRestingError = true;
                    } else if (shiftDuration > 6 * 60 && totalBreakTime < 30){
                        dayMap[mapKey].legalRestingError = true;
                    }
                }
            }

        } else if(storeSettings.country == 8){ //LU Rules
            if (underageStats.underage) {
                //LU PROBABLY allows splitting breaks into 15min intervals for underage too, no need to recalculate totalBreakTime
                //check if break is within 4.0h
                if(!requiredBreakCounts.mainPauseBegunWithinFourHours && shiftDuration > 4.0 * 60){
                    dayMap[mapKey].legalRestingError = true;
                } else {
                    //check break duration violations
                    if(shiftDuration > 6 * 60 && totalBreakTime < 30){ //min 60min Pause, can be split into 15min intervals
                        dayMap[mapKey].legalRestingError = true;
                    } else if (shiftDuration > 4.0 * 60 && totalBreakTime < 30){
                        dayMap[mapKey].legalRestingError = true;
                    }
                }

            } else {
                //check if break is within 6h
                if(!requiredBreakCounts.mainPauseBegunWithinSixHours && shiftDuration > 6 * 60){
                    dayMap[mapKey].legalRestingError = true;
                } else {
                    //check break duration violations
                    if (shiftDuration > 6 * 60 && totalBreakTime < 30){
                        dayMap[mapKey].legalRestingError = true;
                    }
                }
            }

        } else {
            if (underageStats.underage) {
               //Austria does not allow splitting of breaks into 15min intervals for underage -> only use 30 and 45 pauses to compute totalBreakTime
                totalBreakTime = (requiredBreakCounts.countSixtyMinutePauses * 60 +
                                requiredBreakCounts.countFortyFiveMinutePauses * 45 +
                                requiredBreakCounts.countThirtyMinutePauses * 30);
                //check if break is within 6h
                if(!requiredBreakCounts.mainPauseBegunWithinSixHours && shiftDuration > 6 * 60){
                    dayMap[mapKey].legalRestingError = true;
                } else {
                    //check break duration violations
                    if(shiftDuration > 4.5 * 60 && totalBreakTime < 30){ //min 30min Pause
                        dayMap[mapKey].legalRestingError = true;
                    }
                }

            } else {
                //check if break is within 6h
                if(!requiredBreakCounts.mainPauseBegunWithinSixHours && shiftDuration > 6 * 60){
                    dayMap[mapKey].legalRestingError = true;
                } else {
                    //check break duration violations
                    if(shiftDuration > 6 * 60 && totalBreakTime < 30){ //min 30min Pause
                        dayMap[mapKey].legalRestingError = true;
                    }
                }
            }
        }
    }

    doPregnantShiftBoundaryCheck(pregnant, shiftStart, shiftEnd, momentDateBoundaryMap, dayMap, mapKey) {
        if (pregnant) { //pregnant people cant work before 6:00 or after 20:00
            let cantBeBelow = momentDateBoundaryMap[mapKey].pregCantBeBelow;
            let cantBeAbove = momentDateBoundaryMap[mapKey].pregCantBeAbove;
            if (shiftStart < cantBeBelow || shiftEnd > cantBeAbove) {
                dayMap[mapKey].pregnantError = true;
            }
        }
    }

    doUnderageShiftBoundaryCheck(underageStats, shiftStart, shiftEnd, dayMapEntry, dayStart, helpers) {
        if (underageStats.underage && underageStats.rule) { //underage people cant work before 6:00 or after 20:00 / 22:00
            if(underageStats.rule.startTimeMin){
                let temp = helpers.getMomentFromStringTZ(underageStats.rule.startTimeMin, 'HH:mm');
                let cantBeBelow = dayStart.clone().hours(temp.hours()).minutes(temp.minutes());
                if (shiftStart < cantBeBelow ) {
                    dayMapEntry.underageError = true;
                }
            }
            if(underageStats.rule.endTimeMax){
                let temp = helpers.getMomentFromStringTZ(underageStats.rule.endTimeMax, 'HH:mm');
                let cantBeAbove = dayStart.clone().hours(temp.hours()).minutes(temp.minutes());
                if (shiftEnd > cantBeAbove ) {
                    dayMapEntry.underageError = true;
                }
            }
        }
    }

    doShiftInsideContractCheck(employee, shiftStart, shiftEnd, employeeIdContractMap, contractLimits, dayMap, mapKey) {
        let shiftStartInsideContract = false;
        let shiftEndInsideContract = false;
        employeeIdContractMap[employee.id].forEach(employeeContract => {
            let contractFrom = contractLimits.employeeContractMomentMap[employeeContract.id].from;
            let contractTo = contractLimits.employeeContractMomentMap[employeeContract.id].to;

            if (contractFrom <= shiftStart && (contractTo == null || shiftStart <= contractTo)) {
                shiftStartInsideContract = true;
            }
            if (contractFrom <= shiftEnd && (contractTo == null || shiftEnd <= contractTo)) {
                shiftEndInsideContract = true;
            }


        });
        dayMap[mapKey].outsideContractError = !shiftStartInsideContract || !shiftEndInsideContract;

    }

    doContractRestTimeBetweenShiftsCheck(contractLimits, underageStats, shiftStart, shiftEnd, previousShiftStart, previousShiftEnd, dayMap, mapKey, previousMapKey) {
        if (contractLimits && previousShiftEnd) {
            let restTime = contractLimits.contract_restTime;
            if (underageStats.underage && underageStats.rule && underageStats.rule.restTime) {
                restTime = underageStats.rule.restTime * 60;
            }
            if (contractLimits.allowPartialShifts ) {
                let dayTimeMax = contractLimits.contract_dayTimeMax;
                let sameDay = shiftStart.month() == previousShiftStart.month() && shiftStart.date() == previousShiftStart.date() && shiftStart.year() == previousShiftStart.year();

                let isWithinMaxRange = previousShiftStart.unix() + dayTimeMax > shiftEnd.unix();
                if (!sameDay && !isWithinMaxRange) {
                    if (previousShiftEnd.unix() + restTime > shiftStart.unix()) {
                        dayMap[mapKey].restError = true;
                        dayMap[mapKey].restSpareTimeMissing = previousShiftEnd.unix() + restTime - shiftStart.unix();
                        if(previousMapKey != null && dayMap[previousMapKey]){
                            dayMap[previousMapKey].restError = true;
                        }
                    }

                }

            } else {
                if (previousShiftEnd.unix() + restTime > shiftStart.unix()) {
                    dayMap[mapKey].restError = true;
                    dayMap[mapKey].restSpareTimeMissing = previousShiftEnd.unix() + restTime - shiftStart.unix();
                    if(previousMapKey != null && dayMap[previousMapKey]){
                        dayMap[previousMapKey].restError = true;
                    }
                }
            }


        }
    }

    doPlanTypeRestTimeBetweenShiftsCheck(planTypeLimits, shiftStart, shiftEnd, previousShiftStart, previousShiftEnd, dayMap, mapKey, previousMapKey) {
        if (planTypeLimits.planTypeFound && previousShiftEnd) {
            if (planTypeLimits.planType_allowPartialShifts) {
                let dayTimeMax = planTypeLimits.planType_dayTimeMax;
                let sameDay = shiftStart.month() == previousShiftStart.month() && shiftStart.date() == previousShiftStart.date() && shiftStart.year() == previousShiftStart.year();

                let isWithinMaxRange = previousShiftStart.unix() + dayTimeMax > shiftEnd.unix();
                if (!sameDay && !isWithinMaxRange) {
                    if (previousShiftEnd.unix() + planTypeLimits.planType_restTime > shiftStart.unix()) {
                        dayMap[mapKey].plan_restError = true;
                        dayMap[mapKey].plan_restSpareTimeMissing = previousShiftEnd.unix() + planTypeLimits.planType_restTime - shiftStart.unix();
                        if(previousMapKey != null && dayMap[previousMapKey]){
                            dayMap[previousMapKey].plan_restError = true;
                        }
                    }

                } else {
                    if (planTypeLimits.planType_shiftBetweenTimeMin > 0 && previousShiftEnd.unix() + planTypeLimits.planType_shiftBetweenTimeMin > shiftStart.unix()) {
                        dayMap[mapKey].plan_restError = true;
                        dayMap[mapKey].plan_restSpareTimeMissing = previousShiftEnd.unix() + planTypeLimits.planType_shiftBetweenTimeMin - shiftStart.unix();

                    }
                    if (planTypeLimits.planType_shiftBetweenTimeMax > 0 && previousShiftEnd.unix() + planTypeLimits.planType_shiftBetweenTimeMax < shiftStart.unix()) {
                        dayMap[mapKey].plan_restError = true;
                        dayMap[mapKey].plan_restSpareTimeMissing = shiftStart.unix() - (previousShiftEnd.unix() + planTypeLimits.planType_shiftBetweenTimeMax);
                    }
                }
            } else {
                if (previousShiftEnd.unix() + planTypeLimits.planType_restTime > shiftStart.unix()) {
                    dayMap[mapKey].plan_restError = true;
                    dayMap[mapKey].plan_restSpareTimeMissing = previousShiftEnd.unix() + planTypeLimits.planType_restTime - shiftStart.unix();
                    if(previousMapKey != null && dayMap[previousMapKey]){
                        dayMap[previousMapKey].plan_restError = true;
                    }
                }
            }

        }
    }

    // Frontend Check for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3"
    doMaxThreeConsecutiveSundayCheck(employee, underageStats, today, storeSettings, weekEndDayKeys, employeeDateCombinedShiftMap, dayMap, mapKey) {
        if (today.isoWeekday() == 7) {
            if (storeSettings.country == 2) {
                //fucking g*rmans
                let freeSundays = 0;
                weekEndDayKeys.forEach(obj => {
                    let key = obj.sunDay;
                    
                    if (!employeeDateCombinedShiftMap[employee.id][key] || (employeeDateCombinedShiftMap[employee.id][key] && employeeDateCombinedShiftMap[employee.id][key].length == 0)) {
                        freeSundays++;
                    }
                })
                if (freeSundays < 2) {
                    dayMap[mapKey].underageError = true;
                }

            } else { //LU works the same
                let nextWeek = today.clone().add(1, 'weeks');
                let nextNextWeek = today.clone().add(2, 'weeks');
                let nextWeekMapKey = nextWeek.format("YYYY-MM-DD");
                let nextNextWeekMapKey = nextNextWeek.format("YYYY-MM-DD");
                let prevWeekMapKey = today.clone().add(-1, 'weeks').format("YYYY-MM-DD");
                let prevPrevWeekMapKey = today.clone().add(-2, 'weeks').format("YYYY-MM-DD");

                let hasNextWeek = employeeDateCombinedShiftMap[employee.id][nextWeekMapKey] && employeeDateCombinedShiftMap[employee.id][nextWeekMapKey].length > 0;
                let hasNextNextWeek = employeeDateCombinedShiftMap[employee.id][nextNextWeekMapKey] && employeeDateCombinedShiftMap[employee.id][nextNextWeekMapKey].length > 0;
                let hasPrevWeek = employeeDateCombinedShiftMap[employee.id][prevWeekMapKey] && employeeDateCombinedShiftMap[employee.id][prevWeekMapKey].length > 0;
                let hasPrevPrevWeek = employeeDateCombinedShiftMap[employee.id][prevPrevWeekMapKey] && employeeDateCombinedShiftMap[employee.id][prevPrevWeekMapKey].length > 0;

                if (hasPrevPrevWeek && hasPrevWeek || hasPrevWeek && hasNextWeek || hasNextWeek && hasNextNextWeek) {
                    dayMap[mapKey].consecutiveWeekendsError = true;
                }
            }


        }
    }

    // Frontend Check for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3"
    doMaxTwoConsecutiveLongShiftsCheck(employee, today, employeeDateCombinedShiftMap, planShiftMomentMap, workDayCalcMode, dayMap, mapKey, storeSettings, helpers){
        let todayMapKey = today.format("YYYY-MM-DD");
        let nextDayMapKey = today.clone().add(1, 'days').format("YYYY-MM-DD");
        let nextNextDayMapKey = today.clone().add(2, 'days').format("YYYY-MM-DD");
        let prevDayMapKey = today.clone().add(-1, 'days').format("YYYY-MM-DD");
        let prevPrevDayMapKey = today.clone().add(-2, 'days').format("YYYY-MM-DD");
        
        let hasToday = employeeDateCombinedShiftMap[employee.id][todayMapKey] && employeeDateCombinedShiftMap[employee.id][todayMapKey].length > 0;
        let hasNextDay = employeeDateCombinedShiftMap[employee.id][nextDayMapKey] && employeeDateCombinedShiftMap[employee.id][nextDayMapKey].length > 0;
        let hasNextNextDay = employeeDateCombinedShiftMap[employee.id][nextNextDayMapKey] && employeeDateCombinedShiftMap[employee.id][nextNextDayMapKey].length > 0;
        let hasPrevDay = employeeDateCombinedShiftMap[employee.id][prevDayMapKey] && employeeDateCombinedShiftMap[employee.id][prevDayMapKey].length > 0;
        let hasPrevPrevDay = employeeDateCombinedShiftMap[employee.id][prevPrevDayMapKey] && employeeDateCombinedShiftMap[employee.id][prevPrevDayMapKey].length > 0;
        
        let workValueToday = 0;
        let workValuePrevDay = 0;
        let workValuePrevPrevDay = 0;
        let workValueNextDay = 0;
        let workValueNextNextDay = 0;

        if(hasToday){
            employeeDateCombinedShiftMap[employee.id][todayMapKey].forEach(shift => {
                let shiftStart = null;
                let shiftEnd = null;
                if (planShiftMomentMap[shift.id]) {
                    shiftStart = planShiftMomentMap[shift.id].fromDate;
                    shiftEnd = planShiftMomentMap[shift.id].toDate;
                    let workValueData = this.calculateWorkValueData(shift, shiftStart, shiftEnd, true, {}, {}, planShiftMomentMap, workDayCalcMode, storeSettings, helpers);
                    let workValue = workValueData.workValue;
                    workValueToday += workValue;
                }
            });
        }
        if(workValueToday > 10 * 60 * 60){
            // workvalue of current day is more than 10 hours --> check prev/next days if more then 2 consecutive long shifts
            if(hasNextDay){
                employeeDateCombinedShiftMap[employee.id][nextDayMapKey].forEach(shift => {
                    let shiftStart = null;
                    let shiftEnd = null;
                    if (planShiftMomentMap[shift.id]) {
                        shiftStart = planShiftMomentMap[shift.id].fromDate;
                        shiftEnd = planShiftMomentMap[shift.id].toDate;
                        let workValueData = this.calculateWorkValueData(shift, shiftStart, shiftEnd, true, {}, {}, planShiftMomentMap, workDayCalcMode, storeSettings, helpers);
                        let workValue = workValueData.workValue;
                        workValueNextDay += workValue;
                    }
                });
            }
            if(hasNextNextDay){
                employeeDateCombinedShiftMap[employee.id][nextNextDayMapKey].forEach(shift => {
                    let shiftStart = null;
                    let shiftEnd = null;
                    if (planShiftMomentMap[shift.id]) {
                        shiftStart = planShiftMomentMap[shift.id].fromDate;
                        shiftEnd = planShiftMomentMap[shift.id].toDate;
                        let workValueData = this.calculateWorkValueData(shift, shiftStart, shiftEnd, true, {}, {}, planShiftMomentMap, workDayCalcMode, storeSettings, helpers);
                        let workValue = workValueData.workValue;
                        workValueNextNextDay += workValue;
                    }
                });
            }
            if(hasPrevDay){
                employeeDateCombinedShiftMap[employee.id][prevDayMapKey].forEach(shift => {
                    let shiftStart = null;
                    let shiftEnd = null;
                    if (planShiftMomentMap[shift.id]) {
                        shiftStart = planShiftMomentMap[shift.id].fromDate;
                        shiftEnd = planShiftMomentMap[shift.id].toDate;
                        let workValueData = this.calculateWorkValueData(shift, shiftStart, shiftEnd, true, {}, {}, planShiftMomentMap, workDayCalcMode, storeSettings, helpers);
                        let workValue = workValueData.workValue;
                        workValuePrevDay += workValue;
                    }
                });
            }
            if(hasPrevPrevDay){
                employeeDateCombinedShiftMap[employee.id][prevPrevDayMapKey].forEach(shift => {
                    let shiftStart = null;
                    let shiftEnd = null;
                    if (planShiftMomentMap[shift.id]) {
                        shiftStart = planShiftMomentMap[shift.id].fromDate;
                        shiftEnd = planShiftMomentMap[shift.id].toDate;
                        let workValueData = this.calculateWorkValueData(shift, shiftStart, shiftEnd, true, {}, {}, planShiftMomentMap, workDayCalcMode, storeSettings, helpers);
                        let workValue = workValueData.workValue;
                        workValuePrevPrevDay += workValue;
                    }
                });
            }
            let prevLong = workValuePrevDay > 10 * 60 * 60;
            let prevPrevLong = workValuePrevPrevDay > 10 * 60 * 60;
            let nextLong = workValueNextDay > 10 * 60 * 60;
            let nextNextLong = workValueNextNextDay > 10 * 60 * 60;
            if(prevLong && prevPrevLong || prevLong && nextLong || nextLong && nextNextLong){
                dayMap[mapKey].consecutiveLongShiftsError = true;
            }
        }  
    }

    doConsecutiveDaysCheck(start, shift, planConsecutiveDays, limitPlan, contractConsecutiveDays, limitContract, dayMap,
                           actualShiftMomentMap, planShiftMomentMap, splitPreferenceMomentMap) {
        
        let isActuallyConsideredAShift = false;
        if (actualShiftMomentMap[shift.id]) {
            start = actualShiftMomentMap[shift.id].fromDate;
            isActuallyConsideredAShift = true;
        } else if (planShiftMomentMap[shift.id]) {
            start = planShiftMomentMap[shift.id].fromDate;
            isActuallyConsideredAShift = true;
        } else if (splitPreferenceMomentMap[shift.id]) {
            /*if(shift.type == 7){
                start = splitPreferenceMomentMap[shift.id].fromDate;
                isActuallyConsideredAShift = true;
            }*/
        }
        if(isActuallyConsideredAShift){
            let mapKey = start.format('YYYY-MM-DD');
            if(limitPlan != null && limitPlan > 0){
                
                if (!planConsecutiveDays.previousStart) {
                    planConsecutiveDays.previousStart = start;
                    planConsecutiveDays.numberOfDays = 1;
                }
                if (planConsecutiveDays.previousStart.clone().add(1, 'days').format('DD.MM') === start.format('DD.MM')) {
                    planConsecutiveDays.numberOfDays++;
                    if (planConsecutiveDays.numberOfDays === limitPlan + 1) {
                        let counter = 0;
                        while (counter < planConsecutiveDays.numberOfDays) {
                            let dayKey = start.clone().subtract(counter, 'days').format('YYYY-MM-DD');
                            if(dayMap[dayKey]){
                                dayMap[dayKey].plan_daysConsecutiveMax = true;
                            }
                            
                            counter++;
                        }
                    }
                    if (planConsecutiveDays.numberOfDays > limitPlan + 1) {
                        if(dayMap[mapKey]){
                            dayMap[mapKey].plan_daysConsecutiveMax = true;
                        }
                        
                    }
                } else if (planConsecutiveDays.previousStart.clone().format('DD.MM') !== start.format('DD.MM')) {
                    // do not count days on same-day shifts
                    planConsecutiveDays.numberOfDays = 1;
                }
                planConsecutiveDays.previousStart = start;
            }
            if(limitContract != null && limitContract > 0){
                
                if (!contractConsecutiveDays.previousStart) {
                    contractConsecutiveDays.previousStart = start;
                    contractConsecutiveDays.numberOfDays = 1;
                }
                if (contractConsecutiveDays.previousStart.clone().add(1, 'days').format('DD.MM') === start.format('DD.MM')) {
                    contractConsecutiveDays.numberOfDays++;
                    if (contractConsecutiveDays.numberOfDays === limitContract + 1) {
                        let counter = 0;
                        while (counter < contractConsecutiveDays.numberOfDays) {
                            let dayKey = start.clone().subtract(counter, 'days').format('YYYY-MM-DD');
                            if(dayMap[dayKey]){
                                dayMap[dayKey].daysConsecutiveMax = true;
                            }
                            
                            counter++;
                        }
                    }
                    if (contractConsecutiveDays.numberOfDays > limitContract + 1) {
                        if(dayMap[mapKey]){
                            dayMap[mapKey].daysConsecutiveMax = true;
                        }
                    }
                } else if (contractConsecutiveDays.previousStart.clone().format('DD.MM') !== start.format('DD.MM')) {
                    // do not count days on same-day shifts
                    contractConsecutiveDays.numberOfDays = 1;
                }
                contractConsecutiveDays.previousStart = start;
            }

        }

        
    }

    doUnderageDoubleSundayCheck(employee, underageStats, today, birthday, storeSettings, weekEndDayKeys, saturDayKeys, employeeDateCombinedShiftMap, dayMap, mapKey) {
        if (underageStats.underage) {
            if(storeSettings.country == 2 && today.isoWeekday() == 6){
                let freeSaturdays = 0;
                
                saturDayKeys.forEach(key => {
                    
                    
                    if (!employeeDateCombinedShiftMap[employee.id][key] || (employeeDateCombinedShiftMap[employee.id][key] && employeeDateCombinedShiftMap[employee.id][key].length == 0)) {
                        freeSaturdays++;
                        
                    }
                })
                    
                if (freeSaturdays < 2) {
                    dayMap[mapKey].plan_underageError = true;
                }
            }
            if (today.isoWeekday() == 7) {
                if (storeSettings.country == 2) {
                    //fucking g*rmans
                    let freeSundays = 0;
                    let freeWeekends = 0;
                    weekEndDayKeys.forEach(obj => {
                        let key = obj.sunDay;
                        let satKey = obj.satDay;
                        if (!employeeDateCombinedShiftMap[employee.id][key] || (employeeDateCombinedShiftMap[employee.id][key] && employeeDateCombinedShiftMap[employee.id][key].length == 0)) {
                            freeSundays++;
                            /*if (!employeeDateCombinedShiftMap[employee.id][satKey] || (employeeDateCombinedShiftMap[employee.id][satKey] && employeeDateCombinedShiftMap[employee.id][satKey].length == 0)) {
                                freeWeekends++;
                                
                            } */
                        }
                    })
                    
                    if (freeSundays < 2) {
                        dayMap[mapKey].underageError = true;
                    }

                } else { //LU works the same
                    let nextWeek = today.clone().add(1, 'weeks');
                    let nextWeekStillUnderage = true;
                    if(birthday){
                        let age = nextWeek.diff(birthday, 'years');
                        nextWeekStillUnderage = age < 18;
                    }
                    let nextWeekMapKey = nextWeek.format("YYYY-MM-DD");
                    let prevWeekMapKey = today.clone().add(-1, 'weeks').format("YYYY-MM-DD");
                    if (employeeDateCombinedShiftMap[employee.id][nextWeekMapKey] && employeeDateCombinedShiftMap[employee.id][nextWeekMapKey].length > 0 && nextWeekStillUnderage) {
                        dayMap[mapKey].underageError = true;
                    } else if (employeeDateCombinedShiftMap[employee.id][prevWeekMapKey] && employeeDateCombinedShiftMap[employee.id][prevWeekMapKey].length > 0) {
                        dayMap[mapKey].underageError = true;
                    }
                }


            }
        }
    }

    doUnderageHolidayCheck(underageStats, today, shiftStart, shiftEnd, storeSettings, dayMap, mapKey) {
        if (underageStats.underage && storeSettings.country == 2) {
            let forbiddenDays = ["01-01", "12-25", "05-01"]
            let limitedDays = ["12-24", "12-31"]
            let todayKey = today.format("MM-DD");

            if(forbiddenDays.includes(todayKey)){
                dayMap[mapKey].underageError = true; 
            } else if(limitedDays.includes(todayKey)){
                let limit = today.clone().hours(14).minutes(0);
                if(shiftEnd > limit){
                    dayMap[mapKey].underageError = true;
                }
                
            }
            
        }
    }

    doTraineeEightWeeksSundayCheck(employee, underageStats, today, birthday, storeSettings, weekEndDayKeys, employeeDateCombinedShiftMap, dayMap, mapKey, employeeIdContractMap, employeeContractMomentMap, allowedContractMap){
        if(storeSettings.country == 1 && underageStats.underage){
            //lovely austrians
            //systemgastronomie starting May 2024: underage trainees are not allowed to work on a sunday within the first 8 weeks of their contract
            //add frontend check so users can see it in the roster - AlexG: have a look at this please after your vacation :-)
            let isSunday = weekEndDayKeys.map(obj => obj.sunDay).includes(mapKey);
            if(isSunday){
                let contracts = employeeIdContractMap[employee.id] ? employeeIdContractMap[employee.id] : [];
                if(contracts.length > 0){
                    let contractFrom = null;
                    let currentContract = contracts.find(contract => {
                        if(contract.employmentType == 3 && contract.collectiveContractId && (allowedContractMap[contract.collectiveContractId].collectiveContractId == '964f479d-0045-4eb7-a621-aac699ee9585' || allowedContractMap[contract.collectiveContractId].collectiveContractId == 'f6c66725-f229-44ce-9458-418da16def58') && (today >= employeeContractMomentMap[contract.id].fromDate && (employeeContractMomentMap[contract.id].toDate == null || today < employeeContractMomentMap[contract.id].toDate))){
                            return true;
                        } else {
                            return false;
                        }
                    });
                    if(currentContract){
                        contractFrom = employeeContractMomentMap[currentContract.id].fromDate;
                    }
                    while(currentContract && currentContract.parentId != null){
                        currentContract = contracts.find(contract => {
                            if(contract.id == currentContract.parentId && (allowedContractMap[contract.collectiveContractId].collectiveContractId == '964f479d-0045-4eb7-a621-aac699ee9585' || allowedContractMap[contract.collectiveContractId].collectiveContractId == 'f6c66725-f229-44ce-9458-418da16def58')){
                                return true;
                            }else{
                                return false;
                            }
                        });
                        if(currentContract){
                            contractFrom = employeeContractMomentMap[currentContract.id].fromDate;
                        }
                    }
                    if(contractFrom){
                        let checkedDay = new Date(today);
                        let diff = (today - contractFrom)/1000/60/60/24;
                        if(diff < 56){
                            dayMap[mapKey].traineeError = true;
                        }
                    }
                }
            }
        }
    }

    doDayTimeMaxChecksV2(dtWorkTime, pastMidnight, contractLimits, planTypeLimits, dayTimeMax, shiftEnd, dayMap, mapKey) {
        if (pastMidnight) { // Shift goes past midnight - split //_d.getTime() is 1.15x faster
            //First half

            if (contractLimits) {
                dayMap[mapKey].shiftError = dayMap[mapKey].shiftError || (dtWorkTime > dayTimeMax);
            }
            if (planTypeLimits.planTypeFound) {
                dayMap[mapKey].plan_dayError = dayMap[mapKey].plan_dayError || (dtWorkTime > planTypeLimits.planType_dayTimeMax);
            }

            //Second half
            let mapKeySecondHalf = shiftEnd.format("YYYY-MM-DD");

            if (dayMap[mapKeySecondHalf] == undefined) {
                dayMap[mapKeySecondHalf] = {
                    'shiftError': false,
                    'pregnantError': false,
                    'underageError': false,
                    'plan_underageError': false,
                    'plan_dayError': false,
                    'legalRestingError': false,
                    'restError': false,
                    'plan_restError': false,
                    'weekError': false,
                    'plan_weekError': false,

                    'restWeekError': false,
                    'plan_restWeekError': false,
                    'restWeekSpareTimeMissing': 0,
                    'plan_restWeekSpareTimeMissing': 0,
                    'restWeekSpareDaysMissing': 0,
                    'plan_restWeekSpareDaysMissing': 0,
                    'outsideContractError': false,
                    'date': null,
                    'worktime': 0,
                    'restTimeFirst': 86400,
                    'restTimeSecond': 86400,
                    'shiftOvertimeError': false,
                    'weeklyOvertimeError': false,
                    'traineeError': false,
                    'majorityOfWeekends': false
                };
            }

            if (contractLimits) {
                dayMap[mapKeySecondHalf].shiftError = dayMap[mapKeySecondHalf].shiftError || (dtWorkTime > dayTimeMax);
            }
            if (planTypeLimits.planTypeFound) {
                dayMap[mapKeySecondHalf].plan_dayError = dayMap[mapKeySecondHalf].plan_dayError || (dtWorkTime > planTypeLimits.planType_dayTimeMax);
            }
        } else { // Shift is only on one day

            if (contractLimits) {
                dayMap[mapKey].shiftError = dayMap[mapKey].shiftError || (dtWorkTime > dayTimeMax);
            }
            if (planTypeLimits.planTypeFound) {
                dayMap[mapKey].plan_dayError = dayMap[mapKey].plan_dayError || (dtWorkTime > planTypeLimits.planType_dayTimeMax);
            }
        }
    }

    doDayTimeMaxChecks(pastMidnight, contractLimits, planTypeLimits, dayTimeMax, shiftEnd, dayMap, mapKey) {
        if (pastMidnight) { // Shift goes past midnight - split //_d.getTime() is 1.15x faster
            //First half

            if (contractLimits) {
                dayMap[mapKey].shiftError = dayMap[mapKey].shiftError || (dayMap[mapKey].worktime > dayTimeMax);
            }
            if (planTypeLimits.planTypeFound) {
                dayMap[mapKey].plan_dayError = dayMap[mapKey].plan_dayError || (dayMap[mapKey].worktime > planTypeLimits.planType_dayTimeMax);
            }

            //Second half
            let mapKeySecondHalf = shiftEnd.format("YYYY-MM-DD");

            if (dayMap[mapKeySecondHalf] == undefined) {
                dayMap[mapKeySecondHalf] = {
                    'shiftError': false,
                    'pregnantError': false,
                    'underageError': false,
                    'plan_underageError': false,
                    'plan_dayError': false,
                    'legalRestingError': false,
                    'restError': false,
                    'plan_restError': false,
                    'weekError': false,
                    'plan_weekError': false,

                    'restWeekError': false,
                    'plan_restWeekError': false,
                    'restWeekSpareTimeMissing': 0,
                    'plan_restWeekSpareTimeMissing': 0,
                    'restWeekSpareDaysMissing': 0,
                    'plan_restWeekSpareDaysMissing': 0,
                    'outsideContractError': false,
                    'date': null,
                    'worktime': 0,
                    'restTimeFirst': 86400,
                    'restTimeSecond': 86400,
                    'shiftOvertimeError': false,
                    'weeklyOvertimeError': false,
                    'traineeError': false,
                    'majorityOfWeekends': false
                };
            }

            if (contractLimits) {
                dayMap[mapKeySecondHalf].shiftError = dayMap[mapKeySecondHalf].shiftError || (dayMap[mapKeySecondHalf].worktime > dayTimeMax);
            }
            if (planTypeLimits.planTypeFound) {
                dayMap[mapKeySecondHalf].plan_dayError = dayMap[mapKeySecondHalf].plan_dayError || (dayMap[mapKeySecondHalf].worktime > planTypeLimits.planType_dayTimeMax);
            }
        } else { // Shift is only on one day

            if (contractLimits) {
                dayMap[mapKey].shiftError = dayMap[mapKey].shiftError || (dayMap[mapKey].worktime > dayTimeMax);
            }
            if (planTypeLimits.planTypeFound) {
                dayMap[mapKey].plan_dayError = dayMap[mapKey].plan_dayError || (dayMap[mapKey].worktime > planTypeLimits.planType_dayTimeMax);
            }
        }
    }

    doWeekSpareTimeChecks(contractLimits, planTypeLimits, underageStats, weekRestMap, weekKey, dayMap, mapKey, storeSettings) {

        let finalContract_weekSpareDaysMin = contractLimits.contract_weekSpareDaysMin;
        let finalContract_weekSpareTimeMin = contractLimits.contract_weekSpareTimeMin;
        let split_days_ok = false;

        if (underageStats.underage && underageStats.rule && underageStats.rule.weekSpareTimeMin) {
            finalContract_weekSpareDaysMin = underageStats.rule.weekSpareDaysMin ? underageStats.rule.weekSpareDaysMin: 2;
            finalContract_weekSpareTimeMin = underageStats.rule.weekSpareTimeMin *60;
            if(storeSettings.country == 2){
                //fucking germans
                split_days_ok = true;
            }
        }
        if (weekRestMap[weekKey] != null) {


            if (planTypeLimits.planTypeFound) {
                if (weekRestMap[weekKey].spareTime < planTypeLimits.planType_weekSpareTimeMin || weekRestMap[weekKey].spareDays < planTypeLimits.planType_weekSpareDaysMin) {
                    dayMap[mapKey].plan_restWeekError = true;
                    dayMap[mapKey].plan_restWeekSpareTimeMissing = Math.max(0, planTypeLimits.planType_weekSpareTimeMin - weekRestMap[weekKey].spareTime);
                    dayMap[mapKey].plan_restWeekSpareDaysMissing = planTypeLimits.planType_weekSpareDaysMin - weekRestMap[weekKey].spareDays;
                }
            }
            if (contractLimits) {
                if(split_days_ok){
                    if(weekRestMap[weekKey].totalSpareDays < finalContract_weekSpareDaysMin){
                        if(storeSettings.country == 8){ //LUXEMBOURG ONLY GETS A WARNING AND NOT AN ERROR => use plan error
                            dayMap[mapKey].plan_restWeekError = true;
                            dayMap[mapKey].plan_restWeekSpareTimeMissing = Math.max(0, finalContract_weekSpareTimeMin - weekRestMap[weekKey].spareTime);
                            dayMap[mapKey].plan_restWeekSpareDaysMissing = finalContract_weekSpareDaysMin - weekRestMap[weekKey].spareDays;
                        } else {
                            dayMap[mapKey].restWeekError = true;
                            dayMap[mapKey].restWeekSpareTimeMissing = Math.max(0, finalContract_weekSpareTimeMin - weekRestMap[weekKey].spareTime);
                            dayMap[mapKey].restWeekSpareDaysMissing = finalContract_weekSpareDaysMin - weekRestMap[weekKey].spareDays;
                        }

                    }
                } else {
                    if (weekRestMap[weekKey].spareTime < finalContract_weekSpareTimeMin || weekRestMap[weekKey].spareDays < finalContract_weekSpareDaysMin) {
                        if(storeSettings.country == 8){ //LUXEMBOURG ONLY GETS A WARNING AND NOT AN ERROR => use plan error
                            dayMap[mapKey].plan_restWeekError = true;
                            dayMap[mapKey].plan_restWeekSpareTimeMissing = Math.max(0, finalContract_weekSpareTimeMin - weekRestMap[weekKey].spareTime);
                            dayMap[mapKey].plan_restWeekSpareDaysMissing = finalContract_weekSpareDaysMin - weekRestMap[weekKey].spareDays;
                        } else {
                            dayMap[mapKey].restWeekError = true;
                            dayMap[mapKey].restWeekSpareTimeMissing = Math.max(0, finalContract_weekSpareTimeMin - weekRestMap[weekKey].spareTime);
                            dayMap[mapKey].restWeekSpareDaysMissing = finalContract_weekSpareDaysMin - weekRestMap[weekKey].spareDays;
                        }

                    }
                }
            }

        }
    }

    doWeekMaxWorkTimeChecks(contractLimits, planTypeLimits, underageStats, pregnant, weekWorktime, weekKey, dayMap, mapKey, storeSettings) {
        let finalWeekTimeMax = contractLimits.contract_weekTimeMax;
        if(pregnant){
            finalWeekTimeMax = Math.min(finalWeekTimeMax, 40 * 60 * 60);
        }

        if (underageStats.underage && underageStats.rule && underageStats.rule.weekTimeMax) {
            finalWeekTimeMax = Math.min(finalWeekTimeMax, underageStats.rule.weekTimeMax * 60);
        }
        if (weekWorktime[weekKey] != null) {
            if(weekWorktime[weekKey].sum != null){
                if (contractLimits) {
                    if (weekWorktime[weekKey].sum > finalWeekTimeMax) {
                        dayMap[mapKey].weekError = true;
                    }
                }
                if (planTypeLimits.planTypeFound) {
                    if (weekWorktime[weekKey].sum > planTypeLimits.planType_weekTimeMax) {
                        dayMap[mapKey].plan_weekError = true;
                    }
                }
            }
            if(!storeSettings.allowWeeklyOvertime && weekWorktime[weekKey].overtimeSum != null && contractLimits){

                if(weekWorktime[weekKey].overtimeSum > contractLimits.contract_weeklyOvertimeCutoff){
                    dayMap[mapKey].weeklyOvertimeError = true;
                }
            }


        }

    }

    calculateSpareTime(shift, shiftStart, shiftEnd,  shiftMidnight, pastMidnight, shiftStartDay, dayMap, mapKey, isPreference, storeSettings, workDays) {
        if(!isPreference || (storeSettings.lawCheckSpareTimePrefTypes.includes(shift.type) && (shift.alwaysWork || workDays.includes(shiftStartDay.isoWeekday())))){
            if (pastMidnight) { // Shift goes past midnight - split //_d.getTime() is 1.15x faster
                //First half
                let diffFirst = shiftStart._d.getTime() - shiftStartDay._d.getTime();
                diffFirst *= 0.001;
                dayMap[mapKey].restTimeFirst = Math.min(dayMap[mapKey].restTimeFirst, diffFirst);
                dayMap[mapKey].restTimeSecond = 0;

                //Second half
                let mapKeySecondHalf = shiftEnd.format("YYYY-MM-DD");

                if (dayMap[mapKeySecondHalf] == undefined) {
                    dayMap[mapKeySecondHalf] = {
                        'shiftError': false,
                        'pregnantError': false,
                        'underageError': false,
                        'plan_underageError': false,
                        'plan_dayError': false,
                        'restError': false,
                        'restSpareTimeMissing': 0,
                        'legalRestingError': false,
                        'plan_restError': false,
                        'plan_restSpareTimeMissing': 0,
                        'weekError': false,
                        'plan_weekError': false,
                        'plan_skillError': false,
                        'restWeekError': false,
                        'plan_restWeekError': false,
                        'restWeekSpareTimeMissing': 0,
                        'plan_restWeekSpareTimeMissing': 0,
                        'restWeekSpareDaysMissing': 0,
                        'plan_restWeekSpareDaysMissing': 0,
                        'outsideContractError': false,
                        'date': null,
                        'worktime': 0,
                        'restTimeFirst': 86400,
                        'restTimeSecond': 86400,
                        'shiftOvertimeError': false,
                        'weeklyOvertimeError': false,
                        'traineeError': false,
                        'majorityOfWeekends': false
                    };
                }
                dayMap[mapKeySecondHalf].restTimeFirst = 0;
                let diffSecond = (shiftStartDay._d.getTime() + (2 * 24 * 60 * 60 * 1000)) - shiftEnd._d.getTime();
                diffSecond *= 0.001;

                dayMap[mapKeySecondHalf].restTimeSecond = Math.min(dayMap[mapKeySecondHalf].restTimeSecond, diffSecond);

            } else { // Shift is only on one day
                let diffFirst = shiftStart._d.getTime() - shiftStartDay._d.getTime();
                diffFirst *= 0.001;
                dayMap[mapKey].restTimeFirst = Math.min(dayMap[mapKey].restTimeFirst, diffFirst);
                let diffSecond = shiftMidnight._d.getTime() - shiftEnd._d.getTime();
                diffSecond *= 0.001;
                dayMap[mapKey].restTimeSecond = Math.min(dayMap[mapKey].restTimeSecond, diffSecond);
            }
        }


    }

    calculateWorkValueForDayAndWeek(workValueData, weekWorktime, dayMap) {
        if(workValueData.dayWorkValues){
            Object.keys(workValueData.dayWorkValues).forEach(key => {
                if(!dayMap[key]){
                    dayMap[key] = {
                        'shiftError': false,
                        'pregnantError': false,
                        'underageError': false,
                        'plan_underageError': false,
                        'plan_dayError': false,
                        'restError': false,
                        'restSpareTimeMissing': 0,
                        'legalRestingError': false,
                        'plan_restError': false,
                        'plan_restSpareTimeMissing': 0,
                        'weekError': false,
                        'plan_weekError': false,
                        'plan_skillError': false,
                        'restWeekError': false,
                        'plan_restWeekError': false,
                        'restWeekSpareTimeMissing': 0,
                        'plan_restWeekSpareTimeMissing': 0,
                        'restWeekSpareDaysMissing': 0,
                        'plan_restWeekSpareDaysMissing': 0,
                        'outsideContractError': false,
                        'date': null,
                        'worktime': 0,
                        'restTimeFirst': 86400,
                        'restTimeSecond': 86400,
                        'shiftOvertimeError': false,
                        'weeklyOvertimeError': false,
                        'traineeError': false,
                        'majorityOfWeekends': false
                    };
                }
                dayMap[key].worktime += workValueData.dayWorkValues[key];
            })
        }
        if(workValueData.weekWorkValues){
            Object.keys(workValueData.weekWorkValues).forEach(key => {
                if (weekWorktime[key] != null && weekWorktime[key].sum != null) {
                    weekWorktime[key].sum += workValueData.weekWorkValues[key];
                } else {
                    weekWorktime[key] = {
                        'sum':workValueData.weekWorkValues[key]
                    };
                }
            })
        }
        if(workValueData.weekOvertimeWorkValues){
            Object.keys(workValueData.weekOvertimeWorkValues).forEach(key => {
                if (weekWorktime[key] != null && weekWorktime[key].overtimeSum != null) {
                    weekWorktime[key].overtimeSum += workValueData.weekOvertimeWorkValues[key];
                } else {
                    if(weekWorktime[key] == null){
                        weekWorktime[key] = {
                            'sum':0,
                            'overtimeSum': 0
                        };
                    }
                    weekWorktime[key].overtimeSum = workValueData.weekOvertimeWorkValues[key];

                }
            })
        }


    }

    calculateWeekRestMap(dayMap, employee, contractLimits, storeSettings, youthWorkRules, birthday) {
        let weekRestMap = {}
        let weekKey = null;
        let currentSpareTime = 0;
        let currentSpareDays = 0;
        let currentSpareDaysTotal = 0;
        let preferDays = contractLimits.contract_weekSpareDaysMin > 0;

        // create restWeekDayMap to not fiddle with actual dayMap object
        // do not include the single days before and after the rump weeks in this week rest map calculation
        // otherwise those 2 days would always be marked as violation since there are only 24 hours in those weeks
        let restWeekDayMap = {};
        Object.entries(dayMap).forEach(([key, value], index) => {
            if (index > 0 && index < (Object.keys(dayMap).length - 1)) {
                restWeekDayMap[key] = value;
            }
        });

        //iterate through days and sum max sparetime per week
        Object.keys(restWeekDayMap).map((x) => { return {date: this.getMomentFromStringTZ(x), key: x} })
        .sort((a, b) => {return a.date - b.date;})
        .forEach((obj) => {
            
            let x = obj.key;
            let dayStart = obj.date;



            let tweekKey = dayStart.isoWeek();

            let underageStats = this.calculateUnderageStats(dayStart, birthday, youthWorkRules)

            if (tweekKey != weekKey && weekKey != null) {
                let weekEntry = weekRestMap[weekKey];
                if (!weekEntry) {
                    weekRestMap[weekKey] = {
                        spareTime: currentSpareTime,
                        spareDays: currentSpareDays,
                        spareDaysTotal: currentSpareDaysTotal
                    };
                } else if ((weekEntry.spareTime < currentSpareTime && (weekEntry.spareDays <= currentSpareDays || !preferDays)) || (weekEntry.spareDays < currentSpareDays && preferDays)) {
                    weekEntry.spareTime = currentSpareTime;
                    weekEntry.spareDays = currentSpareDays;
                    weekEntry.spareDaysTotal = currentSpareDaysTotal;
                } else {
                    weekEntry.spareDaysTotal = currentSpareDaysTotal;
                }
                currentSpareTime = 0;
                currentSpareDays = 0;
                currentSpareDaysTotal = 0;
            }
            currentSpareTime += restWeekDayMap[x].restTimeFirst;
            if (restWeekDayMap[x].restTimeFirst == 86400) {
                currentSpareDays += 1;
                currentSpareDaysTotal +=1;
            }
            let prevDay = dayStart.clone().subtract(1, 'days');
            let prevWeekKey = prevDay.isoWeek();

            if (prevWeekKey == tweekKey) {

                let prevKey = prevDay.format("YYYY-MM-DD");

                if (restWeekDayMap[prevKey] && restWeekDayMap[prevKey].restTimeSecond != 86400) { //previous day had shift, so add the sparetime after the shift to current spare time sum

                    currentSpareTime += restWeekDayMap[prevKey].restTimeSecond;
                }
            }
            if (restWeekDayMap[x].restTimeFirst != 86400) {
                //day has a shift, end spare time summation and check if it beats current week max

                let weekEntry = weekRestMap[weekKey];
                if (!weekEntry) {
                    weekRestMap[weekKey] = {
                        spareTime: currentSpareTime,
                        spareDays: currentSpareDays,
                        spareDaysTotal: currentSpareDaysTotal
                    };
                } else if ((weekEntry.spareTime < currentSpareTime && (weekEntry.spareDays <= currentSpareDays || !preferDays)) || (weekEntry.spareDays < currentSpareDays && preferDays)) {
                    weekEntry.spareTime = currentSpareTime;
                    weekEntry.spareDays = currentSpareDays;
                    weekEntry.spareDaysTotal = currentSpareDaysTotal
                }
                currentSpareTime = 0;
                currentSpareDays = 0;
            }
            if(dayStart.isoWeekday() == 7){
                //we are on a sunday, so check the rest time after a potential shift from saturday
                let sunDayCurrentSpareTime = 0;
                let sunDayCurrentSpareDays = 0;
                if (restWeekDayMap[x].restTimeFirst == 86400) {
                    //sunday is entirely free => the current spare time is already our sunday spare time, we are simply continuing
                    sunDayCurrentSpareTime = currentSpareTime;
                    sunDayCurrentSpareDays = currentSpareDays;

                } else {
                    //sunday has a shift, so we start a new count with the spare time after the shift
                    sunDayCurrentSpareTime = restWeekDayMap[x].restTimeSecond;
                }

                //then check if we can add the spare time of next week, until the next shift, to it. But only in Germany.
                let allowedCompanies = [115, 195, 196, 210, 218, 219, 220];
                if(storeSettings.country == 2 || (storeSettings.country == 1 && underageStats.underage) || allowedCompanies.includes(storeSettings.companyId)){
                    let nextWeekSpareTime = 0;
                    let nextWeekSpareDays = 0;
                    let nextMonday = dayStart.clone().add(1, 'days').startOf('day');
                    let nextWeekEnd = nextMonday.clone().endOf('week').add(1, 'days').startOf('day');
                    while(nextMonday < nextWeekEnd){
                        let nextKey = nextMonday.format("YYYY-MM-DD");
                        if(restWeekDayMap[nextKey]){
                            if(restWeekDayMap[nextKey].restTimeFirst == 86400){
                                nextWeekSpareDays++;
                            }
                            nextWeekSpareTime += restWeekDayMap[nextKey].restTimeFirst;

                            if(restWeekDayMap[nextKey].restTimeFirst != 86400){
                                //found the next shift -> stop
                                break;
                            }
                        }

                        nextMonday = nextMonday.add(1, 'days');
                    }

                    //add to sunday sparetime, but only the amount that is not used by next week's spare time needs
                    if(contractLimits){
                        let weekSpareTimeMin = contractLimits.contract_weekSpareTimeMin;
                        let weekSpareDaysMin = contractLimits.contract_weekSpareDaysMin;
                        if(underageStats.underage && underageStats.rule){
                            if(underageStats.rule.weekSpareTimeMin != null){
                                weekSpareTimeMin = underageStats.rule.weekSpareTimeMin *60;
                            }
                            if(underageStats.rule.weekSpareDaysMin != null){
                                weekSpareDaysMin = underageStats.rule.weekSpareDaysMin;
                            }
                        }

                        //first check if it even is above the necessary minimum
                        let nextWeekendKey = nextWeekEnd.format("YYYY-MM-DD");
                        if(nextWeekSpareTime >= weekSpareTimeMin && nextWeekSpareDays >= weekSpareDaysMin && restWeekDayMap[nextWeekendKey] ){
                            //calculate the remainder
                            let spareTimeRemainder = Math.max(0, nextWeekSpareTime - weekSpareTimeMin);
                            let spareDaysRemainder = Math.max(0, nextWeekSpareDays - weekSpareDaysMin);
                            
                            //add remainder
                            sunDayCurrentSpareTime += spareTimeRemainder;
                            sunDayCurrentSpareDays += spareDaysRemainder;
                        } else {
                            //add all because the spare time of next week until the next shift does not fulfill the sparetime req anyway or it concerns future month week
                            sunDayCurrentSpareTime += nextWeekSpareTime;
                            sunDayCurrentSpareDays += nextWeekSpareDays;
                            
                        }

                    }



                }

                let weekEntry = weekRestMap[weekKey];
                if (!weekEntry) {
                    weekRestMap[weekKey] = {
                        spareTime: sunDayCurrentSpareTime,
                        spareDays: sunDayCurrentSpareDays,
                        spareDaysTotal: currentSpareDaysTotal
                    };
                } else if ((weekEntry.spareTime < sunDayCurrentSpareTime && (weekEntry.spareDays <= sunDayCurrentSpareDays || !preferDays)) || (weekEntry.spareDays < sunDayCurrentSpareDays && preferDays)) {
                    weekEntry.spareTime = sunDayCurrentSpareTime;
                    weekEntry.spareDays = sunDayCurrentSpareDays;
                    weekEntry.spareDaysTotal = currentSpareDaysTotal
                }


            }
            weekKey = tweekKey;
        });
        //one last iteration at the end in case we ended on a spare day
        let weekEntry = weekRestMap[weekKey];
        if (!weekEntry) {
            weekRestMap[weekKey] = {
                spareTime: currentSpareTime,
                spareDays: currentSpareDays,
                spareDaysTotal: currentSpareDaysTotal
            };
        } else if ((weekEntry.spareTime < currentSpareTime && (weekEntry.spareDays <= currentSpareDays || !preferDays)) || (weekEntry.spareDays < currentSpareDays && preferDays)) {
            weekEntry.spareTime = currentSpareTime;
            weekEntry.spareDays = currentSpareDays;
            weekEntry.spareDaysTotal = currentSpareDaysTotal;
        } else {
            weekEntry.spareDaysTotal = currentSpareDaysTotal;
        }
        
        return weekRestMap;
    }

    checkIfRangeFulfillsSpareTime(employee, from, to, spareDays, spareTime) {
        let result = false
        if (to.diff(from, 'minutes') < spareTime) {
            result = false;
        } else {
            let fromClone = null;
            if (from.hour() == 0 && from.minute() == 0) {
                fromClone = from.clone().add(spareDays);
            } else {
                //start counting from next full day
                fromClone = from.clone().add(1, 'days').startOf('day').add(spareDays, 'days');
            }
            if (fromClone > to) {
                result = false;
            } else {
                result = true;
            }
            /*if(employee.lastName == 'Heller'){
                console.log(from.format()+" - "+to.format()+" "+result+" "+fromClone.format())
            } */
        }

        return result;
    }

    determineSpareTimeRanges(employee, employeeDateCombinedShiftMap, employeePreferenceAvailabilityMap, planShiftMomentMap, actualShiftMomentMap, employeePreferenceMomentMap, rosterFromTo, spareDays, spareTime, storeSettings, countAllPrefs = false) {
        let weekFreeMap = {

        }

        let shifts = this.getCombinedShiftsPreferencesArray(employee, employeeDateCombinedShiftMap, employeePreferenceAvailabilityMap, planShiftMomentMap, actualShiftMomentMap, employeePreferenceMomentMap, countAllPrefs);

        //Checks Per Shift/Day
        let previousShiftEnd = null;
        let previousShiftStart = null;

        for (let k = 0; k < shifts.length; k++) {
            let shift = shifts[k];

            let shiftStart = null;
            let shiftEnd = null;

            let isActualShift = false;
            let isPlanShift = false;
            let isPreference = false;
            if (actualShiftMomentMap[shift.id]) {
                shiftStart = actualShiftMomentMap[shift.id].fromDate;
                shiftEnd = actualShiftMomentMap[shift.id].toDate;
                isActualShift = true;
            } else if (planShiftMomentMap[shift.id]) {
                shiftStart = planShiftMomentMap[shift.id].fromDate;
                shiftEnd = planShiftMomentMap[shift.id].toDate;
                isPlanShift = true;
            } else if (employeePreferenceMomentMap[shift.id]) {
                shiftStart = employeePreferenceMomentMap[shift.id].fromDate;
                shiftEnd = employeePreferenceMomentMap[shift.id].toDate;
                isPreference = true;
            }
            if(!isPreference || (storeSettings.lawCheckSpareTimePrefTypes.includes(shift.type))){
                let mapKey = shiftStart.year() + "-" + shiftStart.isoWeek();
                if (previousShiftEnd != null) {
                    if (previousShiftEnd.isoWeek() != shiftStart.isoWeek()) {
                        //first check time from prevshiftend to end of that week
                        let prevWeekEnd = previousShiftEnd.clone().endOf('week').add(1, 'days').startOf('day');
                        let prevDiff = prevWeekEnd.diff(previousShiftEnd, 'minutes');
                        let prevWeekKey = previousShiftEnd.year() + "-" + previousShiftEnd.isoWeek();
                        if (prevDiff >= 0) {
                            if (!weekFreeMap[prevWeekKey]) {
                                weekFreeMap[prevWeekKey] = [];
                            }
                            let entry = {
                                from: previousShiftEnd.clone(),
                                to: prevWeekEnd,
                                diff: prevDiff,
                                isSpare: false
                            };
                            entry.isSpare = this.checkIfRangeFulfillsSpareTime(employee, entry.from, entry.to, spareDays, spareTime);
                            weekFreeMap[prevWeekKey].push(entry);
                        }
                        //next check start of week to this shift start
                        let curWeekStart = shiftStart.clone().startOf('week');
                        let curDiff = shiftStart.diff(curWeekStart, 'minutes');
                        if (curDiff >= 0) {
                            if (!weekFreeMap[mapKey]) {
                                weekFreeMap[mapKey] = []
                            }
                            let entry = {
                                from: curWeekStart,
                                to: shiftStart.clone(),
                                diff: curDiff,
                                isSpare: false
                            }
                            entry.isSpare = this.checkIfRangeFulfillsSpareTime(employee, entry.from, entry.to, spareDays, spareTime);
                            weekFreeMap[mapKey].push(entry);
                        }
                    } else {
                        let diff = shiftStart.diff(previousShiftEnd, 'minutes');
                        if (diff >= 0) {
                            if (!weekFreeMap[mapKey]) {
                                weekFreeMap[mapKey] = []
                            }
                            let entry = {
                                from: previousShiftEnd.clone(),
                                to: shiftStart.clone(),
                                diff: diff,
                                isSpare: false
                            }
                            entry.isSpare = this.checkIfRangeFulfillsSpareTime(employee, entry.from, entry.to, spareDays, spareTime);
                            weekFreeMap[mapKey].push(entry);
                        }
                    }
                } else {
                    //check from week start to shift from
                    let weekStart = shiftStart.clone().startOf('week');
                    let diff = shiftStart.diff(weekStart, 'minutes');
                    if (diff >= 0) {
                        if (!weekFreeMap[mapKey]) {
                            weekFreeMap[mapKey] = []
                        }
                        let entry = {
                            from: weekStart,
                            to: shiftStart.clone(),
                            diff: diff,
                            isSpare: false
                        }
                        entry.isSpare = this.checkIfRangeFulfillsSpareTime(employee, entry.from, entry.to, spareDays, spareTime);
                        weekFreeMap[mapKey].push(entry);
                    }
                }
                previousShiftEnd = shiftEnd;
            }



        }
        //check from previousShiftEnd to end of week
        if (previousShiftEnd != null) {
            let mapKey = previousShiftEnd.year() + "-" + previousShiftEnd.isoWeek();
            let weekEnd = previousShiftEnd.clone().endOf('week').add(1, 'days').startOf('day');
            let diff = weekEnd.diff(previousShiftEnd, 'minutes')
            if (diff >= 0) {
                if (!weekFreeMap[mapKey]) {
                    weekFreeMap[mapKey] = []
                }
                let entry = {
                    from: previousShiftEnd.clone(),
                    to: weekEnd,
                    diff: diff,
                    isSpare: false
                }
                entry.isSpare = this.checkIfRangeFulfillsSpareTime(employee, entry.from, entry.to, spareDays, spareTime);
                weekFreeMap[mapKey].push(entry);
            }
        }
        //at this point the map contains all intervalls between shifts and weekends, but some weeks might not have had shifts so we need to check for them
        let rosterFrom = this.getMomentFromStringTZ(rosterFromTo.from);
        let rosterTo = this.getMomentFromStringTZ(rosterFromTo.to);
        while (rosterFrom < rosterTo) {
            let mapKey = rosterFrom.year() + "-" + rosterFrom.isoWeek();
            if (!weekFreeMap[mapKey]) {
                weekFreeMap[mapKey] = [];
                let weekEnd = rosterFrom.clone().endOf('week').add(1, 'days').startOf('day');
                let entry = {
                    from: rosterFrom.clone(),
                    to: weekEnd,
                    diff: weekEnd.diff(rosterFrom, 'minutes'),
                    isSpare: false
                }
                entry.isSpare = this.checkIfRangeFulfillsSpareTime(employee, entry.from, entry.to, spareDays, spareTime);
                weekFreeMap[mapKey].push(entry);
            }
            rosterFrom.add(1, 'weeks')
        }
        //ok now we just need to filter out the intervals that are actually legit spare times, we only need 1 per week
        let finalMap = {

        }
        for (let key in weekFreeMap) {
            let intervals = weekFreeMap[key];
            for (let i = 0; i < intervals.length; i++) {
                if (intervals[i].isSpare) {
                    //we only need the real interval
                    let from = intervals[i].from;
                    let to = from.clone().add(spareTime, 'minutes');
                    let entry = {
                        from: from,
                        to: to
                    };
                    finalMap[key] = entry;
                    break;
                }
            }
        }
        return finalMap;
    }

    getCombinedShiftsPreferencesArray(employee, employeeDateCombinedShiftMap, employeePreferenceAvailabilityMap, planShiftMomentMap, actualShiftMomentMap, employeePreferenceMomentMap) {
        let shifts = employeeDateCombinedShiftMap[employee.id] ? employeeDateCombinedShiftMap[employee.id].shifts : [];
        shifts = shifts.slice(0);
        if (employeePreferenceAvailabilityMap[employee.id]) {
            employeePreferenceAvailabilityMap[employee.id].preferences.forEach(pref => {
                //only add if its a approved pref of a type that counts as workday and if there is no shift on that day
                if (pref.approved && pref.state == 1 && employeePreferenceMomentMap[pref.id]) {
                    /*let dateKey = employeePreferenceMomentMap[pref.id].fromDate.format("YYYY-MM-DD");
                    if (!employeeDateCombinedShiftMap[employee.id] || !employeeDateCombinedShiftMap[employee.id][dateKey] || employeeDateCombinedShiftMap[employee.id][dateKey].length == 0) {
                        shifts.push(pref);
                    }*/
                    shifts.push(pref);
                }
            })
            //sort shifts by from
            shifts.sort((a, b) => {
                let aMap = actualShiftMomentMap[a.id] ? actualShiftMomentMap[a.id] : (planShiftMomentMap[a.id] ? planShiftMomentMap[a.id] : employeePreferenceMomentMap[a.id]);
                let bMap = actualShiftMomentMap[b.id] ? actualShiftMomentMap[b.id] : (planShiftMomentMap[b.id] ? planShiftMomentMap[b.id] : employeePreferenceMomentMap[b.id]);
                if (aMap && bMap) {
                    return aMap.fromDate < bMap.fromDate ? -1 : (aMap.fromDate > bMap.fromDate ? 1 : 0)
                } else {
                    return 0
                }
            })
        }

        return shifts;
    }

    getCombinedShiftsPreferencesArrayForLegalCheck(employee, employeeDateCombinedShiftMap, employeePreferenceAvailabilityMap, planShiftMomentMap, actualShiftMomentMap, employeePreferenceMomentMap, splitPreferenceMomentMap) {
        let shifts = employeeDateCombinedShiftMap[employee.id] ? employeeDateCombinedShiftMap[employee.id].shifts : [];
        shifts = shifts.slice(0);
        if (employeePreferenceAvailabilityMap[employee.id]) {
            employeePreferenceAvailabilityMap[employee.id].preferences.forEach(pref => {
                //only add if its a approved pref of a type that counts as workday and if there is no shift on that day
                if (pref.approved && pref.state == 1 && employeePreferenceMomentMap[pref.id]) {
                    let prefFrom = employeePreferenceMomentMap[pref.id].fromDate;
                    let prefTo = employeePreferenceMomentMap[pref.id].toDate;
                    if(prefTo.diff(prefFrom, 'minutes') > 24*60){
                        //split pref into daily chunks
                        let start = prefFrom.clone();
                        let count = 0;
                        while (start < prefTo){
                            let prefCopy = Object.assign({}, pref);
                            prefCopy.id+="-"+count;
                            prefCopy.groupId = pref.id;
                            let nPrefFrom = start.clone();
                            let nPrefTo = start.clone().add(1, 'days').startOf('day');

                            if(nPrefTo > prefTo){
                                nPrefTo = prefTo.clone();
                            }
                            prefCopy.from = nPrefFrom.format();
                            prefCopy.to = nPrefTo.format();
                            if(pref.workValue > 0){
                                prefCopy.workValue = Math.round(pref.workValue * (nPrefTo.unix() - nPrefFrom.unix())/(prefTo.unix() - prefFrom.unix()));
                            }
                            /*
                            let dateKey = nPrefFrom.format("YYYY-MM-DD");
                            if (!employeeDateCombinedShiftMap[employee.id] || !employeeDateCombinedShiftMap[employee.id][dateKey] || employeeDateCombinedShiftMap[employee.id][dateKey].length == 0) {
                                shifts.push(prefCopy);
                            }
                            */
                            shifts.push(prefCopy);
                            splitPreferenceMomentMap[prefCopy.id] =  {fromDate: nPrefFrom, toDate: nPrefTo}
                            count++;

                            start = start.add(24*60, 'minutes');
                        }
                    } else {
                        /*
                        let dateKey = employeePreferenceMomentMap[pref.id].fromDate.format("YYYY-MM-DD");
                        if (!employeeDateCombinedShiftMap[employee.id] || !employeeDateCombinedShiftMap[employee.id][dateKey] || employeeDateCombinedShiftMap[employee.id][dateKey].length == 0) {
                            shifts.push(pref);
                        } */
                        shifts.push(pref);
                        splitPreferenceMomentMap[pref.id] =  {fromDate: prefFrom, toDate: prefTo}
                    }


                }
            })
            //sort shifts by from
            shifts.sort((a, b) => {
                let aMap = actualShiftMomentMap[a.id] ? actualShiftMomentMap[a.id] : (planShiftMomentMap[a.id] ? planShiftMomentMap[a.id] : splitPreferenceMomentMap[a.id]);
                let bMap = actualShiftMomentMap[b.id] ? actualShiftMomentMap[b.id] : (planShiftMomentMap[b.id] ? planShiftMomentMap[b.id] : splitPreferenceMomentMap[b.id]);
                if (aMap && bMap) {
                    return aMap.fromDate < bMap.fromDate ? -1 : (aMap.fromDate > bMap.fromDate ? 1 : 0)
                } else {
                    return 0
                }
            })
        }

        return shifts;
    }

    determineYouthWorkRules(employee, storeSettings, youthWorkConfigMap) {
        let rules = [];
        if(storeSettings && youthWorkConfigMap){
            if(employee.youthWorkConfigId != null && youthWorkConfigMap[employee.youthWorkConfigId]){
                rules =  youthWorkConfigMap[employee.youthWorkConfigId].rules ? youthWorkConfigMap[employee.youthWorkConfigId].rules : [];
            } else if(storeSettings.defaultYouthWorkConfig != null && youthWorkConfigMap[storeSettings.defaultYouthWorkConfig]){
                rules =  youthWorkConfigMap[storeSettings.defaultYouthWorkConfig].rules ? youthWorkConfigMap[storeSettings.defaultYouthWorkConfig].rules : [];
            } else {
                //need to determine default config
                let config = Object.values(youthWorkConfigMap).find(i => i.base && i.country == storeSettings.country);
                if(config){
                    rules = config.rules ? config.rules : []
                } else {
                    //just to be sure for now, use default rule
                    rules.push({maxAge: 18, weekTimeMax: 40*60, dayTimeMax: 8*60, restTime: 12*60, weekSpareTimeMin: 48*60, weekSpareDaysMin: 2, startTimeMin: '06:00', endTimeMax: '20:00'});
                }
            }
        } else {
           //just to be sure for now, use default rule
           console.log("Using default ywr")
           rules.push({maxAge: 18, weekTimeMax: 40*60, dayTimeMax: 8*60, restTime: 12*60, weekSpareTimeMin: 48*60, weekSpareDaysMin: 2, startTimeMin: '06:00', endTimeMax: '20:00'});

        }

        return rules;
    }

    performLegalAndPlantypeChecks(employeeMap, employeeTypeMap, employeeSkillMap,spotMap,
                                allowedContractMap,
                                collectiveContractMap, storeSettings, rosterFromTo, helpers, calculatedShiftMaps, calculatedPreferenceMaps,
                                youthWorkConfigMap, employeeAvgWorktimeMap) {



        let map = {};
        //Create the template Map, so we get the dates which are the keys of the map
        let rosterFrom = this.getMomentFromStringTZ(rosterFromTo.from).add(-1, 'days');
        let rosterTo = this.getMomentFromStringTZ(rosterFromTo.to).add(1, 'days');

        let monthFrom = rosterFrom.clone().date(1).month(rosterFromTo.month).year(rosterFromTo.year);
        let monthTo = monthFrom.clone().add(1, 'month');


        let mapTemplate = {};
        //sundays needed for the g*rmans
        let weekEndDayKeys = []
        let saturDayKeys = []
        let tRosterFrom = rosterFrom.clone();
        let tRosterTo = rosterTo.clone().add(1,'days');
        while (tRosterTo.diff(tRosterFrom) > 0) {
            let dateString = tRosterFrom.format("YYYY-MM-DD");
            if (tRosterFrom.isoWeekday() == 7 && tRosterFrom.month() == rosterFromTo.month && tRosterFrom.year() == rosterFromTo.year) {
                let satKey = tRosterFrom.clone().add(-1, 'days').format("YYYY-MM-DD");
                weekEndDayKeys.push({sunDay: dateString, satDay: satKey});
            }
            if (tRosterFrom.isoWeekday() == 6 && tRosterFrom.month() == rosterFromTo.month && tRosterFrom.year() == rosterFromTo.year) {
                
                saturDayKeys.push(dateString);
            }

            mapTemplate[dateString] = {};
            tRosterFrom.add(1, 'days');
        }


        let dateString = rosterFrom.format("YYYY-MM-DD");
        mapTemplate[dateString] = {};
        //template map creation end
        let momentDateBoundaryMap = {}; //momentDateBoundaryMap[dateKey] = {startOfDay: ..., endOfDay: ...};


        for (let i in employeeMap) {
            let employee = employeeMap[i];
            let dayMap = this.calculateLegalDayMapForEmployee(employee,
                                                            mapTemplate,
                                                            weekEndDayKeys,
                                                            saturDayKeys,
                                                            momentDateBoundaryMap,
                                                            monthFrom,
                                                            monthTo,
                                                            storeSettings,
                                                            rosterFromTo,
                                                            rosterFrom,
                                                            rosterTo,
                                                            calculatedShiftMaps,
                                                            calculatedPreferenceMaps,
                                                            collectiveContractMap,
                                                            allowedContractMap,
                                                            spotMap,
                                                            employeeMap,
                                                            employeeSkillMap,
                                                            employeeTypeMap,

                                                            employeeAvgWorktimeMap,
                                                            youthWorkConfigMap,
                                                            helpers);

            map[employee.id] = dayMap;
        }


        return map;
    }
    calculateLegalDayMapForEmployee(employee,
                                    mapTemplate,
                                    weekEndDayKeys,
                                    saturDayKeys,
                                    momentDateBoundaryMap,
                                    monthFrom,
                                    monthTo,
                                    storeSettings,
                                    rosterFromTo,
                                    rosterFrom,
                                    rosterTo,
                                    calculatedShiftMaps,
                                    calculatedPreferenceMaps,
                                    collectiveContractMap,
                                    allowedContractMap,
                                    spotMap,
                                    employeeMap,
                                    employeeSkillMap,
                                    employeeTypeMap,
                                    employeeAvgWorktimeMap,
                                    youthWorkConfigMap,
                                    helpers){

        let actualShiftMomentMap = calculatedShiftMaps.actualShiftMomentMap;
        let actualBreakMomentMap = calculatedShiftMaps.actualBreakMomentMap;
        let actualBreakShiftIdMap = calculatedShiftMaps.actualBreakShiftIdMap;
        let planShiftMomentMap = calculatedShiftMaps.planShiftMomentMap;
        let employeeEmployeeSkillMap = this.getEmployeeEmployeeSkillMap(employeeSkillMap);
        let employeeIdContractMap = calculatedShiftMaps.employeeIdContractMap;
        let employeeContractMomentMap = calculatedShiftMaps.employeeContractMomentMap;
        let employeeDateCombinedShiftMap = calculatedShiftMaps.employeeDateCombinedShiftMap;

        let employeePreferenceMomentMap = calculatedPreferenceMaps.employeePreferenceMomentMap;
        let employeePreferenceAvailabilityMap = calculatedPreferenceMaps.employeePreferenceAvailabilityMap;


        let isPastNovember2021 = rosterFromTo.year > 2021 || (rosterFromTo.year == 2021 && rosterFromTo.month >= 10); //date after which we take prefs for legal checks into account
        let isPastJune2023 = (rosterFromTo.year > 2023 || (rosterFromTo.year == 2023 && rosterFromTo.month >= 5)) || storeSettings.companyId == 16;
        let isPastMay2024 = (rosterFromTo.year > 2024 || (rosterFromTo.year == 2024 && rosterFromTo.month >= 4)); // date after which underage trainees are not allowed to work on sundays for the first 8 weeks of employment
        let workDayCalcMode = (isPastJune2023 ? storeSettings.workDayCalcMode : 2);

        let birthday = employee.dob ? this.getMomentFromStringTZ(employee.dob) : null;
        let youthWorkRules = this.determineYouthWorkRules(employee, storeSettings, youthWorkConfigMap);
        let pregnantMap = helpers.GetPregnantFlagMapFromContracts(rosterFrom, rosterTo, employeeIdContractMap[employee.id]);

        //create a new map
        let dayMap = {};
        for (let x in mapTemplate) {
            dayMap[x] = {
                    'shiftError': false,
                    'pregnantError': false,
                    'underageError': false,
                    'plan_underageError': false,
                    'plan_dayError': false,
                    'restError': false,
                    'restSpareTimeMissing': 0,
                    'legalRestingError': false,
                    'plan_restError': false,
                    'plan_restSpareTimeMissing': 0,
                    'weekError': false,
                    'plan_weekError': false,
                    'plan_skillError': false,
                    'restWeekError': false,
                    'plan_restWeekError': false,
                    'restWeekSpareTimeMissing': 0,
                    'plan_restWeekSpareTimeMissing': 0,
                    'restWeekSpareDaysMissing': 0,
                    'plan_restWeekSpareDaysMissing': 0,
                    'outsideContractError': false,
                    'date': null,
                    'worktime': 0,
                    'restTimeFirst': 86400,
                    'restTimeSecond': 86400,
                    'shiftOvertimeError': false,
                    'weeklyOvertimeError': false,
                    'shiftDeclinedError': 0,
                    'shiftEnforced': false,
                    'shiftLongerThanTenHours': false,
                    'traineeError': false,
                    'daysConsecutiveMax': false,
                    'plan_daysConsecutiveMax': false,
                    'majorityOfWeekends': false
            };
        }




        let planTypeLimits = this.calculatePlanTypeLimits(employee, employeeTypeMap);

        let contractLimits = this.calculateContractLimits(employee, employeeIdContractMap, allowedContractMap, collectiveContractMap, storeSettings, monthFrom, monthTo);



        if (contractLimits || planTypeLimits.planTypeFound) {
                //only perform the checks, if there are even shifts, otherwise the checks are useless
            let shifts = [];
            let splitPreferenceMomentMap = {};
            if (isPastNovember2021) {
                shifts = this.getCombinedShiftsPreferencesArrayForLegalCheck(employee, employeeDateCombinedShiftMap, employeePreferenceAvailabilityMap, planShiftMomentMap, actualShiftMomentMap, employeePreferenceMomentMap, splitPreferenceMomentMap);

            } else {
                shifts = this.getCombinedShiftsPreferencesArrayForLegalCheck(employee, employeeDateCombinedShiftMap, {}, planShiftMomentMap, actualShiftMomentMap, employeePreferenceMomentMap, splitPreferenceMomentMap);

            }
            
            if (shifts != null && shifts != undefined && shifts.length > 0) {
                //need to add preferences that count as workday

                //Checks Per Shift/Day
                let assignedWeekends = {};
                let previousShiftEnd = null;
                let previousShiftStart = null;
                let previousShift = null;
                let weekWorktime = {};
                let counter24HoursShifts = 0;
                let startOfWeek = null;

                for (let k = 0; k < shifts.length; k++) {
                    let shift = shifts[k];

                    let shiftStart = null;
                    let shiftEnd = null;

                    let isActualShift = false;
                    let isPlanShift = false;
                    let isPreference = false;
                    if (actualShiftMomentMap[shift.id]) {
                        shiftStart = actualShiftMomentMap[shift.id].fromDate;
                        shiftEnd = actualShiftMomentMap[shift.id].toDate;
                        isActualShift = true;
                    } else if (planShiftMomentMap[shift.id]) {
                        shiftStart = planShiftMomentMap[shift.id].fromDate;
                        shiftEnd = planShiftMomentMap[shift.id].toDate;
                        isPlanShift = true;
                    } else if (splitPreferenceMomentMap[shift.id]) {
                        shiftStart = splitPreferenceMomentMap[shift.id].fromDate;
                        shiftEnd = splitPreferenceMomentMap[shift.id].toDate;

                        isPreference = true;
                    }

                    let mapKey = shiftStart.format("YYYY-MM-DD");
                    let previousMapKey = previousShiftStart != null ? previousShiftStart.format("YYYY-MM-DD") : null;
                    let pregnant = pregnantMap[mapKey] != null ? pregnantMap[mapKey] : false;

                    if (!momentDateBoundaryMap[mapKey]) { //might as well save some clones (1600 from bigger store)
                        let pregMax = storeSettings.country == 8 ? 22 : (storeSettings.country == 1 && storeSettings.marketType == 1 && storeSettings.companyId != 124 ? 22 : 20);
                        momentDateBoundaryMap[mapKey] = {
                            startOfDay: shiftStart.clone().startOf('day'),
                            startOfNextDay: shiftStart.clone().startOf('day').add(1, 'day'),
                            pregCantBeBelow: shiftStart.clone().startOf('day').hours(6),
                            pregCantBeAbove: shiftStart.clone().startOf('day').hours(pregMax),

                        };
                    }

                    let today = momentDateBoundaryMap[mapKey].startOfDay;

                    let underageStats = this.calculateUnderageStats(today, birthday, youthWorkRules);

                    if (isPlanShift) {
                        //check if employee has required skill
                        this.doRequiredSkillCheck(shift, employee, mapKey, spotMap, employeeMap, employeeEmployeeSkillMap, dayMap);
                    }

                    if (isActualShift && !shift.endMissing && !storeSettings.noBreaks) {
                        //check if there's enough breaks if it's an actual shift
                        let requiredBreakCounts = this.calculateRequiredBreakCounts(shift, shiftStart, shiftEnd, actualBreakShiftIdMap, actualBreakMomentMap, storeSettings);
                        this.doRequiredBreaksCheck(requiredBreakCounts, underageStats, dayMap, mapKey, storeSettings);
                    } 




                    if (isActualShift || isPlanShift) {
                        //pregnant people cant work before 6:00 or after 20:00
                        this.doPregnantShiftBoundaryCheck(pregnant, shiftStart, shiftEnd, momentDateBoundaryMap, dayMap, mapKey);
                        //underage people cant work before 6:00 or after 20:00 / 22:00
                        this.doUnderageShiftBoundaryCheck(underageStats, shiftStart, shiftEnd, dayMap[mapKey], momentDateBoundaryMap[mapKey].startOfDay, helpers);
                        //underage people need to have every 2nd sunday off or 2 sundays per month in g*rmany
                        this.doUnderageDoubleSundayCheck(employee, underageStats, today, birthday, storeSettings, weekEndDayKeys, saturDayKeys, employeeDateCombinedShiftMap, dayMap, mapKey);
                        //starting May 2024, trainees are not allowed to work on sundays in the first 8 weeks of their employment
                        if(isPastMay2024){
                            this.doTraineeEightWeeksSundayCheck(employee, underageStats, today, birthday, storeSettings, weekEndDayKeys, employeeDateCombinedShiftMap, dayMap, mapKey, employeeIdContractMap, employeeContractMomentMap, allowedContractMap);
                        }

                        //holiday check for G*rmans
                        this.doUnderageHolidayCheck(underageStats, today, shiftStart, shiftEnd, storeSettings, dayMap, mapKey);

                        // Frontend Check for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3"
                        if([474,475,481].includes(storeSettings.id)){
                            this.doMaxThreeConsecutiveSundayCheck(employee, underageStats, today, storeSettings, weekEndDayKeys, employeeDateCombinedShiftMap, dayMap, mapKey);
                            this.doMaxTwoConsecutiveLongShiftsCheck(employee, today, employeeDateCombinedShiftMap, planShiftMomentMap, workDayCalcMode, dayMap, mapKey, storeSettings, helpers);
                        }
                    }


                    if (dayMap[mapKey]) {
                        if (isActualShift || isPlanShift) {
                            //check #0 is shift within boundaries of a contract
                            this.doShiftInsideContractCheck(employee, shiftStart, shiftEnd, employeeIdContractMap, contractLimits, dayMap, mapKey);

                        }
                        if (isActualShift || isPlanShift || (isPreference && storeSettings.lawCheckRestTimePrefTypes.includes(shift.type))) {
                            //Check #1 , are there 11 hours between shifts rest time?
                            if(previousShift != null && (previousShift.groupId == null || shift.groupId == null || previousShift.groupId != shift.groupId)){

                                this.doContractRestTimeBetweenShiftsCheck(contractLimits, underageStats, shiftStart, shiftEnd, previousShiftStart, previousShiftEnd, dayMap, mapKey, previousMapKey);
                                this.doPlanTypeRestTimeBetweenShiftsCheck(planTypeLimits, shiftStart, shiftEnd, previousShiftStart, previousShiftEnd, dayMap, mapKey, previousMapKey);

                            }

                            previousShiftEnd = shiftEnd;
                            previousShiftStart = shiftStart;
                            previousShift = shift;
                        }

                        let shiftStartDay = momentDateBoundaryMap[mapKey].startOfDay;
                        let shiftMidnight = momentDateBoundaryMap[mapKey].startOfNextDay;

                        let pastMidnight = shiftEnd._d.getTime() > shiftMidnight._d.getTime();

                        let currentContract = employeeIdContractMap[shift.employeeId] ? Object.values(employeeIdContractMap[shift.employeeId]).find(contract => {
                            if(shiftStart >= employeeContractMomentMap[contract.id].fromDate && (employeeContractMomentMap[contract.id].toDate == null || shiftStart < employeeContractMomentMap[contract.id].toDate)){
                                return true;
                            } else {
                                return false;
                            }
                        }) : null;

                        let workDays = currentContract ? currentContract.workDays : storeSettings.workDays;

                        this.calculateSpareTime(shift, shiftStart, shiftEnd, shiftMidnight, pastMidnight, shiftStartDay, dayMap, mapKey, isPreference, storeSettings, workDays);

                        let workValueData = null;
                        if (isActualShift || isPlanShift) {
                            //Check #2 , Worktime below threshhold

                            workValueData = this.calculateWorkValueData(shift, shiftStart, shiftEnd, isPlanShift, actualBreakShiftIdMap, actualBreakMomentMap, planShiftMomentMap, workDayCalcMode, storeSettings, helpers);

                            //Check Shift Overtime
                            if(!storeSettings.allowShiftOvertime && contractLimits != null){
                                if(workValueData.workValue > contractLimits.contract_overtimeCutoff){
                                    dayMap[mapKey].shiftOvertimeError = true;
                                }
                            }
                        } else if(isPreference){
                            workValueData = this.calculateWorkValueDataForPreference(employee, shift, shiftStart, shiftEnd, employeeIdContractMap, employeeContractMomentMap, storeSettings, employeeAvgWorktimeMap, workDayCalcMode);
                        }

                        this.calculateWorkValueForDayAndWeek(workValueData, weekWorktime, dayMap);

                        let finalDayTimeMax = contractLimits.contract_dayTimeMax;
                        if(pregnant){
                            if(storeSettings.country == 2){
                                finalDayTimeMax = Math.min(finalDayTimeMax, 8.5*60*60)
                            } else if(storeSettings.country == 1){
                                finalDayTimeMax = Math.min(finalDayTimeMax, 9*60*60)
                            } else {
                                finalDayTimeMax = Math.min(finalDayTimeMax, 8*60*60)
                            }
                        }
                        if(underageStats.rule && underageStats.rule.dayTimeMax){
                            finalDayTimeMax = Math.min(finalDayTimeMax, underageStats.rule.dayTimeMax*60)
                        }

                        if(isPastJune2023) {
                                /*
                                let dtWorkTime = 0;
                                let rangeFrom = shiftStart;
                                let rangeTo = rangeFrom.clone().add(24, 'hours');

                                for (let j = k; j < shifts.length; j++) {
                                    let nshift = shifts[j];

                                    let nshiftStart = null;
                                    let nshiftEnd = null;

                                    let isActualShift = false;
                                    let isPlanShift = false;
                                    let isPreference = false;
                                    if (actualShiftMomentMap[nshift.id]) {
                                        nshiftStart = actualShiftMomentMap[nshift.id].fromDate;
                                        nshiftEnd = actualShiftMomentMap[nshift.id].toDate;
                                        isActualShift = true;
                                    } else if (planShiftMomentMap[nshift.id]) {
                                        nshiftStart = planShiftMomentMap[nshift.id].fromDate;
                                        nshiftEnd = planShiftMomentMap[nshift.id].toDate;
                                        isPlanShift = true;
                                    } else if (splitPreferenceMomentMap[nshift.id]) {
                                        nshiftStart = splitPreferenceMomentMap[nshift.id].fromDate;
                                        nshiftEnd = splitPreferenceMomentMap[nshift.id].toDate;
                                        isPreference = true;
                                    }
                                    if(nshiftStart < rangeTo && nshiftStart >= rangeFrom){
                                        let dtwt = 0;
                                        if (isActualShift) {
                                            dtwt = this.calculateWorkTimeForShift(nshift, nshiftStart, nshiftEnd, rangeFrom, rangeTo, isPlanShift, actualBreakShiftIdMap, actualBreakMomentMap)
                                        } else if (isPlanShift) {
                                            dtwt = this.calculateWorkTimeForShift(nshift, nshiftStart, nshiftEnd, rangeFrom, rangeTo, isPlanShift, actualBreakShiftIdMap, actualBreakMomentMap)

                                        } else if(isPreference && nshiftStart.year() == rangeFrom.year() && nshiftStart.month() == rangeFrom.month() && nshiftStart.date() == rangeFrom.date()){ //only add worktime of a preference if it starts on same day
                                            dtwt = this.calculateWorkTimeForPreference(employee, nshift, nshiftStart, shiftEnd, rangeFrom, rangeTo, employeeIdContractMap, employeeContractMomentMap, storeSettings);
                                        }
                                        dtWorkTime += dtwt;

                                    } else {
                                        //since shifts are ordered we can stop when we find one that is no longer within the 24h range
                                        break;
                                    }


                                }

                                this.doDayTimeMaxChecksV2(dtWorkTime*60, pastMidnight, contractLimits, planTypeLimits, finalDayTimeMax, shiftEnd, dayMap, mapKey);
                                */
                            this.doDayTimeMaxChecks(pastMidnight, contractLimits, planTypeLimits, finalDayTimeMax, shiftEnd, dayMap, mapKey);
                        } else {
                             this.doDayTimeMaxChecks(pastMidnight, contractLimits, planTypeLimits, finalDayTimeMax, shiftEnd, dayMap, mapKey);
                        }

                        if (storeSettings.marketType === 2 &&
                            (shiftStart.day() === 6 || shiftStart.day() === 0)) {
                            let prefCountsAsWorktime = isPreference && (shift.alwaysWork || (shift.type != 4 && workDays.includes(shiftStart.day())));
                            if (!assignedWeekends[shiftStart.week()] && (isActualShift || isPlanShift || prefCountsAsWorktime)) {
                                assignedWeekends[shiftStart.week()] = mapKey;
                            }

                            if (Object.keys(assignedWeekends).length > 2) {
                                dayMap[mapKey].majorityOfWeekends = true;
                            }
                        }

                        let shiftStatus = shift.status;
                        if (shiftStatus != null && shiftStatus >= 3) {
                            dayMap[mapKey].shiftDeclinedError = shiftStatus;
                        }
                        if (shiftStatus != null && shiftStatus == 2) {
                            dayMap[mapKey].shiftEnforced = true;
                        }

                        if (workValueData != null && workValueData.workValue > 10 * 60 * 60) {
                            dayMap[mapKey].shiftLongerThanTenHours = true;
                        }

                        if (storeSettings.marketType === 2) { // Sozialwirtschaft Exceptions for 24 hour shifts
                            let currentWeek = shiftStart.clone().startOf('isoWeek');
                            if (startOfWeek == null) {
                                startOfWeek = currentWeek;
                            }
                            
                            if (startOfWeek < currentWeek) {
                                counter24HoursShifts = 0;
                                startOfWeek = currentWeek;
                            }
                            

                            if (counter24HoursShifts < 3 && dayMap[mapKey].shiftLongerThanTenHours) {
                                dayMap[mapKey].shiftError = false;
                                dayMap[mapKey].plan_dayError = false;
                                dayMap[mapKey].shiftLongerThanTenHours = false;
                                counter24HoursShifts++;
                            }
                        }
                    }
                } //Check END

                let plan_daysConsecutiveMax = planTypeLimits.planType_daysConsecutiveMax;
                let contract_daysConsecutiveMax = contractLimits.contract_daysConsecutiveMax;
                let planConsecutiveDays = {};
                let contractConsecutiveDays = {};
                if ((plan_daysConsecutiveMax != null && plan_daysConsecutiveMax > 0) || (contract_daysConsecutiveMax != null && contract_daysConsecutiveMax > 0)) {
                    
                    let start = null;
                    for (let k = 0; k < shifts.length; k++) {
                        let shift = shifts[k];
                        
                        this.doConsecutiveDaysCheck(start, shift, planConsecutiveDays, plan_daysConsecutiveMax, contractConsecutiveDays, contract_daysConsecutiveMax, dayMap,
                                actualShiftMomentMap, planShiftMomentMap, splitPreferenceMomentMap);
                        
                    }
                }

                let weekRestMap = this.calculateWeekRestMap(dayMap, employee, contractLimits, storeSettings, youthWorkRules, birthday);
                /*
                if(employee.id == 'b6066f60-686e-4118-8dd9-3613cd5e63f2'){
                    console.log(contractLimits)
                    console.log(weekRestMap)
                    console.log(youthWorkRules)
                } */


                for (let x in dayMap) {
                    let dayStart = this.getMomentFromStringTZ(x);
                    let weekStartKey = dayStart.clone().startOf('week').format("YYYY-MM-DD");
                    let pregnant = pregnantMap[weekStartKey] != null ? pregnantMap[weekStartKey] : false;

                    let weekKey = dayStart.isoWeek();
                    let underageStats = this.calculateUnderageStats(dayStart, birthday, youthWorkRules);
                    //Check week rest time
                    this.doWeekSpareTimeChecks(contractLimits, planTypeLimits, underageStats, weekRestMap, weekKey, dayMap, x, storeSettings);
                    //Check is worktime below 60h per week

                    this.doWeekMaxWorkTimeChecks(contractLimits, planTypeLimits, underageStats, pregnant, weekWorktime, weekKey, dayMap, x, storeSettings);
                }
            }
        }
        
        return dayMap;
    }

    calculateWeekWorkMap(employeeDateCombinedShiftMap, employeePreferenceAvailabilityMap, planShiftMomentMap, actualShiftMomentMap, actualBreakShiftIdMap, actualBreakMomentMap,  employeePreferenceMomentMap, employeeIdContractMap, employeeContractMomentMap, storeSettings, employeeMap, employeeAvgWorktimeMap, helpers){
        let map = {};
        Object.values(employeeMap).forEach(employee => {
            let shifts = this.getCombinedShiftsPreferencesArray(employee, employeeDateCombinedShiftMap, employeePreferenceAvailabilityMap, planShiftMomentMap, actualShiftMomentMap, employeePreferenceMomentMap);

            let weekWorktime = {};
            if (shifts != null && shifts != undefined && shifts.length > 0) {
                shifts.forEach(shift => {
                    let shiftStart = null;
                    let shiftEnd = null;

                    let isActualShift = false;
                    let isPlanShift = false;
                    let isPreference = false;
                    if (actualShiftMomentMap[shift.id]) {
                        shiftStart = actualShiftMomentMap[shift.id].fromDate;
                        shiftEnd = actualShiftMomentMap[shift.id].toDate;
                        isActualShift = true;
                    } else if (planShiftMomentMap[shift.id]) {
                        shiftStart = planShiftMomentMap[shift.id].fromDate;
                        shiftEnd = planShiftMomentMap[shift.id].toDate;
                        isPlanShift = true;
                    } else if (employeePreferenceMomentMap[shift.id]) {
                        shiftStart = employeePreferenceMomentMap[shift.id].fromDate;
                        shiftEnd = employeePreferenceMomentMap[shift.id].toDate;
                        isPreference = true;
                    }

                    let workValueData = null;
                    if (isActualShift) {
                        workValueData = this.calculateWorkValueData(shift, shiftStart, shiftEnd, isPlanShift, actualBreakShiftIdMap, actualBreakMomentMap, planShiftMomentMap, 2, storeSettings, helpers);

                        Object.keys(workValueData.weekWorkValues).forEach(key =>{
                            if(!weekWorktime[key]){
                                weekWorktime[key] = {weekId: key, combinedWorkTime: 0, planShiftWorkTime: 0, actualShiftWorkTime: 0, preferenceWorkTime: 0};
                            }
                            weekWorktime[key].combinedWorkTime += workValueData.weekWorkValues[key];
                            weekWorktime[key].actualShiftWorkTime += workValueData.weekWorkValues[key]
                        });
                    }else if (isPlanShift) {
                        workValueData = this.calculateWorkValueData(shift, shiftStart, shiftEnd, isPlanShift, actualBreakShiftIdMap, actualBreakMomentMap, planShiftMomentMap, 2, storeSettings, helpers);

                        Object.keys(workValueData.weekWorkValues).forEach(key =>{
                            if(!weekWorktime[key]){
                                weekWorktime[key] = {weekId: key,combinedWorkTime: 0, planShiftWorkTime: 0, actualShiftWorkTime: 0, preferenceWorkTime: 0};
                            }
                            weekWorktime[key].combinedWorkTime += workValueData.weekWorkValues[key];
                            weekWorktime[key].planShiftWorkTime += workValueData.weekWorkValues[key]
                        });
                    } else if(isPreference){
                        workValueData = this.calculateWorkValueDataForPreference(employee, shift, shiftStart, shiftEnd, employeeIdContractMap, employeeContractMomentMap, storeSettings, employeeAvgWorktimeMap);

                        Object.keys(workValueData.weekWorkValues).forEach(key =>{
                            if(!weekWorktime[key]){
                                weekWorktime[key] = {weekId: key,combinedWorkTime: 0, planShiftWorkTime: 0, actualShiftWorkTime: 0, preferenceWorkTime: 0};
                            }
                            weekWorktime[key].combinedWorkTime += workValueData.weekWorkValues[key];
                            weekWorktime[key].preferenceWorkTime += workValueData.weekWorkValues[key]
                        });
                    }

                })
            }
            map[employee.id] = weekWorktime;

        })
        return map;
    }


    getTimeFrameWorkTime(employee, timeFrom, timeTo, employeeDateCombinedShiftMap, employeePreferenceAvailabilityMap, planShiftMomentMap, actualShiftMomentMap, actualBreakShiftIdMap, actualBreakMomentMap,  employeePreferenceMomentMap, employeeIdContractMap, employeeContractMomentMap, storeSettings, employeeMap){
        let shifts = this.getCombinedShiftsPreferencesArray(employee, employeeDateCombinedShiftMap, employeePreferenceAvailabilityMap, planShiftMomentMap, actualShiftMomentMap, employeePreferenceMomentMap);

        let workTime = 0;
        if (shifts != null && shifts != undefined && shifts.length > 0) {
            shifts.forEach(shift => {
                let shiftStart = null;
                let shiftEnd = null;

                let isActualShift = false;
                let isPlanShift = false;
                let isPreference = false;
                if (actualShiftMomentMap[shift.id]) {
                    shiftStart = actualShiftMomentMap[shift.id].fromDate;
                    shiftEnd = actualShiftMomentMap[shift.id].toDate;
                    isActualShift = true;
                } else if (planShiftMomentMap[shift.id]) {
                    shiftStart = planShiftMomentMap[shift.id].fromDate;
                    shiftEnd = planShiftMomentMap[shift.id].toDate;
                    isPlanShift = true;
                } else if (employeePreferenceMomentMap[shift.id]) {
                    shiftStart = employeePreferenceMomentMap[shift.id].fromDate;
                    shiftEnd = employeePreferenceMomentMap[shift.id].toDate;
                    isPreference = true;
                }

                if (isActualShift) {
                    workTime += this.calculateWorkTimeForShift(shift, shiftStart, shiftEnd, timeFrom, timeTo, isPlanShift, actualBreakShiftIdMap, actualBreakMomentMap)
                } else if (isPlanShift) {
                    workTime += this.calculateWorkTimeForShift(shift, shiftStart, shiftEnd, timeFrom, timeTo, isPlanShift, actualBreakShiftIdMap, actualBreakMomentMap)

                } else if(isPreference){
                    workTime += this.calculateWorkTimeForPreference(employee, shift, shiftStart, shiftEnd, timeFrom, timeTo, employeeIdContractMap, employeeContractMomentMap, storeSettings);
                }

            })
        }
        return workTime;
    }

    getWeekWorkValueRegular(employeeId, employeeIdContractMap, employeeContractMomentMap, weekFrom, weekTo){
        let result = 0;
        if(employeeIdContractMap[employeeId]){
            Object.values(employeeIdContractMap[employeeId]).forEach(c => {
                let cFrom = employeeContractMomentMap[c.id].fromDate;
                let cTo = employeeContractMomentMap[c.id].toDate;

                if((cTo == null || cTo > weekFrom) && cFrom < weekTo){
                    let cBaseFrom = cFrom < weekFrom ? weekFrom : cFrom;
                    let cBaseTo = (cTo == null || cTo > weekTo) ? weekTo : cTo;

                    let baseDiff = weekTo.diff(weekFrom);
                    let cDiff = cBaseTo.diff(cBaseFrom);

                    let ratio = Math.min(1, Math.max(0, cDiff/baseDiff));
                    result += c.weekTimeRegular * ratio;
                }

            })
        }
        return Math.floor(result);

    }

    calculatePlannedActualMap(employeeMap, planShiftMap, planShiftMomentMap, actualShiftMomentMap, actualBreakShiftIdMap, actualBreakMomentMap, employeeDatePlannedShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, employeePreferenceAvailabilityMap, employeePreferenceMomentMap, customHolidayMap, employeeIdWorkBalanceMap, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, rosterVisibilityState, plannedActualCalculationSetting, storeSettings, employeeAvgWorktimeMap, helpers) {
        let view = this;
        let map = {};


        let rosterFrom = view.getMomentFromStringTZ(view.store.state.rosterFromTo.from);
        let rosterTo = view.getMomentFromStringTZ(view.store.state.rosterFromTo.to);


        //Precalculate the federal holidays this month, so we dont have to loop so often

        let holidayMap = {};
        for (let i in customHolidayMap) {
            for (let j = 0; j < customHolidayMap[i].length; j++) {
                let obj = customHolidayMap[i][j];
                let fromDate = view.getMomentFromStringTZ(obj.from)
                let key = fromDate.format("YYYY-MM-DD");
                if ((obj.federalHoliday || obj.bankHoliday || obj.contractHoliday) && obj.active) {
                    if(!holidayMap[key]) {
                        let toDate = view.getMomentFromStringTZ(obj.to)
                        holidayMap[key] = {
                            fromDate: fromDate,
                            toDate: toDate,
                            federalHoliday: obj.federalHoliday,
                            bankHoliday: obj.bankHoliday,
                            contractHoliday: obj.contractHoliday,
                        };
                    } else {
                        holidayMap[key].federalHoliday = holidayMap[key].federalHoliday || obj.federalHoliday;
                        holidayMap[key].bankHoliday = holidayMap[key].bankHoliday || obj.bankHoliday;
                        holidayMap[key].contractHoliday = holidayMap[key].contractHoliday || obj.contractHoliday;
                    }
                    
                }
            }
        }
        let federalHolidays = Object.values(holidayMap).filter(h => h.federalHoliday).map(h => h.fromDate);
        let includingContractHolidays = Object.values(holidayMap).filter(h => h.federalHoliday || h.contractHoliday).map(h => h.fromDate);

        let startOfMonth = rosterFrom.clone().add(14, 'days').startOf('month');
        let endOfMonth = rosterFrom.clone().add(14, 'days').endOf('month').add(7, 'days').startOf('month');


        let insideFrom = plannedActualCalculationSetting.fullMonth ? startOfMonth : plannedActualCalculationSetting.from;
        let insideTo = plannedActualCalculationSetting.fullMonth ? endOfMonth : plannedActualCalculationSetting.to.clone().add(1, 'days');


        let outsideFrom1 = startOfMonth;
        let outsideTo1 = plannedActualCalculationSetting.fullMonth ? startOfMonth : insideFrom;

        let outsideFrom2 = plannedActualCalculationSetting.fullMonth ? endOfMonth : insideTo;
        let outsideTo2 =  endOfMonth;


        for (let i in employeeMap) {
            let employee = employeeMap[i];

            map[employee.id] = this.calculatePlannedActualMapEntry(employee, rosterFrom, rosterTo, startOfMonth, endOfMonth, insideFrom, insideTo, outsideFrom1, outsideTo1, outsideFrom2, outsideTo2,
                federalHolidays, includingContractHolidays, holidayMap, planShiftMap, planShiftMomentMap, actualShiftMomentMap, actualBreakShiftIdMap, actualBreakMomentMap, employeeDatePlannedShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, employeePreferenceAvailabilityMap, employeePreferenceMomentMap, customHolidayMap, employeeIdWorkBalanceMap, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, rosterVisibilityState, plannedActualCalculationSetting, storeSettings, employeeAvgWorktimeMap, helpers);



        }

        return map;
    }

    calculatePlannedActualMapDelta(map, oldEmployeeId, newEmployeeId, employeeMap, planShiftMap, planShiftMomentMap, actualShiftMomentMap, actualBreakShiftIdMap, actualBreakMomentMap, employeeDatePlannedShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, employeePreferenceAvailabilityMap, employeePreferenceMomentMap, customHolidayMap, employeeIdWorkBalanceMap, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, rosterVisibilityState, plannedActualCalculationSetting, storeSettings, employeeAvgWorktimeMap, helpers) {
        let view = this;



        let rosterFrom = view.getMomentFromStringTZ(view.store.state.rosterFromTo.from);
        let rosterTo = view.getMomentFromStringTZ(view.store.state.rosterFromTo.to);


        //Precalculate the federal holidays this month, so we dont have to loop so often

        let holidayMap = {};
        for (let i in customHolidayMap) {
            for (let j = 0; j < customHolidayMap[i].length; j++) {
                let obj = customHolidayMap[i][j];
                let fromDate = view.getMomentFromStringTZ(obj.from)
                let key = fromDate.format("YYYY-MM-DD");
                if ((obj.federalHoliday || obj.bankHoliday || obj.contractHoliday) && obj.active) {
                    if(!holidayMap[key]) {
                        let toDate = view.getMomentFromStringTZ(obj.to)
                        holidayMap[key] = {
                            fromDate: fromDate,
                            toDate: toDate,
                            federalHoliday: obj.federalHoliday,
                            bankHoliday: obj.bankHoliday,
                            contractHoliday: obj.contractHoliday,
                        };
                    } else {
                        holidayMap[key].federalHoliday = holidayMap[key].federalHoliday || obj.federalHoliday;
                        holidayMap[key].bankHoliday = holidayMap[key].bankHoliday || obj.bankHoliday;
                        holidayMap[key].contractHoliday = holidayMap[key].contractHoliday || obj.contractHoliday;
                    }
                    
                }
            }
        }
        let federalHolidays = Object.values(holidayMap).filter(h => h.federalHoliday).map(h => h.fromDate);
        let includingContractHolidays = Object.values(holidayMap).filter(h => h.federalHoliday || h.contractHoliday).map(h => h.fromDate);

        let startOfMonth = rosterFrom.clone().add(14, 'days').startOf('month');
        let endOfMonth = rosterFrom.clone().add(14, 'days').endOf('month').add(7, 'days').startOf('month');


        let insideFrom = plannedActualCalculationSetting.fullMonth ? startOfMonth : plannedActualCalculationSetting.from;
        let insideTo = plannedActualCalculationSetting.fullMonth ? endOfMonth : plannedActualCalculationSetting.to.clone().add(1, 'days');


        let outsideFrom1 = startOfMonth;
        let outsideTo1 = plannedActualCalculationSetting.fullMonth ? startOfMonth : insideFrom;

        let outsideFrom2 = plannedActualCalculationSetting.fullMonth ? endOfMonth : insideTo;
        let outsideTo2 =  endOfMonth;

        if(oldEmployeeId != null){
            let employee = employeeMap[oldEmployeeId];
            map[employee.id] = this.calculatePlannedActualMapEntry(employee, rosterFrom, rosterTo, startOfMonth, endOfMonth, insideFrom, insideTo, outsideFrom1, outsideTo1, outsideFrom2, outsideTo2,
                federalHolidays, includingContractHolidays, holidayMap, planShiftMap, planShiftMomentMap, actualShiftMomentMap, actualBreakShiftIdMap, actualBreakMomentMap, employeeDatePlannedShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, employeePreferenceAvailabilityMap, employeePreferenceMomentMap, customHolidayMap, employeeIdWorkBalanceMap, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, rosterVisibilityState, plannedActualCalculationSetting, storeSettings, employeeAvgWorktimeMap, helpers);

        }

        if(newEmployeeId != null && newEmployeeId != oldEmployeeId){
            let employee = employeeMap[newEmployeeId];
            map[employee.id] = this.calculatePlannedActualMapEntry(employee, rosterFrom, rosterTo, startOfMonth, endOfMonth, insideFrom, insideTo, outsideFrom1, outsideTo1, outsideFrom2, outsideTo2,
                federalHolidays, includingContractHolidays, holidayMap, planShiftMap, planShiftMomentMap, actualShiftMomentMap, actualBreakShiftIdMap, actualBreakMomentMap, employeeDatePlannedShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, employeePreferenceAvailabilityMap, employeePreferenceMomentMap, customHolidayMap, employeeIdWorkBalanceMap, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, rosterVisibilityState, plannedActualCalculationSetting, storeSettings, employeeAvgWorktimeMap, helpers);

        }



        return map;
    }

    calculatePlannedActualMapEntry(employee, rosterFrom, rosterTo, startOfMonth, endOfMonth, insideFrom, insideTo, outsideFrom1, outsideTo1, outsideFrom2, outsideTo2,
                                   federalHolidays, includingContractHolidays, holidayMap, planShiftMap, planShiftMomentMap, actualShiftMomentMap, actualBreakShiftIdMap, actualBreakMomentMap, employeeDatePlannedShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, employeePreferenceAvailabilityMap, employeePreferenceMomentMap, customHolidayMap, employeeIdWorkBalanceMap, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, rosterVisibilityState, plannedActualCalculationSetting, storeSettings, employeeAvgWorktimeMap, helpers) {

        let calculatePastPlanning = rosterVisibilityState.calculatePastPlanning;
        let addHolidayTimeToWorkTime = rosterVisibilityState.addHolidayTimeToWorkTime;

        let mapTemplate = {};

        let rosterIter = rosterFrom.clone();

        while (rosterTo.diff(rosterIter) > 0) {


            let dateKey = rosterIter.format("YYYY-MM-DD");
            mapTemplate[dateKey] = {
                'shifts': [],
                'actualShifts': []
            };
            mapTemplate[dateKey].shifts = employeeDatePlannedShiftMap[employee.id][dateKey];
            mapTemplate[dateKey].actualShiftMarked = employeeDateActualShiftMarkedMap[employee.id][dateKey];
            mapTemplate[dateKey].actualShifts = employeeDateActualShiftMap[employee.id][dateKey];

            rosterIter.add(1, 'days');
        }


        let applyPlannedActualCalculationSetting = !plannedActualCalculationSetting.limitToEmployees || (plannedActualCalculationSetting.limitToEmployees && plannedActualCalculationSetting.employees.includes(employee.id));
        //THIS SHOULD ALWAYS CALCULATE THE REGULAR TIME
        let contracts = employeeIdContractMap ? (employeeIdContractMap[employee.id] ? employeeIdContractMap[employee.id] : []) : [];

        let cworktimeData = this.GetWorktimeData(startOfMonth, startOfMonth, endOfMonth, contracts, allowedContractMap, storeSettings, storeSettings.workTimeMode, null, storeSettings.exitFactoring, helpers, true, federalHolidays, includingContractHolidays)

        let contractWorkTime = cworktimeData['workTime'];
        let isGV = cworktimeData['isGV'];
        let unmodifiedPlannedWorkTime = Math.round(contractWorkTime) * 60 * 1000;
        let sollWorkTime = contractWorkTime * 60 * 1000;
        //-------

        //Determine lower and upper bound for ACTUAL / Ist Worktime calculation
        let lowerBound = startOfMonth;
        let upperBound = endOfMonth;
        if(!isGV && applyPlannedActualCalculationSetting && !plannedActualCalculationSetting.fullMonth && plannedActualCalculationSetting.saldoMode == 1){
            lowerBound = insideFrom;
            upperBound = insideTo;

        }



        if (!isGV && applyPlannedActualCalculationSetting) {

            let enforcedMonthAvgFactor = null;
            if(plannedActualCalculationSetting.workTimeMode == 0 && plannedActualCalculationSetting.enableWorkTimeFactorOverride){
                enforcedMonthAvgFactor = plannedActualCalculationSetting.enforcedWorkTimeFactor;
            }
            let insideRangeWorktimeData = this.GetWorktimeData(startOfMonth, insideFrom, insideTo, contracts, allowedContractMap, storeSettings, plannedActualCalculationSetting.workTimeMode, enforcedMonthAvgFactor, storeSettings.exitFactoring, helpers, true, federalHolidays, includingContractHolidays);
            let workTimeInsideRange = insideRangeWorktimeData['workTime'];
            if(plannedActualCalculationSetting.fullMonth){
                //insideRange == full month, so we don't need to calc time outside of range
                sollWorkTime = Math.round(workTimeInsideRange * (plannedActualCalculationSetting.contractPlannedPercentage / 100)) *60 *1000;
            } else {
                if(plannedActualCalculationSetting.saldoMode == 0){
                    //calculate for entire month => need to calculate the two out of range data
                    let outsideRangeWorktimeData1 = this.GetWorktimeData(startOfMonth, outsideFrom1, outsideTo1, contracts, allowedContractMap, storeSettings, storeSettings.workTimeMode, null, storeSettings.exitFactoring, helpers, true, federalHolidays, includingContractHolidays);
                    let workTimeOutsideRange1 = Math.max(0, outsideRangeWorktimeData1['workTime']);

                    let outsideRangeWorktimeData2 = this.GetWorktimeData(startOfMonth, outsideFrom2, outsideTo2, contracts, allowedContractMap, storeSettings, storeSettings.workTimeMode, null, storeSettings.exitFactoring, helpers, true, federalHolidays, includingContractHolidays);
                    let workTimeOutsideRange2 = Math.max(0, outsideRangeWorktimeData2['workTime']);

                    sollWorkTime = Math.round(workTimeOutsideRange1 + workTimeOutsideRange2 + workTimeInsideRange * (plannedActualCalculationSetting.contractPlannedPercentage / 100)) *60 *1000;
                } else {
                    //only inside range
                    sollWorkTime = Math.round(workTimeInsideRange * (plannedActualCalculationSetting.contractPlannedPercentage / 100)) *60 *1000;
                }
            }


        }

        let deltaWorkTime = 0;
        let unmodifiedDeltaWorkTime = 0;
        let deltaFtWorkTime = 0;
        let workbalance = employeeIdWorkBalanceMap[employee.id];

        if (workbalance) {
            unmodifiedDeltaWorkTime = workbalance.workTimeBalance * 60 * 1000;
            deltaWorkTime = unmodifiedDeltaWorkTime;
            if (applyPlannedActualCalculationSetting) {
                if (!plannedActualCalculationSetting.considerPreviousMonth) {
                    deltaWorkTime = 0;
                }
            }

            deltaFtWorkTime = workbalance.holidayTimeBalance * 60 * 1000;
        }



        let shifts = this.GetShiftsOnTimeframe(rosterFrom.clone(), (rosterTo.diff(rosterFrom)) / 3600000 / 24, mapTemplate, planShiftMomentMap, calculatePastPlanning);

        let untilNow = helpers.getMomentTZ().startOf('day');
        if(endOfMonth < untilNow){
            untilNow = endOfMonth;
        }

        let planTime = 0.0;
        let planTimeUntilNow = 0.0;
        let publishedPlanTime = 0.0;
        let istConfirmedTime = 0.0;
        let istUnconfirmedTime = 0.0;
        let istTimeUntilNow = 0.0; 

        let ftPlanTime = 0.0;
        let ftIstConfirmedTime = 0.0;
        let ftIstUnconfirmedTime = 0.0;
        let projectTimeMap =  {};

        for (let j in shifts) {

            let shift = shifts[j];

            if (shift.remoteId != null && shift.remoteId != undefined) {
                //Worktime actual Shift
                let aShiftFrom = actualShiftMomentMap[shift.id].fromDate;
                let aShiftTo = actualShiftMomentMap[shift.id].toDate
                let contract = contracts.find(c => {
                    let cFrom = employeeContractMomentMap[c.id].fromDate;
                    let cTo = employeeContractMomentMap[c.id].toDate;
                    return (cFrom < aShiftTo && (cTo == null || cTo > aShiftFrom));
                })

                let tmpWorktime = Math.max(0, (helpers.CalculateWorktime(aShiftFrom, aShiftTo, lowerBound, upperBound, this.CalculateBreakValueForActualShift(shift.id, aShiftFrom, aShiftTo, lowerBound, upperBound, actualBreakShiftIdMap, actualBreakMomentMap))));
                let untilNowWorktime = Math.max(0, (helpers.CalculateWorktime(aShiftFrom, aShiftTo, startOfMonth, untilNow, this.CalculateBreakValueForActualShift(shift.id, aShiftFrom, aShiftTo, startOfMonth, untilNow, actualBreakShiftIdMap, actualBreakMomentMap))));
                istTimeUntilNow += untilNowWorktime;

                (shift.confirmed) ? istConfirmedTime += tmpWorktime: istUnconfirmedTime += tmpWorktime;
                if(shift.projectId != null){
                    if(!projectTimeMap[shift.projectId]){
                        projectTimeMap[shift.projectId] = {id: shift.projectId, planned: 0, actual: 0}
                    }
                    projectTimeMap[shift.projectId].actual += tmpWorktime;
                }
                if(contract){
                    //Feiertagsstunden laut Ist
                    //keep track of holidays in case there's 2 on same day, in that case shift should only be counted once
                    let seenHolidays = [];
                    Object.values(holidayMap)
                    .filter(holiday => {
                        let holidayTypes = helpers.getHolidayTypesForStoreEvent(holiday);
                        let matchingTypes = contract.holidayTypes.filter(type => holidayTypes.includes(type));
                        return matchingTypes.length > 0 &&
                        holiday.fromDate < upperBound && holiday.toDate > lowerBound && aShiftFrom < holiday.toDate && aShiftTo > holiday.fromDate
                    })
                    .forEach(holiday => {

                        let holidayKey = holiday.fromDate.format("YYYY-MM-DD");
                        let holidayFrom = holiday.fromDate >= lowerBound ? holiday.fromDate : lowerBound;
                        let holidayTo = holiday.toDate <= upperBound ? holiday.toDate : upperBound;
                        if (!seenHolidays.includes(holidayKey)) {
                            if(storeSettings.useShiftStartForHolidayTime && aShiftFrom >= holidayFrom && aShiftFrom < holidayTo){
                                if(aShiftFrom >= holidayFrom && aShiftFrom < holidayTo) {
                                    let holidayBreakValue = this.CalculateBreakValueForActualShift(shift.id, aShiftFrom, aShiftTo, aShiftFrom, aShiftTo, actualBreakShiftIdMap, actualBreakMomentMap);
                                    let ftTmpWorktime = Math.max(0, (helpers.CalculateWorktime(aShiftFrom, aShiftTo, aShiftFrom, aShiftTo, holidayBreakValue)));
                                    let x_addWorktime = Math.min(tmpWorktime, ftTmpWorktime);

                                    (shift.confirmed) ? ftIstConfirmedTime += x_addWorktime: ftIstUnconfirmedTime += x_addWorktime;
                                    seenHolidays.push(holidayKey);
                                }
                                
                            } else {
                                let holidayBreakValue = this.CalculateBreakValueForActualShift(shift.id, aShiftFrom, aShiftTo, holidayFrom, holidayTo, actualBreakShiftIdMap, actualBreakMomentMap);
                                let ftTmpWorktime = Math.max(0, (helpers.CalculateWorktime(aShiftFrom, aShiftTo, holidayFrom, holidayTo, holidayBreakValue)));
                                let x_addWorktime = Math.min(tmpWorktime, ftTmpWorktime);

                                (shift.confirmed) ? ftIstConfirmedTime += x_addWorktime: ftIstUnconfirmedTime += x_addWorktime;
                                seenHolidays.push(holidayKey);
                            }
                        }
                    })
                }
                

            } else {
                //Worktime plan Shift
                let pShiftFrom = planShiftMomentMap[shift.id].fromDate;
                let pShiftTo = planShiftMomentMap[shift.id].toDate;
                let tmpWorktime = shift.workValue;
                let untilNowWorktime = shift.workValue;

                let contract = contracts.find(c => {
                    let cFrom = employeeContractMomentMap[c.id].fromDate;
                    let cTo = employeeContractMomentMap[c.id].toDate;
                    return (cFrom < pShiftTo && (cTo == null || cTo > pShiftFrom));
                })

                if (tmpWorktime == null || tmpWorktime <= -1) {
                    tmpWorktime = Math.max(0, (helpers.CalculateWorktime(pShiftFrom, pShiftTo, lowerBound, upperBound, this.CalculateBreakValueForPlanShift(shift.id, lowerBound, upperBound, planShiftMap, planShiftMomentMap))));
                    untilNowWorktime = Math.max(0, (helpers.CalculateWorktime(pShiftFrom, pShiftTo, startOfMonth, untilNow, this.CalculateBreakValueForPlanShift(shift.id, startOfMonth, untilNow, planShiftMap, planShiftMomentMap))));
                } else {
                    let percentage = Math.max(0, Math.max(0, (helpers.CalculateWorktime(pShiftFrom, pShiftTo, lowerBound, upperBound, 0))) / pShiftTo.diff(pShiftFrom));

                    tmpWorktime = tmpWorktime * 60 * 1000 * percentage;

                    let percentageUntilNow = Math.max(0, Math.max(0, (helpers.CalculateWorktime(pShiftFrom, pShiftTo, startOfMonth, untilNow, 0))) / pShiftTo.diff(pShiftFrom));
                    untilNowWorktime = tmpWorktime * percentageUntilNow;
                }
                planTime += (tmpWorktime * shift.workValueMultiplier);
                planTimeUntilNow += (untilNowWorktime * shift.workValueMultiplier);
                if(shift.published){
                    publishedPlanTime += (tmpWorktime * shift.workValueMultiplier);
                }

                if(shift.projectId != null){
                    if(!projectTimeMap[shift.projectId]){
                        projectTimeMap[shift.projectId] = {id: shift.projectId, planned: 0, actual: 0}
                    }
                    projectTimeMap[shift.projectId].planned += tmpWorktime;
                }
                if(contract){
                    let seenHolidays = [];
                    Object.values(holidayMap)
                    .filter(holiday => {
                        let holidayTypes = helpers.getHolidayTypesForStoreEvent(holiday);
                        let matchingTypes = contract.holidayTypes.filter(type => holidayTypes.includes(type));
                        return matchingTypes.length > 0 &&
                        holiday.fromDate < upperBound && holiday.toDate > lowerBound && pShiftFrom < holiday.toDate && pShiftTo > holiday.fromDate
                    })
                    .forEach(holiday => {

                        let holidayKey = holiday.fromDate.format("YYYY-MM-DD");
                        let holidayFrom = holiday.fromDate >= lowerBound ? holiday.fromDate : lowerBound;
                        let holidayTo = holiday.toDate <= upperBound ? holiday.toDate : upperBound;

                        if (!seenHolidays.includes(holidayKey)) {
                            //Feiertagsstunden laut Plan
                            if(storeSettings.useShiftStartForHolidayTime){
                                if(pShiftFrom >= holidayFrom && pShiftFrom < holidayTo) {
                                    let holidayBreakValue = this.CalculateBreakValueForPlanShift(shift.id, pShiftFrom, pShiftTo, planShiftMap, planShiftMomentMap);
                                    let ftTmpWorktime = shift.workValue;
                                    if (ftTmpWorktime == -1) ftTmpWorktime = Math.max(0, (helpers.CalculateWorktime(pShiftFrom, pShiftTo, pShiftFrom, pShiftTo, holidayBreakValue)));
                                    let x_addWorktime = Math.min(tmpWorktime, ftTmpWorktime);
                                    ftPlanTime += (x_addWorktime * shift.workValueMultiplier);
                                    seenHolidays.push(holidayKey);
                                }
                            } else {
                                let holidayBreakValue = this.CalculateBreakValueForPlanShift(shift.id, holidayFrom, holidayTo, planShiftMap, planShiftMomentMap);
                                let ftTmpWorktime = shift.workValue;
                                if (ftTmpWorktime == -1) ftTmpWorktime = Math.max(0, (helpers.CalculateWorktime(pShiftFrom, pShiftTo, holidayFrom, holidayTo, holidayBreakValue)));
                                let x_addWorktime = Math.min(tmpWorktime, ftTmpWorktime);
                                ftPlanTime += (x_addWorktime * shift.workValueMultiplier);
                                seenHolidays.push(holidayKey);
                            }
                        }
                    })
                }

            }
        }

        let urlaub = 0;
        let krankenstand = 0;
        let fta = 0;
        let pflegeurlaub = 0;
        let ausbildung = 0;
        let lfz = 0;
        let miscWorkTime = 0;

        employeePreferenceAvailabilityMap[employee.id].preferences.forEach(pref => {

            let diffAdd = this.GetEmployeePreferenceWorkTime(pref, employeePreferenceMomentMap, employee, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, lowerBound, upperBound, storeSettings, employeeAvgWorktimeMap);
            if (pref.state == 1 ) {
                switch (pref.type) {
                    case 1:
                        urlaub += diffAdd;
                        break;
                    case 2:
                        krankenstand += diffAdd;
                        break;
                    case 3:
                        fta += diffAdd;
                        break;
                    case 4:
                        miscWorkTime += diffAdd;
                        break;
                    case 6:
                        pflegeurlaub += diffAdd;
                        break;
                    case 7:
                        ausbildung += diffAdd;
                        break;
                    case 8:
                        lfz += diffAdd;
                        break;
                }
            }

            if(pref.state == 1 && pref.countsAsHoliday){
                let seenHolidays = [];
                let prefFrom = employeePreferenceMomentMap[pref.id].fromDate;
                let prefTo = employeePreferenceMomentMap[pref.id].toDate;

                let contract = contracts.find(c => {
                    let cFrom = employeeContractMomentMap[c.id].fromDate;
                    let cTo = employeeContractMomentMap[c.id].toDate;
                    return (cFrom < prefTo && (cTo == null || cTo > prefFrom));
                })

                if(contract){
                    Object.values(holidayMap)
                    .filter(holiday => {
                        let holidayTypes = helpers.getHolidayTypesForStoreEvent(holiday);
                        let matchingTypes = contract.holidayTypes.filter(type => holidayTypes.includes(type));
                        return matchingTypes.length > 0 &&
                        holiday.fromDate < upperBound && holiday.toDate > lowerBound && prefFrom < holiday.toDate && prefTo > holiday.fromDate
                    })
                    .forEach(holiday => {

                        let holidayKey = holiday.fromDate.format("YYYY-MM-DD");
                        let holidayFrom = holiday.fromDate >= lowerBound ? holiday.fromDate : lowerBound;
                        let holidayTo = holiday.toDate <= upperBound ? holiday.toDate : upperBound;
                        if (!seenHolidays.includes(holidayKey)) {
                                    //Feiertagsstunden laut Plan
                                    let holidayWorkTime = this.GetEmployeePreferenceWorkTime(pref, employeePreferenceMomentMap, employee, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, holidayFrom, holidayTo, storeSettings, employeeAvgWorktimeMap);

                                    ftIstConfirmedTime += (holidayWorkTime *60 * 1000);
                                    seenHolidays.push(holidayKey);


                        }
                    })
                }
                
            }


        });


        let sumSollWorkTime = sollWorkTime - deltaWorkTime;
        let sumWorkTimeProduktiv = planTime + istConfirmedTime + istUnconfirmedTime;
        let sumWorkTimeProduktivUntilNow = planTimeUntilNow + istTimeUntilNow;
        let sumWorkTimePublishedProduktiv = publishedPlanTime + istConfirmedTime + istUnconfirmedTime;
        let sumWorkTimeUnproduktiv = (urlaub + krankenstand + pflegeurlaub + ausbildung + lfz + fta + miscWorkTime) * 60 * 1000;
        fta = fta * 60 * 1000;
        let sumFtWorkTime = ftPlanTime + ftIstConfirmedTime + ftIstUnconfirmedTime - fta;
        let totalFtWorkTime = sumFtWorkTime + deltaFtWorkTime

        let totalWithoutHolidayWorkTime = sumWorkTimeProduktiv + sumWorkTimeUnproduktiv - sumSollWorkTime;
        let total = totalWithoutHolidayWorkTime
        if (addHolidayTimeToWorkTime && totalFtWorkTime > 0) {
            total += totalFtWorkTime;
        }
            /*
                                console.log();
                                console.log("total: " + (total/1000/3600));

                                console.log("sumSollWorkTime: " + (sumSollWorkTime/1000/3600));
                                console.log("sollWorkTime: " + (sollWorkTime/1000/3600));
                                console.log("deltaWorkTime: " + (deltaWorkTime/1000/3600));
                                console.log("deltaFtWorkTime: " + (deltaFtWorkTime/1000/3600));


                                console.log("sumWorkTimeProduktiv: " + (sumWorkTimeProduktiv/1000/3600));
                                console.log("planTime: " + (planTime/1000/3600));
                                console.log("istConfirmedTime: " + (istConfirmedTime/1000/3600));
                                console.log("istUnconfirmedTime: " + (istUnconfirmedTime/1000/3600));

                                console.log("sumFtWorkTime: " + (sumFtWorkTime/1000/3600));
                                console.log("ftPlanTime: " + (ftPlanTime/1000/3600));
                                console.log("ftIstConfirmedTime: " + (ftIstConfirmedTime/1000/3600));
                                console.log("ftIstUnconfirmedTime: " + (ftIstUnconfirmedTime/1000/3600));


                                console.log("urlaub: " + (urlaub/60));
                                console.log("krankenstand: " + (krankenstand/60));
                                console.log("pflegeurlaub: " + (pflegeurlaub/60));
                                console.log("ausbildung: " + (ausbildung/60));
                                console.log("lfz: " + (lfz/60));
            */

        return {
            'total': total,
            'totalWithoutHolidayWorkTime': totalWithoutHolidayWorkTime,
            'sollWorkTime': sollWorkTime,
            'unmodifiedPlannedWorkTime': unmodifiedPlannedWorkTime,
            'deltaWorkTime': deltaWorkTime,
            'unmodifiedDeltaWorkTime': unmodifiedDeltaWorkTime,
            'deltaFtWorkTime': deltaFtWorkTime,

            'planTime': planTime,
            'istConfirmedTime': istConfirmedTime,
            'istUnconfirmedTime': istUnconfirmedTime,

            'projectTimeMap': projectTimeMap,

            'ftPlanTime': ftPlanTime,
            'ftIstConfirmedTime': ftIstConfirmedTime,
            'ftIstUnconfirmedTime': ftIstUnconfirmedTime,
            'ftaTime': fta,

            'sumSollWorkTime': sumSollWorkTime,
            'sumWorkTimeProduktiv': sumWorkTimeProduktiv,
            'sumWorkTimePublishedProduktiv': sumWorkTimePublishedProduktiv,
            'sumWorkTimeProduktivUntilNow': sumWorkTimeProduktivUntilNow,
            'sumWorkTimeUnproduktiv': sumWorkTimeUnproduktiv,
            'sumFtWorkTime': sumFtWorkTime,

            'urlaub': (urlaub * 60 * 1000),
            'krankenstand': (krankenstand * 60 * 1000),
            'pflegeurlaub': (pflegeurlaub * 60 * 1000),
            'ausbildung': (ausbildung * 60 * 1000),
            'lfz': (lfz * 60 * 1000),
            'miscWorkTime': (miscWorkTime * 60 * 1000)

        };
    }

    GetEmployeePreferenceWorkTime(preference, preferenceMomentMap, employee, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, lowerBound, upperBound, storeSettings, employeeAvgWorktimeMap){
        let workValue = 0;
        let view = this;
        if (preference.state == 1 &&
            (preference.type == 1 ||
             preference.type == 2 ||
             preference.type == 3 ||
            (preference.type == 4 && preference.alwaysWork) ||
             preference.type == 6 ||
             preference.type == 7 ||
             preference.type == 8)) { // 1 = Urlaub , 2 = Krankenstand , 3 = FTA , 4 = Sonstiges, 6 = Pflegeurlaub , 7 = Ausbildung , 8 = LFZ

            let prefFrom = preferenceMomentMap[preference.id].fromDate;
            let prefTo = preferenceMomentMap[preference.id].toDate;

            let baseWorkValue = preference.workValue;


            let prefStart = prefFrom.clone();

            while (prefStart < prefTo) {

                //step through day, and check interval
                let endOfDay = prefStart.clone().add(1, 'days').startOf('day');
                let checkEnd = endOfDay < prefTo ? endOfDay : prefTo; //get tatsächliches Ende

                let dayWorktime = view.GetDayWorktimeFromContracts(employee, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, prefStart, checkEnd);
                if (employee.remoteId && employeeAvgWorktimeMap[employee.remoteId] && storeSettings.useAvgWorkTimeForPrefs) {
                    dayWorktime = employeeAvgWorktimeMap[employee.remoteId].averageMinutes;
                }
                let diff = checkEnd.diff(prefStart, 'minutes');

                let ratioFrom = (prefStart < lowerBound) ? lowerBound : ((prefStart > upperBound) ? upperBound : prefStart); // Liegt die Abwesenheit innerhalb des Monats, oder teilweise außerhalb?
                let ratioTo = (checkEnd > upperBound) ? upperBound : ((checkEnd < lowerBound) ? lowerBound : checkEnd);
                let ratio = ratioTo.diff(ratioFrom) / checkEnd.diff(prefStart); //Was ist der Anteil der Abwesenheit an diesem Monat

                let prefTime = Math.round(diff * ratio);
                if (prefTime > 0) {
                    let currentContract = employeeIdContractMap[preference.employeeId] ? Object.values(employeeIdContractMap[preference.employeeId]).find(contract => {
                        if(prefStart >= employeeContractMomentMap[contract.id].fromDate && (employeeContractMomentMap[contract.id].toDate == null || prefStart < employeeContractMomentMap[contract.id].toDate)){
                            return true;
                        } else {
                            return false;
                        }
                    }) : null;

                    let workDays = currentContract ? currentContract.workDays : storeSettings.workDays;
                    let countTowardsWorkTime = workDays.includes(prefStart.isoWeekday()); // IS WORKDAY CHECK

                    let tWorkValue = 0; //Calculation, how much time is this non availability worth
                    if (baseWorkValue > -1) {
                        //use preference.workValue instead of preference duration to determine workValue
                        //first determine the ratio that the current day interval has compared to entire preference length
                        let workValueRatio = ratioTo.diff(ratioFrom) / prefTo.diff(prefFrom);
                        tWorkValue = Math.round(baseWorkValue * workValueRatio);
                    } else {
                        if (prefTime > dayWorktime) {
                            tWorkValue += dayWorktime;
                        } else {
                            tWorkValue += prefTime;
                        }
                    }
                    if (countTowardsWorkTime || preference.alwaysWork) {
                        workValue += Math.max(0, tWorkValue);
                    }
                }
                prefStart = prefStart.add(1, 'days').startOf('day');
            }

        }
        return workValue;
    }

    GetWorktimeData(monthFrom, rangeFrom, rangeTo, employeeContracts, allowedContractMap, storeSettings, workTimeMode, enforcedMonthAvgFactor = null, exitFactoring, helpers, rounded = true, holidays = [], includingContractHolidays = []) {

        let monthTo = monthFrom.clone().endOf('month').add(1,'days').startOf('month');
        let trueRangeFrom = rangeFrom < monthFrom ? monthFrom : rangeFrom;
        let trueRangeTo = rangeTo > monthTo ? monthTo : rangeTo;


        let isGV = false;
        let workTimeRegular = 0;
        let contractDays = 0;
        let timeframes = [];

        let aliquoteBase = helpers.GetAliquoteBase(monthFrom, monthTo, employeeContracts, exitFactoring);
        let overlappingContracts = helpers.GetContractsOverlappingMonth(employeeContracts, trueRangeFrom, trueRangeTo);

        overlappingContracts.forEach(contract => {
            let holidaysToUse = holidays;
            if(contract.holidayTypes.includes(2)){
                holidaysToUse = includingContractHolidays;
            }
            let cwData = helpers.GetWorktimeForRangeWithinMonthFromContract(aliquoteBase, trueRangeFrom, trueRangeTo, contract, allowedContractMap, storeSettings, workTimeMode, true, enforcedMonthAvgFactor, holidaysToUse);
            if (cwData.workTimeRegular > 0) {
                isGV = contract.contractType == 3;
            }
            if(storeSettings.aliquoteWorkTime){
                workTimeRegular += cwData.workTimeRegular;
            } else {
                workTimeRegular = Math.max(workTimeRegular, cwData.workTimeRegular);
            }
            contractDays += cwData.contractDays;
            timeframes.push({
                'from': cwData.contractFrom,
                'to': cwData.contractTo,
                'workTimeRegular': cwData.workTimeRegular,
                'employeeId': contract.employeeId,
                'contractDays': cwData.contractDays,
                'aliquoteBase': cwData.aliquoteBase
            });
        });
        let result = {
            'workTime': rounded ? Math.round(workTimeRegular) : workTimeRegular,
            'isGV': isGV,
            'contractDays': contractDays,
            'aliquoteBase': aliquoteBase,
            'timeframes': timeframes
        };

        return result;

    }


    GetDayWorktimeFromContracts(employee, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, lower, upper) {
        //find contract
        let contracts = employeeIdContractMap[employee.id] ? employeeIdContractMap[employee.id] : [];
        let workTimeRegular = 0;
        let mainContract = null;
        let mainRatio = 0;
        contracts.forEach(contract => {
            let collectiveContract = null;
            if (contract.collectiveContractId) {
                collectiveContract = allowedContractMap[contract.collectiveContractId];
            }

            let contractFrom = employeeContractMomentMap[contract.id].fromDate;
            if (contractFrom < lower) contractFrom = lower;
            let contractTo = contract.to == null ? upper : employeeContractMomentMap[contract.id].toDate;
            if (contractTo > upper) contractTo = upper;
            let ratio = Math.max(0, contractTo.diff(contractFrom) / upper.diff(lower));

            if (ratio > mainRatio) {
                mainContract = contract;
            }
        });
        if (mainContract) {
            workTimeRegular = Math.round(mainContract.weekTimeRegular / mainContract.weekWorkDaysRegular);
        }

        return workTimeRegular;
    }
    CalculateBreakValueForActualShift(id, shiftFrom, shiftTo, lower, upper, actualBreakShiftIdMap, actualBreakMomentMap) {
        let view = this;
        if (!actualBreakShiftIdMap[id] || actualBreakShiftIdMap[id].length === 0) return 0;

        let breakTime = 0;
        actualBreakShiftIdMap[id].forEach(b => {
            let check = view.GetFromToCheckObject(actualBreakMomentMap[b.id].fromDate, actualBreakMomentMap[b.id].toDate, shiftFrom, shiftTo);
            if (check.isNonZeroDiff) {
                let from = check.from;
                let to = check.to;
                let lowerBound = from._d.getTime() < lower._d.getTime() ? lower : (from._d.getTime() > upper._d.getTime() ? upper : from);
                let upperBound = to._d.getTime() > upper._d.getTime() ? upper : (to._d.getTime() < lower._d.getTime() ? lower : to);
                if (lowerBound.utcOffset() != upperBound.utcOffset()) {
                    //upperBound = upperBound.clone().utcOffset(lowerBound.utcOffset(), true);
                }
                breakTime += Math.max(0, upperBound._d.getTime() - lowerBound._d.getTime());
            }

        });
        return breakTime;
    }
    CalculateBreakValueForPlanShift(id, lower, upper, planShiftMap, planShiftMomentMap) {
        if (!planShiftMap[id]) return 0;
        let shift = planShiftMap[id];
        let breakFrom = null;
        if (!shift.breakFrom) {
            let pShiftFrom = planShiftMomentMap[shift.id].fromDate;
            let pShiftTo = planShiftMomentMap[shift.id].toDate;
            breakFrom = pShiftFrom.clone().add(Math.round(pShiftTo.diff(pShiftFrom, 'minutes') / 2), 'minutes');
        } else {
            breakFrom = this.getMomentFromStringTZ(shift.breakFrom);
        }
        let breakTo = breakFrom.clone().add(shift.breakValue, 'minutes');
        let lowerBound = breakFrom._d.getTime() < lower._d.getTime() ? lower : (breakFrom._d.getTime() > upper._d.getTime() ? upper : breakFrom);
        let upperBound = breakTo._d.getTime() > upper._d.getTime() ? upper : (breakTo._d.getTime() < lower._d.getTime() ? lower : breakTo);
        if (lowerBound.utcOffset() != upperBound.utcOffset()) {
            //upperBound = upperBound.clone().utcOffset(lowerBound.utcOffset(), true);
        }
        let breakTime = Math.max(0, upperBound._d.getTime() - lowerBound._d.getTime());
        return breakTime;
    }

    GetShiftsOnTimeframe(start, days, mapTemplate, planShiftMomentMap, takeAll = true) {

        let z = [];
        let startToday = this.getMomentTZ().startOf('day');
        for (let i = 0; i < days; i++) {
            let tmpMoment = start.clone().add(i, 'days');
            let tmp = mapTemplate[tmpMoment.format('YYYY-MM-DD')];
            if (tmp != undefined && ((tmp.actualShifts != undefined && tmp.actualShifts.length > 0) || tmp.actualShiftMarked)) {
                if(tmp.actualShifts){
                    for (let x in tmp.actualShifts) {
                        z.push(tmp.actualShifts[x]);
                    }
                }

            } else if (tmp != undefined && tmp.shifts != undefined && tmp.shifts.length > 0) {
                for (let x in tmp.shifts) {
                    if (!takeAll) {


                        if (planShiftMomentMap[tmp.shifts[x].id].fromDate < startToday) {
                            continue;
                        }
                    }
                    z.push(tmp.shifts[x]);
                }
            }
        }
        return z;
    }

    GetPlannedHoursStatsMap(planShiftMap, planShiftMomentMap, publishedOnly = false){
        let map = {};
        Object.values(planShiftMap).forEach(shift => {
            if(shift.employeeId != null && (!publishedOnly || shift.published) && planShiftMomentMap[shift.id]){
                let shiftFrom = planShiftMomentMap[shift.id].fromDate;
                let shiftTo = planShiftMomentMap[shift.id].toDate
                let shiftHourStart = shiftFrom.clone().startOf('hour');
                let shiftHourEnd = shiftTo.minute() > 0 ? shiftTo.clone().add(1, 'hours').startOf('hour') : shiftTo;
                while(shiftHourStart < shiftHourEnd){
                    let low = shiftHourStart < shiftFrom ? shiftFrom : shiftHourStart;
                    let high = shiftHourStart.clone().add(1, 'hours');
                    if(high > shiftTo){
                        high = shiftTo;
                    }
                    let diff = Math.max(0, high.diff(low, 'minutes'));

                    let dateKey = shiftHourStart.format("DD-MM-YYYY");
                    if(!map[dateKey]){
                        map[dateKey] = {sum: 0, hours: {}, spots: {}};
                    }
                    let dateEntry = map[dateKey];
                    dateEntry.sum += diff;
                    if(!dateEntry.spots[shift.spotId]){
                        dateEntry.spots[shift.spotId] = 0;
                    }
                    dateEntry.spots[shift.spotId] += diff;

                    let hourKey = shiftHourStart.hour()+"";
                    if(!dateEntry.hours[hourKey]){
                        dateEntry.hours[hourKey] = {sum: 0, spots: {}}
                    }
                    let hourEntry = dateEntry.hours[hourKey];
                    hourEntry.sum += diff;
                    if(!hourEntry.spots[shift.spotId]){
                        hourEntry.spots[shift.spotId] = 0;
                    }
                    hourEntry.spots[shift.spotId] += diff;

                    shiftHourStart.add(1, 'hours');
                }
            }
        })

        return map;
    }

    fillWithTaskOverview(body, changes, employeeMap, entries, positioningTaskMap, tasksByEntryId) {
        changes.sort((a, b) => {
            let compare = a.time - b.time;
            if (compare !== 0) return compare;
            return (employeeMap[a.employeeId].lastName + ' ' + employeeMap[a.employeeId].firstName).localeCompare(employeeMap[b.employeeId].lastName + ' ' + employeeMap[b.employeeId].firstName);
        });

        let employeeCount = 0;
        let openShifts = [];
        changes.forEach(change => {
            let employee = employeeMap[change.employeeId];
            this.pushEntries(openShifts, body, change.spot, employeeMap, change);
            if (change.type === 'from') {
                openShifts[employee.id] = { from: change.time, arrivedAs: employeeCount, task: '' };
                employeeCount++;
            } else if (change.type === 'to') {
                delete (openShifts[employee.id]);
                employeeCount--;
            }
            this.assignEntries(entries, employeeCount, openShifts, tasksByEntryId)
        })
    }
    joinSuccessiveEntriesWithSameTask(body, data) {
        let joinedBody = [];
        let buffer = [];

        body.forEach(bodyPart => {
            let shift = buffer[bodyPart.employeeId];
            if (!shift) {
                buffer[bodyPart.employeeId] = bodyPart;
            } else {
                if (shift.to.format('HH:mm') === bodyPart.from.format('HH:mm') && shift.task === bodyPart.task) {
                    shift.to = bodyPart.to;
                    buffer[bodyPart.employeeId] = shift;
                } else {
                    this.pushBody(joinedBody, shift)
                    buffer[bodyPart.employeeId] = bodyPart;
                }
            }
        })

        Object.values(buffer).forEach(shift => this.pushBody(joinedBody, shift));

        joinedBody.sort((a, b) => {
            let compare = a.employee.localeCompare(b.employee);
            if (compare === 0) {
                compare = a.from.diff(b.from);
            }
            return compare;
        });

        return this.groupByEmployee(joinedBody, data);
    }
    groupByEmployee(body, data) {
        let employeeShifts = {};

        body.forEach(shift => {
            let mapEntry = employeeShifts[shift.employee];
            if (!mapEntry) {
                employeeShifts[shift.employee] = [];
            }
            employeeShifts[shift.employee].push(shift);
        })

        if (data.sortChronological) {
            employeeShifts = Object.values(employeeShifts).sort((a, b) => a[0].from.diff(b[0].from));
        }

        let groupedBody = [];
        for (let key in employeeShifts) {
            let index = 0;
            employeeShifts[key].forEach(shift => {
                let employeeName = '';
                if (index === 0) {
                    employeeName = shift.employee;
                }
                groupedBody.push([ employeeName, shift.from.format('HH:mm'), shift.to.format('HH:mm'), shift.spot.name, shift.task]);
                index++;
            })
        }

        return groupedBody;
    }
    pushBody(joinedBody, shift) {
        joinedBody.push({ employee: shift.employee, from: shift.from, to: shift.to, spot: shift.spot, task: shift.task})
    }
    pushEntries(openShifts, body, spot, employeeMap, change) {
        for (let employeeId in openShifts) {
            const from = openShifts[employeeId].from;
            const to = change.time;
            let task = openShifts[employeeId].task;
            if (task) {
                task = task.toString().replaceAll(",", ", ");
            }
            if (from.format('HH:mm') !== to.format('HH:mm')) {
                body.push({spot: spot, employee: employeeMap[employeeId].lastName + ' ' + employeeMap[employeeId].firstName, from: from, to: to, task: task, employeeId: employeeId})
            }

            openShifts[employeeId].from = change.time;
        }
    }
    assignEntries(entries, employeeCount, openShifts, tasksByEntryId) {
        if (!entries) return;

        let entryList = entries[employeeCount] ? entries[employeeCount] : Object.values(entries).filter(entry => entry.reduce((val) => val.employeeCount < employeeCount)).sort((a, b) => b.length - a.length)[0];

        if (!entryList) return;

        let entryCount = 0;
        
        for (let key in openShifts) {
            let entry = entryList[entryCount];
            if (entry) {
                let tasks = tasksByEntryId[entry.id];
                if (tasks) {
                    tasks = Object.values(tasks).sort((a, b) => {
                        if (a.main === b.main) return a.name.localeCompare(b.name);
                        if (a.main) return -1;
                        if (b.main) return 1;
                        return 0;
                    })
                    for (let key in tasks) {
                        tasks[key] = tasks[key].name;
                    }
                }
                openShifts[key].task = tasks;
            }
            entryCount++;
        }
    }
    entriesBySpotIds(positioningEntryMap) {
        let entriesBySpotIds = {};
        Object.values(positioningEntryMap).forEach(entry => {
            let entries = entriesBySpotIds[entry.spotId];
            if (!entries) {
                entries = {};
            }
            entriesBySpotIds[entry.spotId] = entries;

            let entriesForCount = entries[entry.employeeCount];
            if (!entriesForCount) {
                entriesForCount = []
            }
            entriesForCount.push(entry);
            entriesBySpotIds[entry.spotId][entry.employeeCount] = entriesForCount;
        });
        return entriesBySpotIds;
    }
    tasksByEntryId(positioningTaskMap, positioningTaskAssignmentMap) {
        let tasksByEntryId = {};
        Object.values(positioningTaskAssignmentMap).forEach(assignment => {
            if (!tasksByEntryId[assignment.entryId]) {
                tasksByEntryId[assignment.entryId] = [];
            }
            let task = positioningTaskMap[assignment.taskId];
            task.main = assignment.main;
            tasksByEntryId[assignment.entryId].push(task);
        });
        return tasksByEntryId;
    }
    changeBySpotId(planShiftMap, date, spotMap, data) {
        let changeBySpotId = {};
        Object.values(planShiftMap).filter(shift => shift.from.substring(0,10) === date.format('YYYY-MM-DD') && shift.employeeId && (!data.publishedOnly || shift.published)).forEach(shift => {
            let changes = changeBySpotId[shift.spotId];
            if (!changes) {
                changes = [];
            }
            changes.push({ time: shift.fromDate, employeeId: shift.employeeId, type: 'from', spot: spotMap[shift.spotId]});
            changes.push({ time: shift.toDate, employeeId: shift.employeeId, type: 'to', spot: spotMap[shift.spotId]});
            changeBySpotId[shift.spotId] = changes;
        })
        return changeBySpotId;
    }
    taskOverviewBody(spotMap, changeBySpotId, entriesBySpotIds, employeeMap, positioningTaskMap, tasksByEntryId) {
        let body = [];
        Object.values(spotMap).forEach(spot => {
            let changes = changeBySpotId[spot.id];
            let entries = entriesBySpotIds[spot.id];

            if (!changes) {
                return;
            }

            this.fillWithTaskOverview(body, changes, employeeMap, entries, positioningTaskMap, tasksByEntryId)
        })
        return body;
    }
    createBusinessUnit(name, view){
        let url = '/api/sec/businessunit';
        url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/businessunit');

        let payload = {
            storeId: view.$store.state.storeId,
            name: this.SanitizeInput(name),
            createWithSpotAndSkill: true,
        }

        axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+view.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            console.log(response);
            view.newBusinessUnitName = '';
            view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.comp.businessUnitAdded'));
            view.refresh();
        }).catch(function (error) {
            console.log(error);
        })
    }
    SanitizeInput(val) {
        val = val.replace(/[^A-Za-z0-9 \-]/g, '');
        if (val.length > 64) {
            val = val.substring(0, 64);
        }
        return val;
    }
}
